(function () {
  "use strict";

  var isUpdatingPrice = false;
  var isUpdatingDiscount = false;

  function getPriceContainer() {
    var selectors = [
      "#price-" +
        (document.querySelector('[id^="price-"]')?.id?.replace("price-", "") ||
          ""),
      '[id^="price-"]',
      ".product-price-container",
      ".price",
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function getOriginalPrice() {
    var priceContainer = getPriceContainer();
    if (!priceContainer) return null;
    var variantPrice = priceContainer.getAttribute("data-variant-price");
    if (variantPrice) {
      return parseInt(variantPrice);
    }
    var comparePriceEl = priceContainer.querySelector(
      ".price--compare .amount"
    );
    var regularPriceEl = priceContainer.querySelector(
      ".price ins .amount, .price .amount"
    );
    var priceText =
      (comparePriceEl || regularPriceEl)?.textContent?.trim() || "";
    var priceMatch = priceText.match(/[\d'.,]+/);
    if (priceMatch) {
      var cleanPrice = priceMatch[0].replace(/[']/g, "").replace(",", ".");
      var price = parseFloat(cleanPrice) * 100;
      if (price && !isNaN(price)) {
        return price;
      }
    }
    try {
      var productJson = document.querySelector(
        '[type="application/json"][data-product-json]'
      )?.textContent;
      if (productJson) {
        var productData = JSON.parse(productJson);
        var variant =
          productData.variants?.find(function (v) {
            return v.available;
          }) || productData.variants?.[0];
        if (variant) {
          return parseInt(variant.price);
        }
      }
    } catch (e) {}
    return null;
  }

  function updatePriceDataAttributes() {
    var priceContainer = getPriceContainer();
    if (!priceContainer) return;
    try {
      var variantSelects = document.querySelector("variant-selects");
      if (variantSelects && variantSelects.currentVariant) {
        var variant = variantSelects.currentVariant;
        if (variant) {
          priceContainer.setAttribute("data-variant-price", variant.price);
          priceContainer.setAttribute(
            "data-compare-at-price",
            variant.compare_at_price || variant.price
          );
          return;
        }
      }
      var productJson = document.querySelector(
        '[type="application/json"][data-product-json]'
      )?.textContent;
      if (productJson) {
        var productData = JSON.parse(productJson);
        var variantIdInput = document.querySelector('[name="id"]');
        var variantId = variantIdInput ? variantIdInput.value : null;
        var selectedVariant = null;
        if (variantId) {
          selectedVariant = productData.variants?.find(function (v) {
            return String(v.id) === String(variantId);
          });
        }
        if (!selectedVariant) {
          selectedVariant =
            productData.variants?.find(function (v) {
              return v.available;
            }) || productData.variants?.[0];
        }
        if (selectedVariant) {
          priceContainer.setAttribute(
            "data-variant-price",
            selectedVariant.price
          );
          priceContainer.setAttribute(
            "data-compare-at-price",
            selectedVariant.compare_at_price || selectedVariant.price
          );
        }
      }
    } catch (e) {}
  }

  function updatePrice(discount, originalPrice) {
    if (isUpdatingPrice) {
      return null;
    }
    isUpdatingPrice = true;
    var priceContainer = getPriceContainer();
    if (!priceContainer) {
      isUpdatingPrice = false;
      return null;
    }
    var variantPrice = parseInt(
      priceContainer.getAttribute("data-variant-price") || originalPrice
    );
    var compareAtPrice = parseInt(
      priceContainer.getAttribute("data-compare-at-price") || 0
    );
    if (!discount || !variantPrice) {
      var currencyCodeEnabled =
        window.currencyCodeEnabled !== undefined
          ? window.currencyCodeEnabled
          : true;
      var formattedPrice = window.formatMoney(
        variantPrice,
        currencyCodeEnabled
      );
      var formattedComparePrice = window.formatMoney(
        compareAtPrice,
        currencyCodeEnabled
      );
      var priceInsEl = priceContainer.querySelector(".price ins .amount");
      if (priceInsEl) {
        priceInsEl.textContent = formattedPrice;
      } else {
        var priceEl = priceContainer.querySelector(
          ".price .amount:not(.price--compare .amount)"
        );
        if (priceEl && !priceEl.closest(".price--compare")) {
          priceEl.textContent = formattedPrice;
        }
      }
      var comparePriceEl = priceContainer.querySelector(".price--compare");
      var priceInsElement = priceContainer.querySelector(".price ins");
      if (priceInsElement) {
        priceInsElement.classList.remove("price--discount");
      }
      if (comparePriceEl) {
        comparePriceEl.style.display = "none";
        comparePriceEl.remove();
      }
      var savingsEl = priceContainer.querySelector(
        ".product-form-saving-price .price"
      );
      if (savingsEl) {
        savingsEl.closest(".product-form-saving-price").style.display = "none";
      }
      isUpdatingPrice = false;
      return null;
    }
    var finalPrice = variantPrice;
    var savings = 0;
    var discountAmount = 0;
    if (discount.percentage && discount.percentage > 0) {
      discountAmount = Math.round(variantPrice * (discount.percentage / 100));
      finalPrice = variantPrice - discountAmount;
      savings = discountAmount;
    } else {
      finalPrice = variantPrice;
      savings = 0;
    }
    var currencyCodeEnabled =
      window.currencyCodeEnabled !== undefined
        ? window.currencyCodeEnabled
        : true;
    var formattedPrice = window.formatMoney(finalPrice, currencyCodeEnabled);
    var formattedSavings = window.formatMoney(savings, currencyCodeEnabled);
    var formattedDiscountAmount = window.formatMoney(
      discountAmount,
      currencyCodeEnabled
    );
    var priceInsEl = priceContainer.querySelector(".price ins .amount");
    if (priceInsEl) {
      priceInsEl.textContent = formattedPrice;
    } else {
      var priceEl = priceContainer.querySelector(
        ".price .amount:not(.price--compare .amount)"
      );
      if (priceEl && !priceEl.closest(".price--compare")) {
        priceEl.textContent = formattedPrice;
      }
    }
    var comparePriceEl = priceContainer.querySelector(".price--compare");
    var priceInsElement = priceContainer.querySelector(".price ins");
    if (comparePriceEl) {
      comparePriceEl.style.display = "none";
      comparePriceEl.remove();
    }
    if (priceInsElement) {
      priceInsElement.classList.add("price--discount");
    }
    var savingsEl = priceContainer.querySelector(
      ".product-form-saving-price .price"
    );
    if (savingsEl) {
      savingsEl.textContent = formattedSavings;
      savingsEl.closest(".product-form-saving-price").style.display =
        savings > 0 ? "block" : "none";
    }
    isUpdatingPrice = false;
    return {
      discountedPrice: finalPrice,
      savings: savings,
      discountAmount: discountAmount,
      formattedPrice: formattedPrice,
      formattedSavings: formattedSavings,
      formattedDiscountAmount: formattedDiscountAmount,
    };
  }

  function updateAppliedDiscount(discount, priceUpdate, retries) {
    retries = retries || 0;
    if (isUpdatingDiscount && retries === 0) return;
    isUpdatingDiscount = true;
    var appliedDiscountEl = document.getElementById("applied-discount");
    if (!appliedDiscountEl) {
      if (retries < 2) {
        isUpdatingDiscount = false;
        setTimeout(function () {
          updateAppliedDiscount(discount, priceUpdate, retries + 1);
        }, 100);
        return;
      }
      isUpdatingDiscount = false;
      return;
    }
    var appliedDiscountTextEl = document.getElementById(
      "applied-discount-text"
    );
    if (!appliedDiscountTextEl) {
      if (retries < 2) {
        isUpdatingDiscount = false;
        setTimeout(function () {
          updateAppliedDiscount(discount, priceUpdate, retries + 1);
        }, 100);
        return;
      }
      isUpdatingDiscount = false;
      return;
    }
    if (
      !discount ||
      !priceUpdate ||
      !priceUpdate.discountAmount ||
      priceUpdate.discountAmount <= 0
    ) {
      appliedDiscountEl.style.display = "none";
      isUpdatingDiscount = false;
      return;
    }
    var discountTitle = (discount.title || "").trim();
    var codeLabel = window.discountCodeLabel || "Code:";
    var activeText = window.discountActiveText || "Active";
    var newContent = codeLabel + " " + discountTitle + " - " + activeText;

    appliedDiscountTextEl.textContent = newContent;
    appliedDiscountEl.style.display = "flex";

    if (appliedDiscountTextEl.textContent !== newContent && retries < 2) {
      isUpdatingDiscount = false;
      setTimeout(function () {
        updateAppliedDiscount(discount, priceUpdate, retries + 1);
      }, 100);
      return;
    }
    isUpdatingDiscount = false;
  }

  function findDiscountByTitle(discounts, title) {
    if (!discounts || !Array.isArray(discounts) || !title) {
      return null;
    }
    var titleStr = (title || "").trim();
    if (!titleStr) {
      return null;
    }
    var titles = titleStr
      .split(",")
      .map(function (t) {
        return t.trim();
      })
      .filter(function (t) {
        return t.length > 0;
      });
    if (titles.length === 0) {
      return null;
    }
    var exactMatches = [];
    var titlesLower = titles.map(function (t) {
      return t.toLowerCase();
    });
    discounts.forEach(function (d) {
      var discountTitle = (d.title || d.code || "").trim();
      var discountTitleLower = discountTitle.toLowerCase();
      for (var i = 0; i < titlesLower.length; i++) {
        if (discountTitleLower === titlesLower[i]) {
          exactMatches.push(d);
          break;
        }
      }
    });
    if (exactMatches.length === 0) {
      return null;
    }
    if (exactMatches.length === 1) {
      return exactMatches[0];
    }
    var bestMatch = exactMatches[0];
    var bestPercentage = bestMatch.percentage || 0;
    for (var i = 1; i < exactMatches.length; i++) {
      var candidatePercentage = exactMatches[i].percentage || 0;
      if (candidatePercentage > bestPercentage) {
        bestMatch = exactMatches[i];
        bestPercentage = candidatePercentage;
      }
    }
    return bestMatch;
  }

  window.findDiscountByTitle = findDiscountByTitle;

  window.handleDiscountButtonClick = function (discountTitle, buttonElement) {
    if (!buttonElement) {
      return false;
    }

    document.querySelectorAll(".discount-button").forEach(function (btn) {
      btn.classList.remove("active");
    });
    buttonElement.classList.add("active");

    var discountsWrapper = document.querySelector(
      "[data-product-discounts-wrapper]"
    );
    if (!discountsWrapper) {
      return false;
    }
    var discountsScript = discountsWrapper.querySelector(
      'script[type="application/json"]'
    );
    if (!discountsScript) {
      return false;
    }
    var discountsData = discountsScript.textContent.trim();
    if (!discountsData) {
      return false;
    }

    var buttonNumber = null;
    if (buttonElement.id === "discount-button-1") {
      buttonNumber = 1;
    } else if (buttonElement.id === "discount-button-2") {
      buttonNumber = 2;
    }

    window.saveDiscountPreference(discountTitle);
    if (buttonNumber) {
      try {
        localStorage.setItem("assemblyPreference", String(buttonNumber));
      } catch (e) {
        console.error("[BUTTON] Error saving assembly preference:", e);
      }
    }

    applyDiscount(discountTitle, discountsData);

    return false;
  };

  function getActiveDiscountFromPage() {
    try {
      var activeButton = document.querySelector(".discount-button.active");
      if (activeButton) {
        var discountTitle =
          activeButton.getAttribute("data-discount-title") || "";
        if (discountTitle && discountTitle.trim() !== "") {
          return discountTitle.trim();
        }
      }
      return null;
    } catch (e) {
      console.error("[DEBUG] Error getting active discount from page:", e);
      return null;
    }
  }

  function getDiscountPreferenceWithPriority() {
    try {
      var lockedPreference = localStorage.getItem(
        "cartLockedDiscountPreference"
      );
      if (lockedPreference) {
        var buttonNumber = parseInt(lockedPreference, 10);

        var buttonMapping = window.getButtonDiscountMapping();
        if (buttonMapping) {
          var discountTitle =
            buttonNumber === 1 ? buttonMapping.button1 : buttonMapping.button2;
          if (discountTitle) {
            return discountTitle;
          }
        }
      }

      var assemblyPref = localStorage.getItem("assemblyPreference");
      if (assemblyPref) {
        var buttonNumber = parseInt(assemblyPref, 10);
        var buttonMapping = window.getButtonDiscountMapping();
        if (buttonMapping) {
          var discountTitle =
            buttonNumber === 1 ? buttonMapping.button1 : buttonMapping.button2;
          if (discountTitle) {
            return discountTitle;
          }
        }
      }

      var activeDiscountTitle = window.getDiscountPreference();
      if (activeDiscountTitle && activeDiscountTitle.trim() !== "") {
        return activeDiscountTitle.trim();
      }

      var pageDiscount = getActiveDiscountFromPage();
      if (pageDiscount) {
        return pageDiscount;
      }

      return "";
    } catch (e) {
      console.error("[BUTTON] Error in getDiscountPreferenceWithPriority:", e);
      return window.getDiscountPreference() || "";
    }
  }

  function getCurrentVariantPrice() {
    var priceContainer = getPriceContainer();
    if (priceContainer) {
      var dataPrice = priceContainer.getAttribute("data-variant-price");

      if (dataPrice) {
        var parsed = parseInt(dataPrice);

        return parsed;
      }
    }
    var variantSelects = document.querySelector("variant-selects");
    if (variantSelects && variantSelects.currentVariant) {
      var variant = variantSelects.currentVariant;

      if (variant && variant.price) {
        var parsed = parseInt(variant.price);

        return parsed;
      }
    }

    var originalPrice = getOriginalPrice();

    return originalPrice;
  }

  function resetToOriginalPrice() {
    var variantPrice = getCurrentVariantPrice();
    if (variantPrice) {
      updatePrice(null, variantPrice);
      updateAppliedDiscount(null);
    }
  }

  function removeDiscount(variantId) {
    try {
      if (!variantId) {
        var event = window.event || {};
        var target = event.target || event.currentTarget;
        if (target) {
          var removeBtn = target.closest(".discount-pill-remove");
          if (removeBtn) {
            var cartDrawerItem = removeBtn.closest(".mini_cart_item");
            if (cartDrawerItem) {
              variantId = cartDrawerItem.getAttribute("data-variant-id");
              if (!variantId) {
                var removeButton =
                  cartDrawerItem.querySelector(".remove[data-id]");
                if (removeButton) {
                  variantId = removeButton.getAttribute("data-id");
                }
              }
            } else {
              var cartPageRow = removeBtn.closest('tr[id^="CartItem-"]');
              if (cartPageRow) {
                var productId = cartPageRow.getAttribute("data-product-id");
                if (productId) {
                  var keyMatch = productId.match(/^(\d+)/);
                  if (keyMatch) {
                    variantId = keyMatch[1];
                  } else {
                    variantId = productId;
                  }
                }
              }
            }
          }
        }
      }
      if (!variantId) {
        console.warn(
          "[REMOVE-DISCOUNT] No variantId found, cannot remove discount"
        );
        return;
      }

      console.log(
        "[REMOVE-DISCOUNT] Removing discount for variantId:",
        variantId
      );

      try {
        var stored = localStorage.getItem("variantDiscounts");
        if (stored) {
          var variantDiscounts = JSON.parse(stored);
          if (variantDiscounts[variantId]) {
            delete variantDiscounts[variantId];
            localStorage.setItem(
              "variantDiscounts",
              JSON.stringify(variantDiscounts)
            );
            console.log(
              "[REMOVE-DISCOUNT] Removed discount from localStorage for variant:",
              variantId
            );
          }
        }
      } catch (e) {
        console.error("[REMOVE-DISCOUNT] Error removing variant discount:", e);
      }
      if (variantId) {
        var cartDrawerItem = document.querySelector(
          '.mini_cart_item[data-variant-id="' +
            variantId +
            '"], #CartDrawerItem-' +
            variantId
        );
        if (cartDrawerItem) {
          var drawerPill = cartDrawerItem.querySelector(
            "#applied-discount-cart-drawer"
          );
          if (drawerPill) {
            drawerPill.remove();
          }
          var shopifyPills = cartDrawerItem.querySelectorAll(
            ".custom-discount-pill"
          );
          if (shopifyPills.length > 0) {
            shopifyPills.forEach(function (pill) {
              pill.remove();
            });
          }
          var priceSpan = cartDrawerItem.querySelector(".price");
          if (priceSpan) {
            var originalCents = 0;

            var quantity = 1;
            var qtyText = cartDrawerItem.querySelector(".mini-quantity");
            if (qtyText) {
              var qtyMatch = qtyText.textContent.match(/\d+/);
              if (qtyMatch) {
                quantity = parseInt(qtyMatch[0]);
              }
            }

            var dataOriginalPrice = cartDrawerItem.getAttribute(
              "data-original-price"
            );
            if (dataOriginalPrice) {
              originalCents = parseInt(dataOriginalPrice);
              console.log(
                "[REMOVE-DISCOUNT] Got price from data-original-price:",
                originalCents
              );
            }

            if (originalCents === 0 || isNaN(originalCents)) {
              var delPrice = priceSpan.querySelector("del .amount");
              if (delPrice) {
                var originalPriceText = delPrice.textContent.trim();
                originalCents = window.parseMoneyTextToCents(originalPriceText);
                console.log(
                  "[REMOVE-DISCOUNT] Got price from del element:",
                  originalCents
                );
              }
            }

            if ((originalCents === 0 || isNaN(originalCents)) && quantity > 0) {
              var dataOriginalLinePrice = cartDrawerItem.getAttribute(
                "data-original-line-price"
              );
              if (dataOriginalLinePrice) {
                var linePriceCents = parseInt(dataOriginalLinePrice);
                if (linePriceCents > 0 && quantity > 0) {
                  originalCents = Math.round(linePriceCents / quantity);
                  console.log(
                    "[REMOVE-DISCOUNT] Got price from data-original-line-price:",
                    originalCents
                  );
                }
              }
            }

            if (originalCents === 0 || isNaN(originalCents)) {
              var currentAmount = priceSpan.querySelector(".amount");
              if (currentAmount && !priceSpan.querySelector("del")) {
                var currentPriceText = currentAmount.textContent.trim();
                originalCents = window.parseMoneyTextToCents(currentPriceText);
                console.log(
                  "[REMOVE-DISCOUNT] Got price from current amount:",
                  originalCents
                );
              }
            }

            if (originalCents > 0 && !isNaN(originalCents)) {
              var currencyCodeEnabled =
                window.currencyCodeEnabled !== undefined
                  ? window.currencyCodeEnabled
                  : true;
              var formattedPrice = window.formatMoney(
                originalCents,
                currencyCodeEnabled
              );
              priceSpan.innerHTML =
                '<span class="mini-quantity">' +
                quantity +
                " ×</span> " +
                '<span class="amount">' +
                formattedPrice +
                "</span>";
              console.log("[REMOVE-DISCOUNT] Reset cart drawer price:", {
                variantId: variantId,
                originalCents: originalCents,
                formattedPrice: formattedPrice,
                quantity: quantity,
              });
            } else {
              console.warn(
                "[REMOVE-DISCOUNT] Could not determine original price for cart drawer item:",
                {
                  variantId: variantId,
                  dataOriginalPrice: dataOriginalPrice,
                  hasDel: !!priceSpan.querySelector("del .amount"),
                  hasCurrentAmount: !!priceSpan.querySelector(".amount"),
                }
              );
            }
          }
        }
        var cartPageRow = document.querySelector(
          'tr[id^="CartItem-"][data-product-id*="' + variantId + '"]'
        );
        if (cartPageRow) {
          var cartPagePill = cartPageRow.querySelector(
            "#applied-discount-cart-page"
          );
          if (cartPagePill) {
            cartPagePill.remove();
          }
          var cartPageMobilePill = cartPageRow.querySelector(
            "#applied-discount-cart-page-mobile"
          );
          if (cartPageMobilePill) {
            cartPageMobilePill.remove();
          }
          var shopifyPills = cartPageRow.querySelectorAll(
            ".discounts__discount"
          );
          if (shopifyPills.length > 0) {
            shopifyPills.forEach(function (pill) {
              pill.remove();
            });
          }
          var priceCell = cartPageRow.querySelector(
            ".product-price, .cart-item__price"
          );
          if (priceCell) {
            var unitPriceSpan = priceCell.querySelector(".price");
            if (unitPriceSpan) {
              var originalCents = 0;
              var delAmount = unitPriceSpan.querySelector("del .amount");
              if (delAmount) {
                var originalPriceText = delAmount.textContent.trim();
                originalCents = window.parseMoneyTextToCents(originalPriceText);
              } else {
                var dataPrice = priceCell.getAttribute("data-price");
                if (dataPrice) {
                  originalCents = parseInt(dataPrice);
                }
              }
              if (originalCents > 0) {
                var currencyCodeEnabled =
                  window.currencyCodeEnabled !== undefined
                    ? window.currencyCodeEnabled
                    : true;
                var formattedPrice = window.formatMoney(
                  originalCents,
                  currencyCodeEnabled
                );
                var quantity = 1;
                var qtyInput = cartPageRow.querySelector(
                  'input[name="updates[]"]'
                );
                if (qtyInput) {
                  quantity = parseInt(qtyInput.value || "1");
                }
                var lineTotalCents = originalCents * quantity;
                var formattedLineTotal = window.formatMoney(
                  lineTotalCents,
                  currencyCodeEnabled
                );
                var delPrice = unitPriceSpan.querySelector("del");
                var insPrice = unitPriceSpan.querySelector("ins");
                if (delPrice) delPrice.remove();
                if (insPrice) insPrice.remove();
                unitPriceSpan.innerHTML =
                  '<span class="amount">' + formattedPrice + "</span>";
                var subtotalCell = cartPageRow.querySelector(
                  ".product-subtotal, .cart-item__totals"
                );
                if (subtotalCell) {
                  var subtotalPriceSpan = subtotalCell.querySelector(".price");
                  if (subtotalPriceSpan) {
                    var subtotalDel = subtotalPriceSpan.querySelector("del");
                    var subtotalDelAmount = subtotalDel
                      ? subtotalDel.querySelector(".amount")
                      : null;
                    var originalLinePrice = 0;
                    if (subtotalDelAmount) {
                      var originalLineText =
                        subtotalDelAmount.textContent.trim();
                      originalLinePrice =
                        window.parseMoneyTextToCents(originalLineText);
                    } else {
                      var dataSubtotal =
                        subtotalCell.getAttribute("data-subtotal");
                      if (dataSubtotal) {
                        originalLinePrice = parseInt(dataSubtotal);
                      }
                    }
                    if (originalLinePrice > 0) {
                      var formattedOriginalLineTotal = window.formatMoney(
                        originalLinePrice,
                        currencyCodeEnabled
                      );
                      var subtotalIns = subtotalPriceSpan.querySelector("ins");
                      if (subtotalDel) subtotalDel.remove();
                      if (subtotalIns) subtotalIns.remove();
                      subtotalPriceSpan.innerHTML =
                        '<span class="amount">' +
                        formattedOriginalLineTotal +
                        "</span>";
                    } else {
                      var subtotalDel = subtotalPriceSpan.querySelector("del");
                      var subtotalIns = subtotalPriceSpan.querySelector("ins");
                      if (subtotalDel) subtotalDel.remove();
                      if (subtotalIns) subtotalIns.remove();
                      subtotalPriceSpan.innerHTML =
                        '<span class="amount">' +
                        formattedLineTotal +
                        "</span>";
                    }
                  }
                }
              }
            }
          }
        }
      } else {
        var drawerPill = document.getElementById(
          "applied-discount-cart-drawer"
        );
        if (drawerPill) {
          drawerPill.remove();
        }
        var cartPagePill = document.getElementById(
          "applied-discount-cart-page"
        );
        if (cartPagePill) {
          cartPagePill.remove();
        }
        var cartPageMobilePill = document.getElementById(
          "applied-discount-cart-page-mobile"
        );
        if (cartPageMobilePill) {
          cartPageMobilePill.remove();
        }
      }
      try {
        var stored = localStorage.getItem("variantDiscounts");
        var hasAnyDiscounts = false;
        if (stored) {
          var variantDiscounts = JSON.parse(stored);
          hasAnyDiscounts = Object.keys(variantDiscounts).length > 0;
        }

        if (!hasAnyDiscounts) {
          localStorage.removeItem("cartLockedDiscountPreference");
          console.log(
            "[REMOVE-DISCOUNT] All discounts removed, cleared cartLockedDiscountPreference"
          );
        }
      } catch (e) {
        console.error(
          "[REMOVE-DISCOUNT] Error checking if all discounts removed:",
          e
        );
      }

      setTimeout(function () {
        if (typeof window.recomputeDrawerSubtotalFromDOM === "function") {
          window.recomputeDrawerSubtotalFromDOM();
        }
        if (typeof window.recomputeCartPageSubtotalFromDOM === "function") {
          window.recomputeCartPageSubtotalFromDOM();
        }
        try {
          if (typeof setupCheckoutDiscountRedirects === "function") {
            setupCheckoutDiscountRedirects();
          }
        } catch (e) {
          console.error("[REMOVE-DISCOUNT] Error updating checkout URLs:", e);
        }
      }, 100);

      console.log(
        "[REMOVE-DISCOUNT] ✅ Successfully removed discount for variant:",
        variantId
      );
    } catch (e) {
      console.error("[DISCOUNT] Error removing discount:", e);
    }
  }

  window.removeDiscount = removeDiscount;

  function applyDiscount(discountTitle, discountsData) {
    if (!discountTitle || discountTitle.trim() === "") {
      resetToOriginalPrice();
      return;
    }
    var discounts = null;
    try {
      discounts =
        typeof discountsData === "string"
          ? JSON.parse(discountsData.trim())
          : discountsData;
    } catch (e) {
      console.error("[DISCOUNT] Error parsing discounts:", e);
      return;
    }
    var discount = null;
    if (discounts && Array.isArray(discounts)) {
      discount = discounts.find(function (d) {
        return d.title === discountTitle.trim();
      });
    }
    if (!discount) {
      resetToOriginalPrice();
      return;
    }
    var variantPrice = getCurrentVariantPrice();

    if (!variantPrice) {
      console.error("[DISCOUNT] Could not get variant price");
      return;
    }
    if (!discount.percentage || discount.percentage <= 0) {
      resetToOriginalPrice();
      return;
    }

    var priceUpdate = updatePrice(discount, variantPrice);

    updateAppliedDiscount(discount, priceUpdate);

    return discount;
  }

  function applyActiveDiscount() {
    if (isUpdatingPrice) {
      return;
    }
    updatePriceDataAttributes();
    var discountButtonsContainer = document.querySelector(
      "[data-product-discounts-wrapper] .discount-buttons"
    );
    var activeButton = discountButtonsContainer?.querySelector(
      ".discount-button.active"
    );
    var discountsScript = document.querySelector(
      '[data-product-discounts-wrapper] script[type="application/json"]'
    );
    if (activeButton && discountsScript) {
      var discountTitle = activeButton.getAttribute("data-discount-title");
      if (discountTitle) {
        var discountsData = discountsScript.textContent.trim();
        applyDiscount(discountTitle, discountsData);
      }
    } else {
      var variantPrice = getCurrentVariantPrice();
      if (variantPrice) {
        updatePrice(null, variantPrice);
        updateAppliedDiscount(null, null);
      }
    }
  }

  function interceptShopifyPriceUpdate() {
    var variantSelects = document.querySelector("variant-selects");
    if (!variantSelects) return;
    if (!variantSelects._originalRenderProductInfo) {
      variantSelects._originalRenderProductInfo =
        variantSelects.renderProductInfo;
    }
    variantSelects.renderProductInfo = function () {
      var sections = this.getSectionsToRender();
      var activeDiscount = document.querySelector(".discount-button.active");
      var discountTitle = activeDiscount
        ? activeDiscount.getAttribute("data-discount-title")
        : null;
      if (!activeDiscount || !discountTitle || discountTitle.trim() === "") {
        variantSelects._originalRenderProductInfo.call(this);
        var delays = [200, 400, 600];
        delays.forEach(function (delay) {
          setTimeout(function () {
            if (!isUpdatingPrice) {
              updatePriceDataAttributes();
            }
          }, delay);
        });
        return;
      }
      fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      )
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) {
              var isPriceSection = id && id.indexOf("price-") === 0;
              if (!isPriceSection) {
                destination.innerHTML = source.innerHTML;
              }
            }
            const price = document.getElementById(id);
            if (price) price.classList.remove("visibility-hidden");
          });
          this.toggleAddButton(
            !this.currentVariant.available,
            window.theme.variantStrings.soldOut
          );
          setTimeout(function () {
            if (!isUpdatingPrice) {
              updatePriceDataAttributes();
              applyActiveDiscount();
            }
          }, 100);
        });
    };
  }

  function handleVariantChange(event) {
    if (isUpdatingPrice) return;
    var activeDiscount = document.querySelector(".discount-button.active");
    var discountTitle = activeDiscount
      ? activeDiscount.getAttribute("data-discount-title")
      : null;
    if (!activeDiscount || !discountTitle || discountTitle.trim() === "") {
      updateAppliedDiscount(null, null);
      return;
    }
    setTimeout(function () {
      if (!isUpdatingPrice) {
        updatePriceDataAttributes();
        applyActiveDiscount();
      }
    }, 300);
  }

  function initializeInterception() {
    var variantSelects = document.querySelector("variant-selects");
    if (variantSelects) {
      interceptShopifyPriceUpdate();
    } else {
      setTimeout(initializeInterception, 100);
    }
  }

  function applyPreferenceOnProductPage() {
    try {
      var wrapper = document.querySelector("[data-product-discounts-wrapper]");
      if (!wrapper) {
        return;
      }

      var pref = null;
      var buttonNumber = null;
      var useLockedPreference = false;

      try {
        var lockedPreference = localStorage.getItem(
          "cartLockedDiscountPreference"
        );
        if (lockedPreference) {
          buttonNumber = parseInt(lockedPreference, 10);
          useLockedPreference = true;
        }
      } catch (e) {
        console.error(
          "[BUTTON] Error checking cartLockedDiscountPreference:",
          e
        );
      }

      if (!buttonNumber) {
        try {
          var assemblyPref = localStorage.getItem("assemblyPreference");
          if (assemblyPref) {
            buttonNumber = parseInt(assemblyPref, 10);
            useLockedPreference = false;
          }
        } catch (e) {
          console.error("[BUTTON] Error checking assemblyPreference:", e);
        }
      }

      if (!buttonNumber) {
        pref = window.getDiscountPreference();
      }

      var buttons = wrapper.querySelectorAll(".discount-button");
      if (!buttons || !buttons.length) {
        return;
      }
      var targetBtn = null;
      if (window.hasNoDiscountPreference() && !buttonNumber) {
        buttons.forEach(function (btn, index) {
          var title = btn.getAttribute("data-discount-title") || "";
          if (!targetBtn) {
            if (btn.id === "discount-button-2") {
              targetBtn = btn;
            }
          }
        });
        if (!targetBtn && buttons.length >= 2) {
          if (buttons[1] && buttons[1].id === "discount-button-2") {
            targetBtn = buttons[1];
          }
        }
        if (targetBtn) {
          document.querySelectorAll(".discount-button").forEach(function (btn) {
            btn.classList.remove("active");
          });
          targetBtn.classList.add("active");
          resetToOriginalPrice();
          var productPill = document.getElementById("applied-discount");
          if (productPill) {
            productPill.style.display = "none";
          }
        }
        return;
      }

      if (buttonNumber && (buttonNumber === 1 || buttonNumber === 2)) {
        var targetButtonId =
          buttonNumber === 1 ? "discount-button-1" : "discount-button-2";
        targetBtn = wrapper.querySelector("#" + targetButtonId);
        if (targetBtn) {
          var buttonTitle = targetBtn.getAttribute("data-discount-title");
          if (buttonTitle) {
            pref = buttonTitle;
          }
        } else {
          console.error(
            "[BUTTON] Target button not found:",
            targetButtonId,
            "buttonNumber:",
            buttonNumber,
            "useLockedPreference:",
            useLockedPreference
          );
        }
      } else if (pref) {
        buttons.forEach(function (btn) {
          try {
            var title = btn.getAttribute("data-discount-title") || "";
            if (!targetBtn && title && title.trim() !== "") {
              var prefLower = pref.toLowerCase();
              var titleLower = title.trim().toLowerCase();
              if (prefLower === titleLower) {
                targetBtn = btn;
              }
            }
          } catch (e) {
            console.error(
              "[DEBUG] Error processing button in applyPreferenceOnProductPage:",
              e
            );
          }
        });
      }

      if (!targetBtn && !useLockedPreference) {
        var discountButtonsContainer =
          wrapper.querySelector(".discount-buttons");
        if (discountButtonsContainer) {
          var initialDiscount = discountButtonsContainer.getAttribute(
            "data-initial-discount"
          );
          if (initialDiscount && initialDiscount.trim() !== "") {
            buttons.forEach(function (btn) {
              var title = btn.getAttribute("data-discount-title") || "";
              if (
                !targetBtn &&
                title &&
                title.trim() === initialDiscount.trim()
              ) {
                targetBtn = btn;
              }
            });
          }
        }

        if (!targetBtn) {
          var existingActive = wrapper.querySelector(".discount-button.active");
          var hasSavedPreference =
            window.getDiscountPreference() ||
            localStorage.getItem("assemblyPreference");

          if (existingActive && !hasSavedPreference) {
            targetBtn = existingActive;
          }
        }
      }
      if (!targetBtn) {
        return;
      }
      var discountsScript = wrapper.querySelector(
        'script[type="application/json"]'
      );
      if (!discountsScript) {
        console.error("[DEBUG] Discounts script not found");
        return;
      }
      try {
        var discountsData = discountsScript.textContent.trim();
        var buttonMappingFromDOM = null;
        var button1 = wrapper.querySelector("#discount-button-1");
        var button2 = wrapper.querySelector("#discount-button-2");
        if (button1 && button2) {
          var button1Title = button1.getAttribute("data-discount-title");
          var button2Title = button2.getAttribute("data-discount-title");
          if (button1Title && button2Title) {
            buttonMappingFromDOM = {
              button1: button1Title,
              button2: button2Title,
            };
            try {
              localStorage.setItem(
                "buttonDiscountMapping",
                JSON.stringify(buttonMappingFromDOM)
              );
            } catch (e) {
              console.error(
                "[BUTTON] Error storing button mapping from DOM:",
                e
              );
            }
          }
        }

        document.querySelectorAll(".discount-button").forEach(function (btn) {
          try {
            btn.classList.remove("active");
          } catch (e) {
            console.error("[DEBUG] Error removing active class:", e);
          }
        });
        targetBtn.classList.add("active");

        var buttonDiscountTitle =
          targetBtn.getAttribute("data-discount-title") || pref;
        applyDiscount(buttonDiscountTitle, discountsData);
      } catch (e) {
        console.error(
          "[DEBUG] Error applying discount in applyPreferenceOnProductPage:",
          e
        );
      }
    } catch (e) {
      console.error("[DEBUG] Error in applyPreferenceOnProductPage:", e);
    }
  }

  function initializeAddToCartListener() {
    var addToCartButton = document.querySelector("#AddToCart");
    if (addToCartButton) {
      var form = addToCartButton.closest("form");
      if (form && !form.dataset.discountListenerAdded) {
        form.dataset.discountListenerAdded = "true";
        form.addEventListener("submit", function (e) {
          try {
            setTimeout(function () {
              try {
                var variantIdInput = form.querySelector('input[name="id"]');
                if (variantIdInput) {
                  var variantId = variantIdInput.value;
                  if (variantId) {
                    var discountTitleToUse = "";
                    var lockedPreference = null;
                    try {
                      lockedPreference = localStorage.getItem(
                        "cartLockedDiscountPreference"
                      );
                    } catch (e) {}

                    if (lockedPreference) {
                      var buttonMapping = window.getButtonDiscountMapping();
                      if (buttonMapping) {
                        if (lockedPreference === "1") {
                          discountTitleToUse = buttonMapping.button1 || "";
                        } else if (lockedPreference === "2") {
                          discountTitleToUse = buttonMapping.button2 || "";
                        }
                      }
                    }

                    var discountsWrapper = document.querySelector(
                      "[data-product-discounts-wrapper]"
                    );
                    if (!discountsWrapper) {
                      return;
                    }

                    if (!discountTitleToUse) {
                      discountTitleToUse = getDiscountPreferenceWithPriority();
                    }

                    var discountPercentage = 0;
                    var discountsScript = discountsWrapper.querySelector(
                      'script[type="application/json"]'
                    );
                    if (discountsScript && discountTitleToUse) {
                      try {
                        var discounts = JSON.parse(
                          discountsScript.textContent.trim()
                        );
                        var discount = findDiscountByTitle(
                          discounts,
                          discountTitleToUse
                        );
                        if (discount && discount.percentage) {
                          discountPercentage = discount.percentage;
                        }
                      } catch (e) {
                        console.error(
                          "[DEBUG] Error parsing discounts in form submit:",
                          e
                        );
                      }
                    }
                    setTimeout(function () {
                      try {
                        window.saveVariantDiscount(
                          variantId,
                          discountTitleToUse,
                          discountPercentage
                        );
                      } catch (e) {
                        console.error(
                          "[DEBUG] Error saving variant discount:",
                          e
                        );
                      }
                    }, 500);
                  }
                }
              } catch (e) {
                console.error("[DEBUG] Error in form submit listener:", e);
              }
            }, 300);
          } catch (e) {
            console.error("[DEBUG] Error setting up form submit:", e);
          }
        });
      }
      return true;
    }
    return false;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initializeInterception();
      if (!initializeAddToCartListener()) {
        setTimeout(initializeAddToCartListener, 500);
      }
      setTimeout(function () {
        applyPreferenceOnProductPage();
        setTimeout(applyPreferenceOnProductPage, 100);
      }, 200);
      try {
        setupCheckoutDiscountRedirects();
      } catch (e) {
        console.error("[CHK] init error", e);
      }
    });
  } else {
    initializeInterception();
    if (!initializeAddToCartListener()) {
      setTimeout(initializeAddToCartListener, 500);
    }
    setTimeout(function () {
      applyPreferenceOnProductPage();
      setTimeout(applyPreferenceOnProductPage, 100);
    }, 200);
    try {
      setupCheckoutDiscountRedirects();
    } catch (e) {
      console.error("[CHK] init error", e);
    }
  }

  document.addEventListener("variant:change", handleVariantChange);
  document.addEventListener("product:variant-change", handleVariantChange);

  function handleCartItemAdded(productData) {
    try {
      console.log("[CART-ADD] handleCartItemAdded called", productData);

      var discountsWrapper = document.querySelector(
        "[data-product-discounts-wrapper]"
      );
      if (!discountsWrapper) {
        console.log(
          "[CART-ADD] No discount buttons found, marking variant as no-discount"
        );
        if (productData && productData.variant_id) {
          try {
            var noDiscountVariants = JSON.parse(
              localStorage.getItem("noDiscountVariants") || "[]"
            );
            if (
              noDiscountVariants.indexOf(String(productData.variant_id)) === -1
            ) {
              noDiscountVariants.push(String(productData.variant_id));
              localStorage.setItem(
                "noDiscountVariants",
                JSON.stringify(noDiscountVariants)
              );
            }
          } catch (e) {
            console.error("[CART-ADD] Error saving no-discount variant:", e);
          }
        }
        return;
      }

      var button1 = document.querySelector("#discount-button-1");
      var button2 = document.querySelector("#discount-button-2");
      var activeButton = document.querySelector(".discount-button.active");

      console.log("[CART-ADD] Buttons found:", {
        button1: !!button1,
        button2: !!button2,
        activeButton: !!activeButton,
        activeButtonId: activeButton ? activeButton.id : null,
      });

      var buttonNumber = null;

      if (button1 && button2 && activeButton) {
        var button1Title = button1.getAttribute("data-discount-title");
        var button2Title = button2.getAttribute("data-discount-title");
        if (button1Title && button2Title) {
          var mapping = {
            button1: button1Title,
            button2: button2Title,
          };
          try {
            localStorage.setItem(
              "buttonDiscountMapping",
              JSON.stringify(mapping)
            );
            console.log("[CART-ADD] Button mapping saved:", mapping);
          } catch (e) {
            console.error("[CART-ADD] Error storing button mapping:", e);
          }
        }

        if (activeButton.id === "discount-button-2") {
          buttonNumber = 2;
        } else if (activeButton.id === "discount-button-1") {
          buttonNumber = 1;
        }
        console.log(
          "[CART-ADD] Button number from active button:",
          buttonNumber
        );
      }

      if (buttonNumber === null) {
        try {
          var assemblyPref = localStorage.getItem("assemblyPreference");
          console.log("[CART-ADD] assemblyPreference found:", assemblyPref);
          if (assemblyPref) {
            buttonNumber = parseInt(assemblyPref, 10);
            console.log("[CART-ADD] Using assemblyPreference:", buttonNumber);
          }
        } catch (e) {
          console.error("[CART-ADD] Error getting assemblyPreference:", e);
        }
      }

      if (buttonNumber === null || (buttonNumber !== 1 && buttonNumber !== 2)) {
        buttonNumber = 1;
        console.log("[CART-ADD] Defaulting to first button (1 - selfmontage)");
      }

      console.log("[CART-ADD] Final buttonNumber:", buttonNumber);

      try {
        var lockedPreference = localStorage.getItem(
          "cartLockedDiscountPreference"
        );
        console.log(
          "[CART-ADD] Current cartLockedDiscountPreference:",
          lockedPreference
        );

        if (!lockedPreference) {
          try {
            localStorage.setItem(
              "cartLockedDiscountPreference",
              String(buttonNumber)
            );
            var verify = localStorage.getItem("cartLockedDiscountPreference");
            if (verify === String(buttonNumber)) {
              console.log(
                "[CART-ADD] ✅ SUCCESS: Set cartLockedDiscountPreference to:",
                buttonNumber
              );
            } else {
              console.error(
                "[CART-ADD] ❌ VERIFICATION FAILED: Expected",
                buttonNumber,
                "but got",
                verify
              );
            }
          } catch (e) {
            console.error(
              "[CART-ADD] ❌ ERROR setting cartLockedDiscountPreference:",
              e
            );
          }
        } else {
          var lockedButtonNumber = parseInt(lockedPreference, 10);
          buttonNumber = lockedButtonNumber;
          console.log(
            "[CART-ADD] Using existing cartLockedDiscountPreference:",
            lockedButtonNumber
          );
        }
      } catch (e) {
        console.error("[CART-ADD] Error handling locked preference:", e);
      }

      setTimeout(function () {
        if (typeof window.applyCartDrawerDiscounts === "function") {
          window.applyCartDrawerDiscounts();
        }
        if (typeof window.applyCartPageDiscounts === "function") {
          window.applyCartPageDiscounts();
        }
      }, 400);
    } catch (e) {
      console.error("[CART-ADD] ❌ CRITICAL ERROR in handleCartItemAdded:", e);
    }
  }

  document.addEventListener("cart:item-added", function (event) {
    console.log("[CART-ADD] cart:item-added event received", event);
    var product =
      event.detail?.product || event.detail || event.detail?.items?.[0];
    console.log("[CART-ADD] Product data extracted:", product);
    handleCartItemAdded(product);
  });

  document.addEventListener("cart-drawer:open", function () {
    try {
      if (typeof window.applyCartDrawerDiscounts === "function") {
        window.applyCartDrawerDiscounts();
      }
    } catch (e) {}
  });

  var formInterceptionInitialized = false;

  function initializeFormInterception() {
    if (formInterceptionInitialized) {
      return;
    }

    var addToCartButton = document.querySelector("#AddToCart");
    if (!addToCartButton) {
      return;
    }

    var form = addToCartButton.closest("form");
    if (!form) {
      return;
    }

    if (form.dataset.formInterceptionInitialized) {
      return;
    }

    form.dataset.formInterceptionInitialized = "true";
    formInterceptionInitialized = true;

    var productFormElement = form.closest("product-form");
    if (form) {
      var formSubmitted = false;
      var handleFormSubmit = function (e) {
        if (formSubmitted) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }

        var discountsWrapper = document.querySelector(
          "[data-product-discounts-wrapper]"
        );
        if (!discountsWrapper) {
          formSubmitted = false;
          return;
        }

        var lockedPreference = null;
        try {
          lockedPreference = localStorage.getItem(
            "cartLockedDiscountPreference"
          );
        } catch (e) {
          console.error("[CART] Error checking locked preference:", e);
        }

        var activeButton = discountsWrapper.querySelector(
          ".discount-button.active"
        );
        var isButton2Active = false;
        if (activeButton) {
          isButton2Active = activeButton.id === "discount-button-2";
        }

        var shouldAddMontageProducts = false;
        if (lockedPreference === "2") {
          shouldAddMontageProducts = true;
        } else if (lockedPreference === "1") {
          shouldAddMontageProducts = false;
        } else {
          shouldAddMontageProducts = isButton2Active;
        }

        if (!shouldAddMontageProducts) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          formSubmitted = true;

          var variantIdInput = form.querySelector('input[name="id"]');
          var quantityInput = form.querySelector('input[name="quantity"]');
          var variantId = variantIdInput ? variantIdInput.value : null;
          var quantity = quantityInput
            ? parseInt(quantityInput.value || "1")
            : 1;

          if (!variantId) {
            console.error("[FORM-SUBMIT] No variant ID found");
            formSubmitted = false;
            return false;
          }

          var submitButtons = form.querySelectorAll(
            ".single-add-to-cart-button"
          );
          submitButtons.forEach(function (submitButton) {
            if (!submitButton.classList.contains("thb-loading")) {
              submitButton.setAttribute("aria-disabled", true);
              submitButton.classList.add("thb-loading");
            }
          });

          // Check if architect service should be added
          var architectSelected = localStorage.getItem('cartArchitectSelected') === 'true';
          var architectToggle = document.querySelector('[data-architect-toggle]');
          var architectVariantId = architectToggle ? architectToggle.dataset.architectVariantId : null;
          var cartBody;

          if (architectSelected && architectVariantId) {
            // Get product title for architect line property
            var productTitle = "";
            var productJson = document.querySelector('[type="application/json"][data-product-json]');
            if (productJson) {
              try {
                var productData = JSON.parse(productJson.textContent);
                productTitle = productData.title || "";
              } catch (e) {
                console.error("[CART] Error parsing product JSON for architect:", e);
              }
            }

            // Localized property key
            var propertyLabel = { en: "For", de: "Für", fr: "Pour", it: "Per" };
            var langCode = (document.documentElement.lang || "en").split("-")[0].toLowerCase();
            var propertyKey = propertyLabel[langCode] || "For";

            var architectProps = {};
            if (productTitle) {
              architectProps[propertyKey] = productTitle;
            }

            cartBody = {
              items: [
                { id: variantId, quantity: quantity },
                { id: architectVariantId, quantity: 1, properties: architectProps }
              ]
            };
          } else {
            cartBody = { id: variantId, quantity: quantity };
          }

          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/json",
            },
            body: JSON.stringify(cartBody),
          })
            .then(function (response) {
              if (response.ok) {
                return response.json();
              }
              throw new Error("Failed to add to cart");
            })
            .then(function (cartData) {
              var sectionsToRender = [
                {
                  id: "cart-drawer",
                  section: "cart-drawer",
                  selector: ".side-panel-content",
                },
                {
                  id: "Cart-Drawer",
                  section: "cart-drawer",
                  selector: ".side-panel-content",
                },
              ];

              var sectionsParam = sectionsToRender
                .map(function (s) {
                  return s.section;
                })
                .join(",");

              return fetch(
                `/cart.js?sections=${sectionsParam}&sections_url=${encodeURIComponent(
                  window.location.pathname
                )}`
              )
                .then(function (res) {
                  return res.json();
                })
                .then(function (sectionsData) {
                  sectionsToRender.forEach(function (section) {
                    var element = document.getElementById(section.id);
                    if (
                      element &&
                      sectionsData.sections &&
                      sectionsData.sections[section.section]
                    ) {
                      var selector = section.selector || element;
                      var elementToReplace =
                        typeof selector === "string"
                          ? element.querySelector(selector) || element
                          : selector;
                      if (elementToReplace) {
                        elementToReplace.innerHTML =
                          sectionsData.sections[section.section];
                      }

                      if (
                        section.id === "Cart-Drawer" &&
                        typeof CartDrawer !== "undefined"
                      ) {
                        new CartDrawer();
                      }
                    }
                  });
                  return cartData;
                });
            })
            .then(function (cartData) {
              var discountsWrapper = document.querySelector(
                "[data-product-discounts-wrapper]"
              );
              if (!discountsWrapper) {
                formSubmitted = false;
                submitButtons.forEach(function (submitButton) {
                  submitButton.classList.remove("thb-loading");
                  submitButton.removeAttribute("aria-disabled");
                });
                document.dispatchEvent(new CustomEvent("cart:refresh"));
                return;
              }

              var discountTitleToUse = "";
              var lockedPreference = null;
              try {
                lockedPreference = localStorage.getItem(
                  "cartLockedDiscountPreference"
                );
              } catch (e) {
                console.error("[CART] Error checking locked preference:", e);
              }

              if (lockedPreference && variantId) {
                var lockedButtonNumber = parseInt(lockedPreference, 10);
                var button1 =
                  discountsWrapper.querySelector("#discount-button-1");
                var button2 =
                  discountsWrapper.querySelector("#discount-button-2");
                var buttonToUse = null;
                if (lockedButtonNumber === 1 && button1) {
                  buttonToUse = button1;
                } else if (lockedButtonNumber === 2 && button2) {
                  buttonToUse = button2;
                }
                if (buttonToUse) {
                  discountTitleToUse =
                    buttonToUse.getAttribute("data-discount-title") || "";
                }
              }

              if (!discountTitleToUse && variantId) {
                var buttonMapping = window.getButtonDiscountMapping();
                if (buttonMapping && lockedPreference) {
                  if (lockedPreference === "1") {
                    discountTitleToUse = buttonMapping.button1 || "";
                  } else if (lockedPreference === "2") {
                    discountTitleToUse = buttonMapping.button2 || "";
                  }
                }
                if (!discountTitleToUse) {
                  var activeDiscountButton = discountsWrapper.querySelector(
                    ".discount-button.active"
                  );
                  if (activeDiscountButton) {
                    discountTitleToUse =
                      activeDiscountButton.getAttribute(
                        "data-discount-title"
                      ) || "";
                  }
                }
              }

              if (
                discountTitleToUse &&
                discountTitleToUse.trim() !== "" &&
                variantId
              ) {
                var discountsScript = discountsWrapper.querySelector(
                  'script[type="application/json"]'
                );
                if (discountsScript) {
                  try {
                    var discountsData = JSON.parse(
                      discountsScript.textContent.trim()
                    );
                    if (discountsData && Array.isArray(discountsData)) {
                      var exactDiscount = discountsData.find(function (d) {
                        return d.title === discountTitleToUse.trim();
                      });
                      if (
                        exactDiscount &&
                        exactDiscount.percentage !== undefined
                      ) {
                        window.saveVariantDiscount(
                          variantId,
                          discountTitleToUse.trim(),
                          exactDiscount.percentage
                        );
                      } else {
                        window.saveVariantDiscount(
                          variantId,
                          discountTitleToUse.trim(),
                          0
                        );
                      }
                    } else {
                      window.saveVariantDiscount(
                        variantId,
                        discountTitleToUse.trim(),
                        0
                      );
                    }
                  } catch (e) {
                    console.error(
                      "[CART] Error parsing discounts or saving variant discount:",
                      e
                    );
                    window.saveVariantDiscount(
                      variantId,
                      discountTitleToUse.trim(),
                      0
                    );
                  }
                } else {
                  window.saveVariantDiscount(
                    variantId,
                    discountTitleToUse.trim(),
                    0
                  );
                }
              }

              formSubmitted = false;

              submitButtons.forEach(function (submitButton) {
                submitButton.classList.remove("thb-loading");
                submitButton.removeAttribute("aria-disabled");
              });

              document.dispatchEvent(new CustomEvent("cart:refresh"));

              var cartDrawerToggle =
                document.getElementById("cart-drawer-toggle");
              if (cartDrawerToggle) {
                setTimeout(function () {
                  cartDrawerToggle.click();
                }, 100);
                setTimeout(function () {
                  document.dispatchEvent(new CustomEvent("cart-drawer:open"));
                }, 200);
              }

              if (cartData && cartData.items) {
                var productItem = cartData.items[cartData.items.length - 1];
                console.log(
                  "[FORM-SUBMIT] Dispatching cart:item-added event (linked variants path)",
                  productItem
                );
                document.dispatchEvent(
                  new CustomEvent("cart:item-added", {
                    detail: { product: productItem },
                  })
                );

                console.log(
                  "[FORM-SUBMIT] Calling handleCartItemAdded directly (linked variants path)"
                );
                handleCartItemAdded(productItem);
              } else {
                console.warn(
                  "[FORM-SUBMIT] cartData.items not found (linked variants path), cartData:",
                  cartData
                );

                if (cartData) {
                  handleCartItemAdded(cartData);
                }
              }

              setTimeout(function () {
                if (typeof window.applyCartDrawerDiscounts === "function") {
                  window.applyCartDrawerDiscounts();
                }
                if (typeof window.applyCartPageDiscounts === "function") {
                  window.applyCartPageDiscounts();
                }
              }, 400);
            })
            .catch(function (error) {
              formSubmitted = false;
              console.error("[FORM-SUBMIT] Error adding to cart:", error);
              submitButtons.forEach(function (submitButton) {
                submitButton.classList.remove("thb-loading");
                submitButton.removeAttribute("aria-disabled");
              });
            });

          return false;
        }

        var variantIdInput = form.querySelector('input[name="id"]');
        if (variantIdInput) {
          var variantId = variantIdInput.value;
          if (variantId) {
            var linkedVariantsScript = document.querySelector(
              '[id^="linked-variants-data-"]'
            );
            if (linkedVariantsScript) {
              try {
                var linkedVariantsData = JSON.parse(
                  linkedVariantsScript.textContent.trim()
                );
                var linkedVariants = linkedVariantsData[variantId];
                if (
                  linkedVariants &&
                  Array.isArray(linkedVariants) &&
                  linkedVariants.length > 0
                ) {
                  console.log(
                    "[FORM-SUBMIT-DEBUG] Found linked variants, handling montage products"
                  );
                  e.preventDefault();
                  e.stopPropagation();
                  e.stopImmediatePropagation();
                  formSubmitted = true;

                  var quantityInput = form.querySelector(
                    'input[name="quantity"]'
                  );
                  var quantity = quantityInput
                    ? parseInt(quantityInput.value || "1")
                    : 1;

                  var productTitle = "";
                  var variantTitle = "";

                  var productTitleEl = document.querySelector(
                    ".product_title, h1.product_title"
                  );
                  if (productTitleEl) {
                    productTitle = productTitleEl.textContent.trim();
                  }

                  var variantSelects =
                    document.querySelector("variant-selects");
                  if (variantSelects && variantSelects.currentVariant) {
                    variantTitle = variantSelects.currentVariant.title || "";
                  } else {
                    var productJson = document.querySelector(
                      '[type="application/json"][data-product-json]'
                    );
                    if (productJson) {
                      try {
                        var productData = JSON.parse(productJson.textContent);
                        var selectedVariant = productData.variants?.find(
                          function (v) {
                            return String(v.id) === String(variantId);
                          }
                        );
                        if (selectedVariant) {
                          variantTitle = selectedVariant.title || "";
                        }
                      } catch (e) {
                        console.error("[CART] Error parsing product JSON:", e);
                      }
                    }
                  }

                  var propertyLabel = {
                    en: "For",
                    de: "Für",
                    fr: "Pour",
                    it: "Per",
                  };

                  var currentLocale = document.documentElement.lang || "en";
                  var langCode = currentLocale.split("-")[0].toLowerCase();
                  if (!propertyLabel[langCode]) {
                    langCode = "en";
                  }

                  var propertyKey = propertyLabel[langCode];

                  var combinedTitle = productTitle || "";
                  if (variantTitle && variantTitle !== "Default Title") {
                    if (combinedTitle) {
                      combinedTitle = combinedTitle + " " + variantTitle;
                    } else {
                      combinedTitle = variantTitle;
                    }
                  }

                  var itemsToAdd = [{ id: variantId, quantity: quantity }];
                  var linkedVariantIds = [];
                  linkedVariants.forEach(function (linkedVariant) {
                    if (
                      linkedVariant &&
                      linkedVariant.id &&
                      String(linkedVariant.id) !== String(variantId)
                    ) {
                      linkedVariantIds.push(String(linkedVariant.id));
                      var properties = {};
                      if (combinedTitle) {
                        properties[propertyKey] = combinedTitle;
                      }

                      itemsToAdd.push({
                        id: String(linkedVariant.id),
                        quantity: quantity,
                        properties: properties,
                      });
                    }
                  });

                  // Add architect service if selected
                  var architectSelected = localStorage.getItem('cartArchitectSelected') === 'true';
                  var architectToggle = document.querySelector('[data-architect-toggle]');
                  var architectVariantId = architectToggle ? architectToggle.dataset.architectVariantId : null;
                  if (architectSelected && architectVariantId) {
                    var architectProps = {};
                    if (combinedTitle) {
                      architectProps[propertyKey] = combinedTitle;
                    }
                    itemsToAdd.push({
                      id: architectVariantId,
                      quantity: 1,
                      properties: architectProps
                    });
                  }

                  if (linkedVariantIds.length > 0) {
                    try {
                      var variantRelationships = JSON.parse(
                        localStorage.getItem("variantRelationships") || "{}"
                      );
                      variantRelationships[String(variantId)] =
                        linkedVariantIds;
                      localStorage.setItem(
                        "variantRelationships",
                        JSON.stringify(variantRelationships)
                      );
                    } catch (e) {
                      console.error(
                        "[CART] Error storing variant relationship:",
                        e
                      );
                    }
                  }

                  var discountTitleToUse = "";
                  var lockedPreference = null;
                  try {
                    lockedPreference = localStorage.getItem(
                      "cartLockedDiscountPreference"
                    );
                  } catch (e) {
                    console.error(
                      "[CART] Error checking locked preference:",
                      e
                    );
                  }

                  if (lockedPreference) {
                    var lockedButtonNumber = parseInt(lockedPreference, 10);
                    var button1 = document.querySelector("#discount-button-1");
                    var button2 = document.querySelector("#discount-button-2");
                    var buttonToUse = null;
                    if (lockedButtonNumber === 1 && button1) {
                      buttonToUse = button1;
                    } else if (lockedButtonNumber === 2 && button2) {
                      buttonToUse = button2;
                    }
                    if (buttonToUse) {
                      discountTitleToUse =
                        buttonToUse.getAttribute("data-discount-title") || "";
                    }
                  }

                  if (!discountTitleToUse) {
                    var activeDiscountButton = document.querySelector(
                      ".discount-button.active"
                    );
                    if (activeDiscountButton) {
                      discountTitleToUse =
                        activeDiscountButton.getAttribute(
                          "data-discount-title"
                        ) || "";
                    }
                  }

                  if (discountTitleToUse && discountTitleToUse.trim() !== "") {
                    var discountsScript = document.querySelector(
                      '[data-product-discounts-wrapper] script[type="application/json"]'
                    );
                    if (discountsScript) {
                      try {
                        var discountsData = JSON.parse(
                          discountsScript.textContent.trim()
                        );
                        if (discountsData && Array.isArray(discountsData)) {
                          var exactDiscount = discountsData.find(function (d) {
                            return d.title === discountTitleToUse.trim();
                          });
                          if (
                            exactDiscount &&
                            exactDiscount.percentage !== undefined
                          ) {
                            window.saveVariantDiscount(
                              variantId,
                              discountTitleToUse.trim(),
                              exactDiscount.percentage
                            );
                          } else {
                            window.saveVariantDiscount(
                              variantId,
                              discountTitleToUse.trim(),
                              0
                            );
                          }
                        } else {
                          window.saveVariantDiscount(
                            variantId,
                            discountTitleToUse.trim(),
                            0
                          );
                        }
                      } catch (e) {
                        console.error(
                          "[CART] Error parsing discounts or saving variant discount:",
                          e
                        );
                        window.saveVariantDiscount(
                          variantId,
                          discountTitleToUse.trim(),
                          0
                        );
                      }
                    } else {
                      window.saveVariantDiscount(
                        variantId,
                        discountTitleToUse.trim(),
                        0
                      );
                    }
                  }

                  var submitButtons = form.querySelectorAll(
                    ".single-add-to-cart-button"
                  );
                  submitButtons.forEach(function (submitButton) {
                    if (!submitButton.classList.contains("thb-loading")) {
                      submitButton.setAttribute("aria-disabled", true);
                      submitButton.classList.add("thb-loading");
                    }
                  });

                  var config = {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With": "XMLHttpRequest",
                      Accept: "application/json",
                    },
                    body: JSON.stringify({ items: itemsToAdd }),
                  };
                  fetch("/cart/add.js", config)
                    .then(function (response) {
                      if (response.ok) {
                        return response.json();
                      }
                      throw new Error("Network response was not ok");
                    })
                    .then(function (cartData) {
                      var sectionsToRender = [
                        {
                          id: "cart-drawer",
                          section: "cart-drawer",
                          selector: ".side-panel-content",
                        },
                        {
                          id: "Cart-Drawer",
                          section: "cart-drawer",
                          selector: ".side-panel-content",
                        },
                      ];

                      var sectionsParam = sectionsToRender
                        .map(function (s) {
                          return s.section;
                        })
                        .join(",");

                      return fetch(
                        `/cart.js?sections=${sectionsParam}&sections_url=${encodeURIComponent(
                          window.location.pathname
                        )}`
                      )
                        .then(function (res) {
                          return res.json();
                        })
                        .then(function (sectionsData) {
                          sectionsToRender.forEach(function (section) {
                            var element = document.getElementById(section.id);
                            if (
                              element &&
                              sectionsData.sections &&
                              sectionsData.sections[section.section]
                            ) {
                              var selector = section.selector || element;
                              var elementToReplace =
                                typeof selector === "string"
                                  ? element.querySelector(selector) || element
                                  : selector;
                              if (elementToReplace) {
                                elementToReplace.innerHTML =
                                  sectionsData.sections[section.section];
                              }

                              if (
                                section.id === "Cart-Drawer" &&
                                typeof CartDrawer !== "undefined"
                              ) {
                                new CartDrawer();
                              }
                            }
                          });
                          return cartData;
                        });
                    })
                    .then(function (cartData) {
                      formSubmitted = false;

                      submitButtons.forEach(function (submitButton) {
                        submitButton.classList.remove("thb-loading");
                        submitButton.removeAttribute("aria-disabled");
                      });

                      document.dispatchEvent(new CustomEvent("cart:refresh"));

                      var cartDrawerToggle =
                        document.getElementById("cart-drawer-toggle");
                      if (cartDrawerToggle) {
                        setTimeout(function () {
                          cartDrawerToggle.click();
                        }, 100);
                        setTimeout(function () {
                          document.dispatchEvent(
                            new CustomEvent("cart-drawer:open")
                          );
                        }, 200);
                      }

                      if (cartData && cartData.items) {
                        var productItem =
                          cartData.items[cartData.items.length - 1];
                        document.dispatchEvent(
                          new CustomEvent("cart:item-added", {
                            detail: { product: productItem },
                          })
                        );
                      }
                    })
                    .catch(function (error) {
                      formSubmitted = false;
                      console.error(
                        "[CART] Error adding linked variants:",
                        error
                      );
                    });

                  return false;
                } else {
                  console.log(
                    "[FORM-SUBMIT-DEBUG] No linked variants found, but shouldAddMontageProducts is true - adding main product only"
                  );
                  e.preventDefault();
                  e.stopPropagation();
                  e.stopImmediatePropagation();
                  formSubmitted = true;

                  var quantityInput = form.querySelector(
                    'input[name="quantity"]'
                  );
                  var quantity = quantityInput
                    ? parseInt(quantityInput.value || "1")
                    : 1;

                  var submitButtons = form.querySelectorAll(
                    ".single-add-to-cart-button"
                  );
                  submitButtons.forEach(function (submitButton) {
                    if (!submitButton.classList.contains("thb-loading")) {
                      submitButton.setAttribute("aria-disabled", true);
                      submitButton.classList.add("thb-loading");
                    }
                  });

                  fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      "X-Requested-With": "XMLHttpRequest",
                      Accept: "application/json",
                    },
                    body: JSON.stringify({
                      id: variantId,
                      quantity: quantity,
                    }),
                  })
                    .then(function (response) {
                      if (response.ok) {
                        return response.json();
                      }
                      throw new Error("Failed to add to cart");
                    })
                    .then(function (cartData) {
                      var sectionsToRender = [
                        {
                          id: "cart-drawer",
                          section: "cart-drawer",
                          selector: ".side-panel-content",
                        },
                        {
                          id: "Cart-Drawer",
                          section: "cart-drawer",
                          selector: ".side-panel-content",
                        },
                      ];

                      var sectionsParam = sectionsToRender
                        .map(function (s) {
                          return s.section;
                        })
                        .join(",");

                      return fetch(
                        `/cart.js?sections=${sectionsParam}&sections_url=${encodeURIComponent(
                          window.location.pathname
                        )}`
                      )
                        .then(function (res) {
                          return res.json();
                        })
                        .then(function (sectionsData) {
                          sectionsToRender.forEach(function (section) {
                            var element = document.getElementById(section.id);
                            if (
                              element &&
                              sectionsData.sections &&
                              sectionsData.sections[section.section]
                            ) {
                              var selector = section.selector || element;
                              var elementToReplace =
                                typeof selector === "string"
                                  ? element.querySelector(selector) || element
                                  : selector;
                              if (elementToReplace) {
                                elementToReplace.innerHTML =
                                  sectionsData.sections[section.section];
                              }

                              if (
                                section.id === "Cart-Drawer" &&
                                typeof CartDrawer !== "undefined"
                              ) {
                                new CartDrawer();
                              }
                            }
                          });
                          return cartData;
                        });
                    })
                    .then(function (cartData) {
                      var discountTitleToUse = "";
                      var lockedPreference = null;
                      try {
                        lockedPreference = localStorage.getItem(
                          "cartLockedDiscountPreference"
                        );
                        console.log(
                          "[CART] Locked preference:",
                          lockedPreference
                        );
                      } catch (e) {
                        console.error(
                          "[CART] Error checking locked preference:",
                          e
                        );
                      }

                      if (lockedPreference == null) {
                        var activeDiscountButton = document.querySelector(
                          ".discount-button.active"
                        );
                        if (activeDiscountButton) {
                          var buttonId = activeDiscountButton.id;
                          var buttonNumber = null;
                          if (buttonId === "discount-button-1") {
                            buttonNumber = 1;
                          } else if (buttonId === "discount-button-2") {
                            buttonNumber = 2;
                          }
                          if (buttonNumber) {
                            try {
                              localStorage.setItem(
                                "cartLockedDiscountPreference",
                                String(buttonNumber)
                              );
                              lockedPreference = String(buttonNumber);
                              console.log(
                                "[CART] Set locked preference to current active button:",
                                buttonNumber
                              );
                            } catch (e) {
                              console.error(
                                "[CART] Error setting locked preference:",
                                e
                              );
                            }
                          }
                        }
                      }

                      if (lockedPreference && variantId) {
                        var lockedButtonNumber = parseInt(lockedPreference, 10);
                        var button1 =
                          document.querySelector("#discount-button-1");
                        var button2 =
                          document.querySelector("#discount-button-2");
                        var buttonToUse = null;
                        if (lockedButtonNumber === 1 && button1) {
                          buttonToUse = button1;
                        } else if (lockedButtonNumber === 2 && button2) {
                          buttonToUse = button2;
                        }
                        if (buttonToUse) {
                          discountTitleToUse =
                            buttonToUse.getAttribute("data-discount-title") ||
                            "";
                        }
                        console.log(
                          "[FORM-SUBMIT-DEBUG] Using locked preference discount",
                          {
                            lockedPreference: lockedPreference,
                            lockedButtonNumber: lockedButtonNumber,
                            discountTitleToUse: discountTitleToUse,
                            variantId: variantId,
                          }
                        );
                      }

                      if (!discountTitleToUse && variantId) {
                        var activeDiscountButton = document.querySelector(
                          ".discount-button.active"
                        );
                        if (activeDiscountButton) {
                          discountTitleToUse =
                            activeDiscountButton.getAttribute(
                              "data-discount-title"
                            ) || "";
                        }
                        console.log(
                          "[FORM-SUBMIT-DEBUG] Using active button discount (no locked preference)",
                          {
                            discountTitleToUse: discountTitleToUse,
                            variantId: variantId,
                          }
                        );
                      }

                      if (
                        discountTitleToUse &&
                        discountTitleToUse.trim() !== "" &&
                        variantId
                      ) {
                        var discountsScript = document.querySelector(
                          '[data-product-discounts-wrapper] script[type="application/json"]'
                        );
                        if (discountsScript) {
                          try {
                            var discountsData = JSON.parse(
                              discountsScript.textContent.trim()
                            );
                            if (discountsData && Array.isArray(discountsData)) {
                              var exactDiscount = discountsData.find(function (
                                d
                              ) {
                                return d.title === discountTitleToUse.trim();
                              });
                              var discountPercentage = 0;
                              if (
                                exactDiscount &&
                                exactDiscount.percentage !== undefined
                              ) {
                                discountPercentage = exactDiscount.percentage;
                              }
                              console.log(
                                "[FORM-SUBMIT-DEBUG] Saving discount to localStorage (no linked variants path)",
                                {
                                  variantId: variantId,
                                  discountTitle: discountTitleToUse.trim(),
                                  discountPercentage: discountPercentage,
                                }
                              );
                              window.saveVariantDiscount(
                                variantId,
                                discountTitleToUse.trim(),
                                discountPercentage
                              );
                            } else {
                              console.log(
                                "[FORM-SUBMIT-DEBUG] No discounts data array, saving with 0% (no linked variants path)",
                                {
                                  variantId: variantId,
                                  discountTitle: discountTitleToUse.trim(),
                                }
                              );
                              window.saveVariantDiscount(
                                variantId,
                                discountTitleToUse.trim(),
                                0
                              );
                            }
                          } catch (e) {
                            console.error(
                              "[CART] Error parsing discounts or saving variant discount:",
                              e
                            );
                            window.saveVariantDiscount(
                              variantId,
                              discountTitleToUse.trim(),
                              0
                            );
                          }
                        } else {
                          console.log(
                            "[FORM-SUBMIT-DEBUG] No discounts script found, saving with 0% (no linked variants path)",
                            {
                              variantId: variantId,
                              discountTitle: discountTitleToUse.trim(),
                            }
                          );
                          window.saveVariantDiscount(
                            variantId,
                            discountTitleToUse.trim(),
                            0
                          );
                        }
                      } else {
                        console.log(
                          "[FORM-SUBMIT-DEBUG] Not saving discount - missing data (no linked variants path)",
                          {
                            variantId: variantId,
                            discountTitleToUse: discountTitleToUse,
                          }
                        );
                      }

                      formSubmitted = false;

                      submitButtons.forEach(function (submitButton) {
                        submitButton.classList.remove("thb-loading");
                        submitButton.removeAttribute("aria-disabled");
                      });

                      document.dispatchEvent(new CustomEvent("cart:refresh"));

                      var cartDrawerToggle =
                        document.getElementById("cart-drawer-toggle");
                      if (cartDrawerToggle) {
                        setTimeout(function () {
                          cartDrawerToggle.click();
                        }, 100);
                        setTimeout(function () {
                          document.dispatchEvent(
                            new CustomEvent("cart-drawer:open")
                          );
                        }, 200);
                      }

                      if (cartData && cartData.items) {
                        var productItem =
                          cartData.items[cartData.items.length - 1];
                        document.dispatchEvent(
                          new CustomEvent("cart:item-added", {
                            detail: { product: productItem },
                          })
                        );
                      }

                      setTimeout(function () {
                        if (
                          typeof window.applyCartDrawerDiscounts === "function"
                        ) {
                          window.applyCartDrawerDiscounts();
                        }
                        if (
                          typeof window.applyCartPageDiscounts === "function"
                        ) {
                          window.applyCartPageDiscounts();
                        }
                      }, 400);

                      setTimeout(function () {
                        if (
                          typeof window.applyCartDrawerDiscounts === "function"
                        ) {
                          window.applyCartDrawerDiscounts();
                        }
                      }, 800);
                    })
                    .catch(function (error) {
                      formSubmitted = false;
                      console.error(
                        "[FORM-SUBMIT] Error adding to cart:",
                        error
                      );
                      submitButtons.forEach(function (submitButton) {
                        submitButton.classList.remove("thb-loading");
                        submitButton.removeAttribute("aria-disabled");
                      });
                    });

                  return false;
                }
              } catch (err) {
                console.error("[CART] Error parsing linked variants:", err);
                console.log(
                  "[FORM-SUBMIT-DEBUG] Error parsing linked variants, adding main product only"
                );
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                formSubmitted = true;

                var quantityInput = form.querySelector(
                  'input[name="quantity"]'
                );
                var quantity = quantityInput
                  ? parseInt(quantityInput.value || "1")
                  : 1;

                var submitButtons = form.querySelectorAll(
                  ".single-add-to-cart-button"
                );
                submitButtons.forEach(function (submitButton) {
                  if (!submitButton.classList.contains("thb-loading")) {
                    submitButton.setAttribute("aria-disabled", true);
                    submitButton.classList.add("thb-loading");
                  }
                });

                fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({
                    id: variantId,
                    quantity: quantity,
                  }),
                })
                  .then(function (response) {
                    if (response.ok) {
                      return response.json();
                    }
                    throw new Error("Failed to add to cart");
                  })
                  .then(function (cartData) {
                    var sectionsToRender = [
                      {
                        id: "cart-drawer",
                        section: "cart-drawer",
                        selector: ".side-panel-content",
                      },
                      {
                        id: "Cart-Drawer",
                        section: "cart-drawer",
                        selector: ".side-panel-content",
                      },
                    ];

                    var sectionsParam = sectionsToRender
                      .map(function (s) {
                        return s.section;
                      })
                      .join(",");

                    return fetch(
                      `/cart.js?sections=${sectionsParam}&sections_url=${encodeURIComponent(
                        window.location.pathname
                      )}`
                    )
                      .then(function (res) {
                        return res.json();
                      })
                      .then(function (sectionsData) {
                        sectionsToRender.forEach(function (section) {
                          var element = document.getElementById(section.id);
                          if (
                            element &&
                            sectionsData.sections &&
                            sectionsData.sections[section.section]
                          ) {
                            var selector = section.selector || element;
                            var elementToReplace =
                              typeof selector === "string"
                                ? element.querySelector(selector) || element
                                : selector;
                            if (elementToReplace) {
                              elementToReplace.innerHTML =
                                sectionsData.sections[section.section];
                            }

                            if (
                              section.id === "Cart-Drawer" &&
                              typeof CartDrawer !== "undefined"
                            ) {
                              new CartDrawer();
                            }
                          }
                        });
                        return cartData;
                      });
                  })
                  .then(function (cartData) {
                    var discountTitleToUse = "";
                    var lockedPreference = null;
                    try {
                      lockedPreference = localStorage.getItem(
                        "cartLockedDiscountPreference"
                      );
                    } catch (e) {
                      console.error(
                        "[CART] Error checking locked preference:",
                        e
                      );
                    }

                    if (lockedPreference && variantId) {
                      var lockedButtonNumber = parseInt(lockedPreference, 10);
                      var button1 =
                        document.querySelector("#discount-button-1");
                      var button2 =
                        document.querySelector("#discount-button-2");
                      var buttonToUse = null;
                      if (lockedButtonNumber === 1 && button1) {
                        buttonToUse = button1;
                      } else if (lockedButtonNumber === 2 && button2) {
                        buttonToUse = button2;
                      }
                      if (buttonToUse) {
                        discountTitleToUse =
                          buttonToUse.getAttribute("data-discount-title") || "";
                      }
                    }

                    if (!discountTitleToUse && variantId) {
                      var activeDiscountButton = document.querySelector(
                        ".discount-button.active"
                      );
                      if (activeDiscountButton) {
                        discountTitleToUse =
                          activeDiscountButton.getAttribute(
                            "data-discount-title"
                          ) || "";
                      }
                    }

                    if (
                      discountTitleToUse &&
                      discountTitleToUse.trim() !== "" &&
                      variantId
                    ) {
                      var discountsScript = document.querySelector(
                        '[data-product-discounts-wrapper] script[type="application/json"]'
                      );
                      if (discountsScript) {
                        try {
                          var discountsData = JSON.parse(
                            discountsScript.textContent.trim()
                          );
                          if (discountsData && Array.isArray(discountsData)) {
                            var exactDiscount = discountsData.find(function (
                              d
                            ) {
                              return d.title === discountTitleToUse.trim();
                            });
                            if (
                              exactDiscount &&
                              exactDiscount.percentage !== undefined
                            ) {
                              window.saveVariantDiscount(
                                variantId,
                                discountTitleToUse.trim(),
                                exactDiscount.percentage
                              );
                            } else {
                              window.saveVariantDiscount(
                                variantId,
                                discountTitleToUse.trim(),
                                0
                              );
                            }
                          } else {
                            window.saveVariantDiscount(
                              variantId,
                              discountTitleToUse.trim(),
                              0
                            );
                          }
                        } catch (e) {
                          console.error(
                            "[CART] Error parsing discounts or saving variant discount:",
                            e
                          );
                          window.saveVariantDiscount(
                            variantId,
                            discountTitleToUse.trim(),
                            0
                          );
                        }
                      } else {
                        window.saveVariantDiscount(
                          variantId,
                          discountTitleToUse.trim(),
                          0
                        );
                      }
                    }

                    formSubmitted = false;

                    submitButtons.forEach(function (submitButton) {
                      submitButton.classList.remove("thb-loading");
                      submitButton.removeAttribute("aria-disabled");
                    });

                    document.dispatchEvent(new CustomEvent("cart:refresh"));

                    var cartDrawerToggle =
                      document.getElementById("cart-drawer-toggle");
                    if (cartDrawerToggle) {
                      setTimeout(function () {
                        cartDrawerToggle.click();
                      }, 100);
                      setTimeout(function () {
                        document.dispatchEvent(
                          new CustomEvent("cart-drawer:open")
                        );
                      }, 200);
                    }

                    if (cartData && cartData.items) {
                      var productItem =
                        cartData.items[cartData.items.length - 1];
                      console.log(
                        "[FORM-SUBMIT] Dispatching cart:item-added event (main path)",
                        productItem
                      );
                      document.dispatchEvent(
                        new CustomEvent("cart:item-added", {
                          detail: { product: productItem },
                        })
                      );

                      console.log(
                        "[FORM-SUBMIT] Calling handleCartItemAdded directly (main path)"
                      );
                      handleCartItemAdded(productItem);
                    } else {
                      console.warn(
                        "[FORM-SUBMIT] cartData.items not found (main path), cartData:",
                        cartData
                      );

                      if (cartData) {
                        handleCartItemAdded(cartData);
                      }
                    }

                    setTimeout(function () {
                      if (
                        typeof window.applyCartDrawerDiscounts === "function"
                      ) {
                        window.applyCartDrawerDiscounts();
                      }
                      if (typeof window.applyCartPageDiscounts === "function") {
                        window.applyCartPageDiscounts();
                      }
                    }, 400);
                  })
                  .catch(function (error) {
                    formSubmitted = false;
                    console.error("[FORM-SUBMIT] Error adding to cart:", error);
                    submitButtons.forEach(function (submitButton) {
                      submitButton.classList.remove("thb-loading");
                      submitButton.removeAttribute("aria-disabled");
                    });
                  });

                return false;
              }
            } else {
              console.log(
                "[FORM-SUBMIT-DEBUG] No linked variants script found, adding main product only"
              );
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              formSubmitted = true;

              var quantityInput = form.querySelector('input[name="quantity"]');
              var quantity = quantityInput
                ? parseInt(quantityInput.value || "1")
                : 1;

              var submitButtons = form.querySelectorAll(
                ".single-add-to-cart-button"
              );
              submitButtons.forEach(function (submitButton) {
                if (!submitButton.classList.contains("thb-loading")) {
                  submitButton.setAttribute("aria-disabled", true);
                  submitButton.classList.add("thb-loading");
                }
              });

              fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  id: variantId,
                  quantity: quantity,
                }),
              })
                .then(function (response) {
                  if (response.ok) {
                    return response.json();
                  }
                  throw new Error("Failed to add to cart");
                })
                .then(function (cartData) {
                  var sectionsToRender = [
                    {
                      id: "cart-drawer",
                      section: "cart-drawer",
                      selector: ".side-panel-content",
                    },
                    {
                      id: "Cart-Drawer",
                      section: "cart-drawer",
                      selector: ".side-panel-content",
                    },
                  ];

                  var sectionsParam = sectionsToRender
                    .map(function (s) {
                      return s.section;
                    })
                    .join(",");

                  return fetch(
                    `/cart.js?sections=${sectionsParam}&sections_url=${encodeURIComponent(
                      window.location.pathname
                    )}`
                  )
                    .then(function (res) {
                      return res.json();
                    })
                    .then(function (sectionsData) {
                      sectionsToRender.forEach(function (section) {
                        var element = document.getElementById(section.id);
                        if (
                          element &&
                          sectionsData.sections &&
                          sectionsData.sections[section.section]
                        ) {
                          var selector = section.selector || element;
                          var elementToReplace =
                            typeof selector === "string"
                              ? element.querySelector(selector) || element
                              : selector;
                          if (elementToReplace) {
                            elementToReplace.innerHTML =
                              sectionsData.sections[section.section];
                          }

                          if (
                            section.id === "Cart-Drawer" &&
                            typeof CartDrawer !== "undefined"
                          ) {
                            new CartDrawer();
                          }
                        }
                      });
                      return cartData;
                    });
                })
                .then(function (cartData) {
                  formSubmitted = false;

                  submitButtons.forEach(function (submitButton) {
                    submitButton.classList.remove("thb-loading");
                    submitButton.removeAttribute("aria-disabled");
                  });

                  document.dispatchEvent(new CustomEvent("cart:refresh"));

                  var cartDrawerToggle =
                    document.getElementById("cart-drawer-toggle");
                  if (cartDrawerToggle) {
                    setTimeout(function () {
                      cartDrawerToggle.click();
                    }, 100);
                    setTimeout(function () {
                      document.dispatchEvent(
                        new CustomEvent("cart-drawer:open")
                      );
                    }, 200);
                  }

                  if (cartData && cartData.items) {
                    var productItem = cartData.items[cartData.items.length - 1];
                    console.log(
                      "[FORM-SUBMIT] Dispatching cart:item-added event",
                      productItem
                    );
                    document.dispatchEvent(
                      new CustomEvent("cart:item-added", {
                        detail: { product: productItem },
                      })
                    );

                    console.log(
                      "[FORM-SUBMIT] Calling handleCartItemAdded directly"
                    );
                    handleCartItemAdded(productItem);
                  } else {
                    console.warn(
                      "[FORM-SUBMIT] cartData.items not found, cartData:",
                      cartData
                    );

                    if (cartData) {
                      handleCartItemAdded(cartData);
                    }
                  }

                  setTimeout(function () {
                    if (typeof window.applyCartDrawerDiscounts === "function") {
                      window.applyCartDrawerDiscounts();
                    }
                    if (typeof window.applyCartPageDiscounts === "function") {
                      window.applyCartPageDiscounts();
                    }
                  }, 400);
                })
                .catch(function (error) {
                  formSubmitted = false;
                  console.error("[FORM-SUBMIT] Error adding to cart:", error);
                  submitButtons.forEach(function (submitButton) {
                    submitButton.classList.remove("thb-loading");
                    submitButton.removeAttribute("aria-disabled");
                  });
                });

              return false;
            }
          } else {
            console.log(
              "[FORM-SUBMIT-DEBUG] No variantId found, letting theme handle"
            );
          }
        } else {
          console.log(
            "[FORM-SUBMIT-DEBUG] No variantIdInput found, letting theme handle"
          );
        }

        console.log(
          "[FORM-SUBMIT-DEBUG] Returning undefined, letting theme handle submission"
        );
      };
    }

    var submitHandled = false;
    var handleFormSubmitOnce = function (e) {
      if (submitHandled) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
      submitHandled = true;
      var result = handleFormSubmit(e);

      var discountsWrapper = document.querySelector(
        "[data-product-discounts-wrapper]"
      );
      if (!discountsWrapper) {
        submitHandled = false;
        return;
      }

      setTimeout(function () {
        submitHandled = false;
      }, 1000);
      return result;
    };

    form.addEventListener("submit", handleFormSubmitOnce, true);

    if (productFormElement) {
      var originalOnSubmit = productFormElement.onSubmitHandler;
      console.log(
        "[FORM-SUBMIT-DEBUG] productFormElement found, originalOnSubmit:",
        !!originalOnSubmit
      );
      if (originalOnSubmit) {
        productFormElement.onSubmitHandler = function (evt) {
          console.log(
            "[FORM-SUBMIT-DEBUG] product-form onSubmitHandler called",
            {
              formSubmitted: formSubmitted,
            }
          );
          if (formSubmitted) {
            console.log(
              "[FORM-SUBMIT-DEBUG] Form submitted flag is true, preventing original handler"
            );
            evt.preventDefault();
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            return false;
          }
          return originalOnSubmit.call(this, evt);
        };
      }
      productFormElement.addEventListener("submit", handleFormSubmitOnce, true);
    }

    form.addEventListener("submit", function (e) {
      if (formSubmitted) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
      setTimeout(function () {
        try {
          var variantIdInput = form.querySelector('input[name="id"]');
          if (variantIdInput) {
            var variantId = variantIdInput.value;
            if (variantId) {
              var variantIdStr = String(variantId).trim();
              var existingDiscount =
                window.getVariantDiscountData(variantIdStr);
              if (existingDiscount && existingDiscount.title) {
                return;
              }
              var activeDiscount = getDiscountPreferenceWithPriority();
              if (!activeDiscount || activeDiscount.trim() === "") {
                return;
              }
              var discountPercentage = 0;
              var selectedDiscountTitle = activeDiscount.trim();
              var discountsScript = document.querySelector(
                '[data-product-discounts-wrapper] script[type="application/json"]'
              );
              if (discountsScript && selectedDiscountTitle) {
                try {
                  var discounts = JSON.parse(
                    discountsScript.textContent.trim()
                  );
                  if (discounts && Array.isArray(discounts)) {
                    var exactDiscount = discounts.find(function (d) {
                      return d.title === selectedDiscountTitle;
                    });
                    if (
                      exactDiscount &&
                      exactDiscount.percentage !== undefined
                    ) {
                      discountPercentage = exactDiscount.percentage;
                      selectedDiscountTitle =
                        exactDiscount.title || selectedDiscountTitle;
                    }
                  }
                } catch (e) {
                  console.error(
                    "[DEBUG] Error parsing discounts in form submit:",
                    e
                  );
                }
              }

              setTimeout(function () {
                try {
                  window.saveVariantDiscount(
                    variantIdStr,
                    selectedDiscountTitle,
                    discountPercentage
                  );
                } catch (e) {
                  console.error(
                    "[DEBUG] Error saving variant discount in form submit:",
                    e
                  );
                }
              }, 500);
            }
          }
        } catch (e) {
          console.error("[DEBUG] Error in form submit listener:", e);
        }
      }, 300);
    });
  }

  initializeFormInterception();

  if (typeof window.applyCartDrawerDiscounts === "undefined") {
    window.applyCartDrawerDiscounts = function () {
      fetch("/cart.js")
        .then(function (response) {
          return response.json();
        })
        .then(function (cartData) {
          setTimeout(function () {
            applyCartDrawerDiscountsInternal(cartData);
          }, 100);
        })
        .catch(function (error) {
          console.error("[DRAWER] Error fetching cart data:", error);
          setTimeout(function () {
            applyCartDrawerDiscountsInternal(null);
          }, 100);
        });
    };

    function applyCartDrawerDiscountsInternal(cartData) {
      setTimeout(function () {
        var userRemovedDiscountGlobal = window.hasNoDiscountPreference();
        if (userRemovedDiscountGlobal) {
          var allDrawerItems = document.querySelectorAll(".mini_cart_item");
          allDrawerItems.forEach(function (item) {
            try {
              var shopifyPill = item.querySelector(".custom-discount-pill");
              if (shopifyPill) shopifyPill.remove();
              var customPill = item.querySelector(
                '.selected-applied-discount[id="applied-discount-cart-drawer"]'
              );
              if (customPill) customPill.remove();
              var priceSpan = item.querySelector(".price");
              if (priceSpan) {
                var del = priceSpan.querySelector("del");
                var ins = priceSpan.querySelector("ins");
                if (del || ins) {
                  var originalCents = 0;
                  var delAmount = del ? del.querySelector(".amount") : null;
                  if (delAmount) {
                    var originalText = delAmount.textContent.trim();
                    originalCents = window.parseMoneyTextToCents(originalText);
                  } else {
                    var amountEl = priceSpan.querySelector(".amount");
                    if (amountEl) {
                      var priceText = amountEl.textContent.trim();
                      originalCents = window.parseMoneyTextToCents(priceText);
                    }
                  }
                  if (originalCents > 0) {
                    var cce =
                      window.currencyCodeEnabled !== undefined
                        ? window.currencyCodeEnabled
                        : true;
                    var formattedPrice = window.formatMoney(originalCents, cce);
                    var qtyText = item.querySelector(".mini-quantity");
                    var quantity = 1;
                    if (qtyText) {
                      var qtyMatch = qtyText.textContent.match(/\d+/);
                      if (qtyMatch) quantity = parseInt(qtyMatch[0]);
                    }
                    if (del) del.remove();
                    if (ins) ins.remove();
                    priceSpan.innerHTML =
                      '<span class="mini-quantity">' +
                      quantity +
                      " ×</span> " +
                      '<span class="amount">' +
                      formattedPrice +
                      "</span>";
                  }
                }
              }
            } catch (e) {
              console.error("[DEBUG] Error resetting drawer item:", e);
            }
          });
          recomputeDrawerSubtotalFromDOM();
          return;
        }
        var cartItems = document.querySelectorAll(".mini_cart_item");
        var drawerTotals = { original: 0, discounted: 0 };
        cartItems.forEach(function (item, itemIndex) {
          try {
            var isMontageProduct = false;
            var productHandle = item.getAttribute("data-product-handle");
            if (productHandle) {
              isMontageProduct =
                productHandle === "montage" ||
                productHandle === "montage-zubehor";
            }

            if (!isMontageProduct) {
              var productLink = item.querySelector(
                ".mini_cart_item_content h3 a, .mini_cart_item_content h3 span"
              );
              if (productLink) {
                var productTitle = productLink.textContent.trim().toLowerCase();
                isMontageProduct = productTitle.includes("montage");
              }
            }

            if (isMontageProduct) {
              var existingDiscountPill = item.querySelector(
                '.selected-applied-discount[id="applied-discount-cart-drawer"]'
              );
              if (existingDiscountPill) {
                existingDiscountPill.remove();
              }
              var shopifyPill = item.querySelector(".custom-discount-pill");
              if (shopifyPill) {
                shopifyPill.remove();
              }
              return;
            }

            var variantIdMatch = item.id.match(/CartDrawerItem-(\d+)/);
            var button = item.querySelector(".remove[data-id]");
            var variantId = null;

            variantId = item.getAttribute("data-variant-id");

            if (!variantId && item.dataset && item.dataset.variantId) {
              variantId = item.dataset.variantId;
            }
            if (!variantId && button) {
              variantId = button.getAttribute("data-id");
            }
            if (!variantId && variantIdMatch && cartData && cartData.items) {
              var itemIndex = parseInt(variantIdMatch[1], 10);

              if (itemIndex > 0 && itemIndex <= cartData.items.length) {
                var cartItem = cartData.items[itemIndex - 1];

                if (cartItem && cartItem.variant_id) {
                  variantId = String(cartItem.variant_id);
                }
              }
            }
            if (!variantId && variantIdMatch) {
              variantId = variantIdMatch[1];
            }

            if (variantId) {
              variantId = String(variantId).trim();
            }

            if (!variantId) {
              console.error(
                "[DRAWER-DEBUG] CRITICAL: No variant ID found for item!",
                {
                  itemId: item.id,
                  itemHTML: item.outerHTML.substring(0, 300),
                }
              );
              return;
            }

            var discountData = window.getVariantDiscountData(variantId);

            var buttonMapping = window.getButtonDiscountMapping();
            var assemblyPreference = window.getAssemblyPreference();
            var buttonNumber = assemblyPreference || 1;
            var targetDiscountTitle = null;

            if (
              buttonMapping &&
              (buttonMapping.button1 || buttonMapping.button2)
            ) {
              if (buttonNumber === 1) {
                targetDiscountTitle = buttonMapping.button1;
              } else if (buttonNumber === 2) {
                targetDiscountTitle = buttonMapping.button2;
              }
            }

            var variantDiscountsAttr = item.getAttribute(
              "data-variant-discounts"
            );

            try {
              var noDiscountVariants = JSON.parse(
                localStorage.getItem("noDiscountVariants") || "[]"
              );
              if (noDiscountVariants.indexOf(variantId) !== -1) {
                return;
              }
            } catch (e) {
              console.error(
                "[DRAWER-DEBUG] Error checking no-discount variants:",
                e
              );
            }

            if (variantDiscountsAttr && targetDiscountTitle) {
              try {
                var variantDiscounts = JSON.parse(variantDiscountsAttr);
                if (
                  variantDiscounts &&
                  Array.isArray(variantDiscounts) &&
                  variantDiscounts.length > 0
                ) {
                  var needsUpdate = false;

                  if (
                    !discountData ||
                    !discountData.title ||
                    discountData.title !== targetDiscountTitle
                  ) {
                    needsUpdate = true;
                  }

                  if (needsUpdate || !discountData || !discountData.title) {
                    var foundDiscount = variantDiscounts.find(function (d) {
                      return d.title && d.title.trim() === targetDiscountTitle;
                    });

                    if (foundDiscount) {
                      var discountPercentage = 0;
                      var discountValue = foundDiscount.value;

                      if (discountValue) {
                        if (discountValue.value !== undefined) {
                          var value = parseFloat(discountValue.value);
                          if (discountValue.type === "percentage") {
                            discountPercentage =
                              value <= 1 ? value * 100 : value;
                          } else {
                            discountPercentage = value * 100;
                          }
                        } else if (typeof discountValue === "number") {
                          discountPercentage =
                            discountValue <= 1
                              ? discountValue * 100
                              : discountValue;
                        } else if (typeof discountValue === "string") {
                          var parsed = parseFloat(discountValue);
                          discountPercentage =
                            parsed <= 1 ? parsed * 100 : parsed;
                        }
                      }

                      discountData = {
                        title: targetDiscountTitle,
                        percentage: discountPercentage,
                      };

                      window.saveVariantDiscount(
                        variantId,
                        targetDiscountTitle,
                        discountPercentage
                      );
                    }
                  }
                }
              } catch (e) {
                console.error(
                  "[DRAWER] Error parsing variant discounts from DOM:",
                  e
                );
              }
            }

            var priceSpan = item.querySelector(".price");
            var existingDiscountPill = item.querySelector(
              '.selected-applied-discount[id="applied-discount-cart-drawer"]'
            );
            var shopifyDiscountPill = item.querySelector(
              ".custom-discount-pill"
            );
            var userRemovedDiscount = window.hasNoDiscountPreference();

            if (shopifyDiscountPill) {
              if (userRemovedDiscount) {
                shopifyDiscountPill.remove();
                if (existingDiscountPill) {
                  existingDiscountPill.remove();
                }
                var priceSpan2 = item.querySelector(".price");
                if (priceSpan2) {
                  var delPrice2 = priceSpan2.querySelector("del .amount");
                  var originalPriceText2 = delPrice2
                    ? delPrice2.textContent.trim()
                    : priceSpan2.querySelector(".amount")
                    ? priceSpan2.querySelector(".amount").textContent.trim()
                    : "";
                  if (originalPriceText2) {
                    var originalCents2 =
                      window.parseMoneyTextToCents(originalPriceText2);
                    if (originalCents2 > 0) {
                      var quantity2 = 1;
                      var qtyText2 = item.querySelector(".mini-quantity");
                      if (qtyText2) {
                        var qtyMatch2 = qtyText2.textContent.match(/\d+/);
                        if (qtyMatch2) {
                          quantity2 = parseInt(qtyMatch2[0]);
                        }
                      }
                      var lineTotalCents2 = originalCents2 * quantity2;
                      var currencyCodeEnabled2 =
                        window.currencyCodeEnabled !== undefined
                          ? window.currencyCodeEnabled
                          : true;
                      var formattedPrice2 = window.formatMoney(
                        originalCents2,
                        currencyCodeEnabled2
                      );
                      var formattedLineTotal2 = window.formatMoney(
                        lineTotalCents2,
                        currencyCodeEnabled2
                      );
                      var delElement = priceSpan2.querySelector("del");
                      var insElement = priceSpan2.querySelector("ins");
                      if (delElement) delElement.remove();
                      if (insElement) insElement.remove();
                      priceSpan2.innerHTML =
                        '<span class="mini-quantity">' +
                        quantity2 +
                        " ×</span> " +
                        '<span class="amount">' +
                        formattedPrice2 +
                        "</span>";
                      drawerTotals.original += lineTotalCents2;
                      drawerTotals.discounted += lineTotalCents2;
                    }
                  }
                }
                return;
              }
            }
            if (shopifyDiscountPill && !userRemovedDiscount) {
              if (
                discountData &&
                discountData.title &&
                discountData.title.trim() !== ""
              ) {
                shopifyDiscountPill.remove();
                if (existingDiscountPill) {
                  existingDiscountPill.remove();
                }
              } else {
                if (existingDiscountPill) {
                  existingDiscountPill.remove();
                }
                try {
                  var delAmt = item.querySelector(".price del .amount");
                  var insAmt = item.querySelector(".price ins .amount");
                  if (delAmt && insAmt) {
                    var oTxt = delAmt.textContent.trim();
                    var dTxt = insAmt.textContent.trim();
                    var oMatch = oTxt.match(/[\d'.,]+/);
                    var dMatch = dTxt.match(/[\d'.,]+/);
                    if (oMatch && dMatch) {
                      var oCents = Math.round(
                        parseFloat(
                          oMatch[0].replace(/[']/g, "").replace(/,/g, ".")
                        ) * 100
                      );
                      var dCents = Math.round(
                        parseFloat(
                          dMatch[0].replace(/[']/g, "").replace(/,/g, ".")
                        ) * 100
                      );
                      var qTxt = (
                        item.querySelector(".mini-quantity")?.textContent || "1"
                      ).replace(/[^0-9]/g, "");
                      var q = parseInt(qTxt || "1");
                      drawerTotals.original += oCents * (isNaN(q) ? 1 : q);
                      drawerTotals.discounted += dCents * (isNaN(q) ? 1 : q);
                    }
                  }
                } catch (e) {
                  console.error(
                    "[DEBUG] Error processing Shopify discount:",
                    e
                  );
                }
                return;
              }
            }
            if (
              discountData &&
              discountData.title &&
              discountData.title.trim() !== ""
            ) {
              if (
                priceSpan &&
                priceSpan.dataset.discountApplied === "true" &&
                existingDiscountPill
              ) {
                try {
                  var delAmt = item.querySelector(".price del .amount");
                  var insAmt = item.querySelector(".price ins .amount");
                  if (delAmt && insAmt) {
                    var oTxt = delAmt.textContent.trim();
                    var dTxt = insAmt.textContent.trim();
                    var oMatch = oTxt.match(/[\d'.,]+/);
                    var dMatch = dTxt.match(/[\d'.,]+/);
                    if (oMatch && dMatch) {
                      var oCents = Math.round(
                        parseFloat(
                          oMatch[0].replace(/[']/g, "").replace(/,/g, ".")
                        ) * 100
                      );
                      var dCents = Math.round(
                        parseFloat(
                          dMatch[0].replace(/[']/g, "").replace(/,/g, ".")
                        ) * 100
                      );
                      var qTxt = (
                        item.querySelector(".mini-quantity")?.textContent || "1"
                      ).replace(/[^0-9]/g, "");
                      var q = parseInt(qTxt || "1");
                      drawerTotals.original += oCents * (isNaN(q) ? 1 : q);
                      drawerTotals.discounted += dCents * (isNaN(q) ? 1 : q);
                    }
                  }
                } catch (e) {}
                return;
              }
              if (!priceSpan) {
                return;
              }
              var originalPrice = 0;

              var originalLinePriceAttr = item.getAttribute(
                "data-original-line-price"
              );
              if (originalLinePriceAttr) {
                var originalLinePrice = parseInt(originalLinePriceAttr) || 0;
                if (originalLinePrice > 0) {
                  var qtyText = (
                    item.querySelector(".mini-quantity")?.textContent || "1"
                  ).replace(/[^0-9]/g, "");
                  var qty = parseInt(qtyText || "1");
                  if (qty > 0) {
                    originalPrice = Math.round(originalLinePrice / qty);
                  } else {
                    originalPrice = originalLinePrice;
                  }
                }
              }

              if (!originalPrice) {
                var delAmountEl = priceSpan.querySelector("del .amount");
                if (delAmountEl) {
                  var delPriceText = delAmountEl.textContent.trim();
                  originalPrice = window.parseMoneyTextToCents(delPriceText);
                }
              }

              if (!originalPrice) {
                var dataOriginalPrice = item.getAttribute(
                  "data-original-price"
                );
                if (dataOriginalPrice) {
                  var dataPrice = parseInt(dataOriginalPrice) || 0;
                  if (dataPrice > 0) {
                    originalPrice = dataPrice;
                  }
                }
              }

              if (!originalPrice) {
                var insAmountEl = priceSpan.querySelector("ins .amount");
                if (insAmountEl) {
                  var insPriceText = insAmountEl.textContent.trim();
                  var insPrice = window.parseMoneyTextToCents(insPriceText);
                  if (
                    discountData.percentage > 0 &&
                    discountData.percentage < 100
                  ) {
                    originalPrice = Math.round(
                      insPrice / (1 - discountData.percentage / 100)
                    );
                  } else {
                    originalPrice = insPrice;
                  }
                }
              }

              if (!originalPrice) {
                var insAmountEl = priceSpan.querySelector("ins .amount");
                var delAmountEl = priceSpan.querySelector("del .amount");
                if (
                  discountData.percentage > 0 &&
                  discountData.percentage < 100
                ) {
                  if (insAmountEl) {
                    var discountedPriceText = insAmountEl.textContent.trim();
                    var discountedPrice =
                      window.parseMoneyTextToCents(discountedPriceText);
                    if (discountedPrice > 0) {
                      originalPrice = Math.round(
                        discountedPrice / (1 - discountData.percentage / 100)
                      );
                    }
                  }

                  if (!originalPrice && delAmountEl) {
                    var delPriceText = delAmountEl.textContent.trim();
                    var delPrice = window.parseMoneyTextToCents(delPriceText);

                    if (delPrice > 0 && discountData.percentage > 0) {
                      var potentialOriginal = Math.round(
                        delPrice / (1 - discountData.percentage / 100)
                      );

                      originalPrice = potentialOriginal;
                    }
                  }
                }
              }

              if (!originalPrice) {
                var delAmountEl = priceSpan.querySelector("del .amount");
                if (delAmountEl) {
                  var delPriceText = delAmountEl.textContent.trim();
                  originalPrice = window.parseMoneyTextToCents(delPriceText);
                }
              }

              if (!originalPrice) {
                var amountSpan = priceSpan.querySelector(".amount");
                if (amountSpan) {
                  var originalPriceText = amountSpan.textContent.trim();
                  originalPrice =
                    window.parseMoneyTextToCents(originalPriceText);
                }
              }

              if (!originalPrice) return;
              var discountPercentage = discountData.percentage || 0;
              var displayDiscountTitle = discountData.title;

              if (
                discountData.percentage === undefined ||
                discountData.percentage === 0
              ) {
                var discountsScript =
                  document.querySelector("#cart-drawer-discounts-data") ||
                  document.querySelector(
                    '[data-product-discounts-wrapper] script[type="application/json"]'
                  );
                if (discountsScript) {
                  try {
                    var discounts = JSON.parse(
                      discountsScript.textContent.trim()
                    );
                    if (discounts && Array.isArray(discounts)) {
                      var exactMatch = discounts.find(function (d) {
                        return d.title === discountData.title;
                      });
                      if (exactMatch) {
                        discountPercentage = exactMatch.percentage || 0;
                        displayDiscountTitle =
                          exactMatch.title || discountData.title;
                      }
                    }
                  } catch (e) {
                    console.error("[CART] Error resolving discount title:", e);
                  }
                }
              }
              if (!discountPercentage && existingDiscountPill) {
                try {
                  var pillText = existingDiscountPill.textContent || "";

                  var currencyCode = (window.shop_currency || "CHF").replace(
                    /[.*+?^${}()|[\]\\]/g,
                    "\\$&"
                  );
                  var mAmt = pillText.match(
                    new RegExp("-\\s*" + currencyCode + "\\s*([\\d'.,]+)", "i")
                  );
                  if (mAmt) {
                    var dCents = Math.round(
                      parseFloat(
                        mAmt[1].replace(/[']/g, "").replace(/,/g, ".")
                      ) * 100
                    );
                    if (originalPrice > 0 && dCents > 0) {
                      discountPercentage = Math.max(
                        0,
                        Math.min(100, (dCents / originalPrice) * 100)
                      );
                    }
                  }
                } catch (e) {}
              }
              if (discountPercentage > 0) {
                try {
                  var unitDiscountAmount = Math.round(
                    originalPrice * (discountPercentage / 100)
                  );
                  var finalPrice = originalPrice - unitDiscountAmount;
                  var qtyText = (
                    item.querySelector(".mini-quantity")?.textContent || "1"
                  ).replace(/[^0-9]/g, "");
                  var qty = parseInt(qtyText || "1");
                  var lineDiscountAmount =
                    unitDiscountAmount * (isNaN(qty) ? 1 : qty);
                  var currencyCodeEnabled =
                    window.currencyCodeEnabled !== undefined
                      ? window.currencyCodeEnabled
                      : true;
                  var formattedOriginal = window.formatMoney(
                    originalPrice,
                    currencyCodeEnabled
                  );
                  var formattedFinal = window.formatMoney(
                    finalPrice,
                    currencyCodeEnabled
                  );
                  var formattedDiscount = window.formatMoney(
                    lineDiscountAmount,
                    currencyCodeEnabled
                  );
                  var quantityText = "";
                  var existingQuantity =
                    priceSpan.querySelector(".mini-quantity");
                  if (existingQuantity) {
                    quantityText = existingQuantity.textContent || "";
                  }
                  priceSpan.innerHTML =
                    '<span class="mini-quantity">' +
                    quantityText +
                    "</span> " +
                    '<del class="price--compare"><span class="amount">' +
                    formattedOriginal +
                    "</span></del> " +
                    '<ins class="price--sale"><span class="amount">' +
                    formattedFinal +
                    "</span></ins>";
                  var discountPill = item.querySelector(
                    '.selected-applied-discount[id="applied-discount-cart-drawer"]'
                  );
                  if (!discountPill) {
                    var discountPillHtml =
                      '<div class="selected-applied-discount" id="applied-discount-cart-drawer">' +
                      '<span><svg width="12" height="12" aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg></span>' +
                      "<span>" +
                      displayDiscountTitle +
                      "</span>" +
                      '<button type="button" class="discount-pill-remove" onclick="window.removeDiscount && window.removeDiscount(\'' +
                      variantId +
                      '\'); return false;" aria-label="Remove discount" title="Remove discount">×</button>' +
                      "</div>";
                    var customPillContainer = item.querySelector(
                      ".mini_cart_item_content"
                    );

                    var insertionPoint = null;
                    var insertionMethod = "beforebegin";

                    if (customPillContainer) {
                      var priceSpanParent = priceSpan.parentElement;
                      if (
                        priceSpanParent &&
                        priceSpanParent === customPillContainer
                      ) {
                        var walker = document.createTreeWalker(
                          customPillContainer,
                          NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_ELEMENT,
                          null,
                          false
                        );
                        var node;
                        var foundStartComment = false;
                        while ((node = walker.nextNode())) {
                          if (node.nodeType === Node.COMMENT_NODE) {
                            var commentText = node.textContent.trim();
                            if (
                              commentText.includes("CUSTOM DISCOUNT PILL START")
                            ) {
                              foundStartComment = true;
                              insertionPoint = node;
                              insertionMethod = "afterend";
                              break;
                            }
                          }
                        }

                        if (!insertionPoint) {
                          var existingPills =
                            customPillContainer.querySelectorAll(
                              ".custom-discount-pill, .selected-applied-discount"
                            );
                          if (existingPills.length > 0) {
                            insertionPoint =
                              existingPills[existingPills.length - 1];
                            insertionMethod = "afterend";
                          } else {
                            insertionPoint = priceSpan;
                            insertionMethod = "beforebegin";
                          }
                        }
                      } else {
                        insertionPoint = priceSpan;
                        insertionMethod = "beforebegin";
                      }
                    } else {
                      var customPillEnd = item.querySelector(
                        ".custom-discount-pill:last-of-type, .selected-applied-discount:last-of-type"
                      );
                      if (customPillEnd) {
                        insertionPoint = customPillEnd;
                        insertionMethod = "afterend";
                      } else if (priceSpan) {
                        insertionPoint = priceSpan;
                        insertionMethod = "beforebegin";
                      }
                    }

                    if (insertionPoint) {
                      try {
                        if (insertionPoint.nodeType === Node.COMMENT_NODE) {
                          var tempDiv = document.createElement("div");
                          insertionPoint.parentNode.insertBefore(
                            tempDiv,
                            insertionPoint.nextSibling
                          );
                          tempDiv.innerHTML = discountPillHtml;
                          var pillElement = tempDiv.firstElementChild;
                          if (pillElement) {
                            tempDiv.parentNode.replaceChild(
                              pillElement,
                              tempDiv
                            );
                          } else {
                            tempDiv.remove();
                          }
                        } else {
                          insertionPoint.insertAdjacentHTML(
                            insertionMethod,
                            discountPillHtml
                          );
                        }
                      } catch (insertError) {
                        console.error(
                          "[DRAWER-DEBUG] Error inserting discount pill:",
                          insertError,
                          {
                            variantId: variantId,
                            insertionPoint: insertionPoint,
                            insertionMethod: insertionMethod,
                          }
                        );
                      }
                    } else {
                      console.error(
                        "[DRAWER-DEBUG] Could not find insertion point for discount pill, variant:",
                        variantId,
                        {
                          customPillContainer: !!customPillContainer,
                          priceSpan: !!priceSpan,
                        }
                      );
                    }
                  } else if (existingDiscountPill) {
                    var textSpan =
                      existingDiscountPill.querySelector("span:last-child");
                    if (textSpan) {
                      textSpan.textContent = displayDiscountTitle;
                    }
                    var removeBtn = existingDiscountPill.querySelector(
                      ".discount-pill-remove"
                    );
                    if (!removeBtn) {
                      var removeBtnHtml =
                        '<button type="button" class="discount-pill-remove" onclick="window.removeDiscount && window.removeDiscount(\'' +
                        variantId +
                        '\'); return false;" aria-label="Remove discount" title="Remove discount">×</button>';
                      existingDiscountPill.insertAdjacentHTML(
                        "beforeend",
                        removeBtnHtml
                      );
                    }
                  }

                  priceSpan.dataset.discountApplied = "true";
                  var qtyText = (
                    priceSpan.querySelector(".mini-quantity")?.textContent ||
                    "1"
                  ).replace(/[^0-9]/g, "");
                  var qty = parseInt(qtyText || "1");
                  var lineOrig = originalPrice * (isNaN(qty) ? 1 : qty);
                  var lineDisc = finalPrice * (isNaN(qty) ? 1 : qty);
                  drawerTotals.original += lineOrig;
                  drawerTotals.discounted += lineDisc;
                  try {
                    item.dataset.originalSubtotal = String(lineOrig);
                    item.dataset.discountedSubtotal = String(lineDisc);
                  } catch (e) {}
                } catch (e) {
                  console.error("[CART] Error applying discount:", e);
                }
              }
            } else {
              if (existingDiscountPill) {
                existingDiscountPill.remove();
              }
              if (priceSpan && priceSpan.dataset.discountApplied === "true") {
                delete priceSpan.dataset.discountApplied;
              }
              try {
                var delShown = item.querySelector(".price del .amount");
                var insShown = item.querySelector(".price ins .amount");
                if (delShown && insShown) {
                  var oTxt2 = delShown.textContent.trim();
                  var dTxt2 = insShown.textContent.trim();
                  var om2 = oTxt2.match(/[\d'.,]+/);
                  var dm2 = dTxt2.match(/[\d'.,]+/);
                  if (om2 && dm2) {
                    var oC2 = Math.round(
                      parseFloat(
                        om2[0].replace(/[']/g, "").replace(/,/g, ".")
                      ) * 100
                    );
                    var dC2 = Math.round(
                      parseFloat(
                        dm2[0].replace(/[']/g, "").replace(/,/g, ".")
                      ) * 100
                    );
                    var qTxt2 = (
                      item.querySelector(".mini-quantity")?.textContent || "1"
                    ).replace(/[^0-9]/g, "");
                    var q2 = parseInt(qTxt2 || "1");
                    drawerTotals.original += oC2 * (isNaN(q2) ? 1 : q2);
                    drawerTotals.discounted += dC2 * (isNaN(q2) ? 1 : q2);
                    return;
                  }
                }
              } catch (e) {}
              var centsNo = 0;
              var dsOrig = parseInt(item.dataset.originalPrice || "0");
              if (dsOrig && !isNaN(dsOrig)) {
                centsNo = dsOrig;
              } else {
                var amountSpanNo = item.querySelector(".price .amount");
                if (amountSpanNo) {
                  var txtNo = amountSpanNo.textContent.trim();
                  var mNo = txtNo.match(/[\d'.,]+/);
                  if (mNo) {
                    centsNo = Math.round(
                      parseFloat(
                        mNo[0].replace(/[']/g, "").replace(/,/g, ".")
                      ) * 100
                    );
                  }
                }
              }
              if (centsNo) {
                var qtyTextNo = (
                  item.querySelector(".mini-quantity")?.textContent || "1"
                ).replace(/[^0-9]/g, "");
                var qtyNo = parseInt(qtyTextNo || "1");
                var lineNo = centsNo * (isNaN(qtyNo) ? 1 : qtyNo);
                drawerTotals.original += lineNo;
                drawerTotals.discounted += lineNo;
              }
            }
          } catch (e) {
            console.error(
              "[DEBUG] Error processing cart item in applyCartDrawerDiscounts:",
              e
            );
          }
        });
        try {
          recomputeDrawerSubtotalFromDOM();
        } catch (e) {
          console.error("[DEBUG] Error in recomputeDrawerSubtotalFromDOM:", e);
        }
      }, 100);
    }
  }

  document.addEventListener("cart:refresh", function () {
    window.applyCartDrawerDiscounts();
  });
  document.addEventListener("line-item:change:end", function () {
    window.applyCartDrawerDiscounts();
  });

  if (typeof window.applyCartPageDiscounts === "undefined") {
    var applyCartPageDiscountsTimeout = null;
    var isApplyingCartPageDiscounts = false;
    window.applyCartPageDiscounts = function () {
      if (applyCartPageDiscountsTimeout) {
        clearTimeout(applyCartPageDiscountsTimeout);
        applyCartPageDiscountsTimeout = null;
      }

      if (isApplyingCartPageDiscounts) {
        if (applyCartPageDiscountsTimeout) {
          clearTimeout(applyCartPageDiscountsTimeout);
        }
        applyCartPageDiscountsTimeout = setTimeout(function () {
          isApplyingCartPageDiscounts = false;
          window.applyCartPageDiscounts();
        }, 200);
        return;
      }
      isApplyingCartPageDiscounts = true;

      applyCartPageDiscountsTimeout = setTimeout(function () {
        try {
          isApplyingCartPageDiscounts = false;
          applyCartPageDiscountsTimeout = null;
          var userRemovedDiscountGlobal = window.hasNoDiscountPreference();
          if (userRemovedDiscountGlobal) {
            var allRows = document.querySelectorAll('tr[id^="CartItem-"]');
            allRows.forEach(function (row) {
              try {
                var shopifyPills = row.querySelectorAll(".discounts__discount");
                shopifyPills.forEach(function (pill) {
                  pill.remove();
                });
                var customPill = row.querySelector(
                  '#applied-discount-cart-page, .selected-applied-discount[id="applied-discount-cart-page"]'
                );
                if (customPill) customPill.remove();
                var mobilePill = row.querySelector(
                  "#applied-discount-cart-page-mobile"
                );
                if (mobilePill) mobilePill.remove();
                var priceCell = row.querySelector(".product-price");
                if (priceCell) {
                  var priceSpan = priceCell.querySelector(".price");
                  if (priceSpan) {
                    var del = priceSpan.querySelector("del");
                    var ins = priceSpan.querySelector("ins");
                    if (del || ins) {
                      var originalCents = 0;
                      var delAmount = del ? del.querySelector(".amount") : null;
                      if (delAmount) {
                        var originalText = delAmount.textContent.trim();
                        originalCents =
                          window.parseMoneyTextToCents(originalText);
                      } else {
                        var dataPrice = priceCell.getAttribute("data-price");
                        if (dataPrice) {
                          originalCents = parseInt(dataPrice);
                        }
                      }
                      if (originalCents > 0) {
                        var cce =
                          window.currencyCodeEnabled !== undefined
                            ? window.currencyCodeEnabled
                            : true;
                        var formattedPrice = window.formatMoney(
                          originalCents,
                          cce
                        );
                        if (del) del.remove();
                        if (ins) ins.remove();
                        priceSpan.innerHTML =
                          '<span class="amount">' + formattedPrice + "</span>";
                        var subtotalCell =
                          row.querySelector(".product-subtotal");
                        if (subtotalCell) {
                          var subtotalPriceSpan =
                            subtotalCell.querySelector(".price");
                          if (subtotalPriceSpan) {
                            var subtotalDel =
                              subtotalPriceSpan.querySelector("del");
                            var subtotalIns =
                              subtotalPriceSpan.querySelector("ins");
                            if (subtotalDel) subtotalDel.remove();
                            if (subtotalIns) subtotalIns.remove();
                            var qtyInput = row.querySelector(
                              'input[name="updates[]"]'
                            );
                            var quantity = qtyInput
                              ? parseInt(qtyInput.value || "1")
                              : 1;
                            var lineTotal = originalCents * quantity;
                            var formattedLineTotal = window.formatMoney(
                              lineTotal,
                              cce
                            );
                            subtotalPriceSpan.innerHTML =
                              '<span class="amount">' +
                              formattedLineTotal +
                              "</span>";
                          }
                        }
                      }
                    }
                  }
                }
              } catch (e) {
                console.error("[DEBUG] Error resetting row:", e);
              }
            });
            recomputeCartPageSubtotalFromDOM();
            return;
          }
          var rows = document.querySelectorAll('tr[id^="CartItem-"]');
          var pageTotals = { original: 0, discounted: 0 };
          rows.forEach(function (row) {
            try {
              var isMontageProduct = false;
              var productName = row.querySelector(
                ".product-name a, .product-name span"
              );

              // Get variant ID first to check if it has a saved discount
              var keyForMontageCheck = row.getAttribute("data-product-id") || "";
              var matchForMontageCheck = keyForMontageCheck.match(/^(\d+)/);
              var variantIdForMontageCheck = matchForMontageCheck ? matchForMontageCheck[1] : null;
              var hasSavedDiscount = variantIdForMontageCheck && window.getVariantDiscountData(variantIdForMontageCheck);

              if (productName) {
                var productTitle = productName.textContent.trim().toLowerCase();
                // Only treat as montage if it has "montage" in title OR (no main-variant-id AND no saved discount)
                isMontageProduct =
                  productTitle.includes("montage") ||
                  (!row.hasAttribute("data-main-variant-id") && !hasSavedDiscount);
              } else {
                isMontageProduct = !row.hasAttribute("data-main-variant-id") && !hasSavedDiscount;
              }

              if (isMontageProduct) {
                var existingPill = row.querySelector(
                  "#applied-discount-cart-page, .selected-applied-discount[id='applied-discount-cart-page'], .discounts .selected-applied-discount"
                );
                if (existingPill) {
                  existingPill.remove();
                }
                var existingMobilePill = row.querySelector(
                  "#applied-discount-cart-page-mobile"
                );
                if (existingMobilePill) {
                  existingMobilePill.remove();
                }
                return;
              }

              var key = row.getAttribute("data-product-id") || "";
              var match = key.match(/^(\d+)/);
              if (!match) return;
              var variantId = match[1];
              var discountData = window.getVariantDiscountData(variantId);

              var buttonMapping = window.getButtonDiscountMapping();
              var assemblyPreference = window.getAssemblyPreference();
              var buttonNumber = assemblyPreference || 1;
              var targetDiscountTitle = null;

              if (
                buttonMapping &&
                (buttonMapping.button1 || buttonMapping.button2)
              ) {
                if (buttonNumber === 1) {
                  targetDiscountTitle = buttonMapping.button1;
                } else if (buttonNumber === 2) {
                  targetDiscountTitle = buttonMapping.button2;
                }
              }

              var variantDiscountsAttr = row.getAttribute(
                "data-variant-discounts"
              );

              try {
                var noDiscountVariants = JSON.parse(
                  localStorage.getItem("noDiscountVariants") || "[]"
                );
                if (noDiscountVariants.indexOf(variantId) !== -1) {
                  console.log(
                    "[CART-PAGE] Variant marked as no-discount, skipping:",
                    variantId
                  );
                  return;
                }
              } catch (e) {
                console.error(
                  "[CART-PAGE] Error checking no-discount variants:",
                  e
                );
              }

              if (variantDiscountsAttr && targetDiscountTitle) {
                try {
                  var variantDiscounts = JSON.parse(variantDiscountsAttr);
                  if (
                    variantDiscounts &&
                    Array.isArray(variantDiscounts) &&
                    variantDiscounts.length > 0
                  ) {
                    var needsUpdate = false;

                    if (
                      !discountData ||
                      !discountData.title ||
                      discountData.title !== targetDiscountTitle
                    ) {
                      needsUpdate = true;
                    }

                    if (needsUpdate || !discountData || !discountData.title) {
                      var foundDiscount = variantDiscounts.find(function (d) {
                        return (
                          d.title && d.title.trim() === targetDiscountTitle
                        );
                      });

                      if (foundDiscount) {
                        var discountPercentage = 0;
                        var discountValue = foundDiscount.value;

                        if (discountValue) {
                          if (discountValue.value !== undefined) {
                            var value = parseFloat(discountValue.value);
                            if (discountValue.type === "percentage") {
                              discountPercentage =
                                value <= 1 ? value * 100 : value;
                            } else {
                              discountPercentage = value * 100;
                            }
                          } else if (typeof discountValue === "number") {
                            discountPercentage =
                              discountValue <= 1
                                ? discountValue * 100
                                : discountValue;
                          } else if (typeof discountValue === "string") {
                            var parsed = parseFloat(discountValue);
                            discountPercentage =
                              parsed <= 1 ? parsed * 100 : parsed;
                          }
                        }

                        discountData = {
                          title: targetDiscountTitle,
                          percentage: discountPercentage,
                        };

                        window.saveVariantDiscount(
                          variantId,
                          targetDiscountTitle,
                          discountPercentage
                        );
                      }
                    }
                  }
                } catch (e) {
                  console.error(
                    "[CART] Error parsing variant discounts from DOM:",
                    e
                  );
                }
              }

              var priceCell = row.querySelector(".product-price");
              var subtotalCell = row.querySelector(".product-subtotal");
              var unitPriceSpan = priceCell
                ? priceCell.querySelector(".price")
                : null;
              var subtotalPriceSpan = subtotalCell
                ? subtotalCell.querySelector(".price")
                : null;
              if (!unitPriceSpan) return;
              var existingPill = row.querySelector(
                '#applied-discount-cart-page, .selected-applied-discount[id="applied-discount-cart-page"]'
              );
              var allShopifyPills = row.querySelectorAll(
                ".discounts__discount"
              );

              var userRemovedDiscount = window.hasNoDiscountPreference();
              if (userRemovedDiscount) {
                allShopifyPills.forEach(function (pill) {
                  pill.remove();
                });
                if (existingPill) {
                  existingPill.remove();
                }
                try {
                  var mobilePill = row.querySelector(
                    "#applied-discount-cart-page-mobile"
                  );
                  if (mobilePill) {
                    mobilePill.remove();
                  }
                } catch (e) {
                  console.error("[DEBUG] Error removing mobile pill:", e);
                }
                var priceCell2 = row.querySelector(
                  ".product-price, .cart-item__price"
                );
                if (priceCell2) {
                  var unitPriceSpan2 = priceCell2.querySelector(".price");
                  if (unitPriceSpan2) {
                    var hasDelOrIns =
                      unitPriceSpan2.querySelector("del") ||
                      unitPriceSpan2.querySelector("ins");
                    if (hasDelOrIns) {
                      var originalCents2 = 0;
                      var delAmount =
                        unitPriceSpan2.querySelector("del .amount");
                      if (delAmount) {
                        var originalPriceText = delAmount.textContent.trim();
                        originalCents2 =
                          window.parseMoneyTextToCents(originalPriceText);
                      } else {
                        var dataPrice = priceCell2.getAttribute("data-price");
                        if (dataPrice) {
                          originalCents2 = parseInt(dataPrice);
                        }
                      }
                      if (originalCents2 > 0) {
                        var currencyCodeEnabled2 =
                          window.currencyCodeEnabled !== undefined
                            ? window.currencyCodeEnabled
                            : true;
                        var formattedPrice2 = window.formatMoney(
                          originalCents2,
                          currencyCodeEnabled2
                        );
                        var quantity2 = 1;
                        var qtyInput2 = row.querySelector(
                          'input[name="updates[]"]'
                        );
                        if (qtyInput2) {
                          quantity2 = parseInt(qtyInput2.value || "1");
                        }
                        var lineTotalCents2 = originalCents2 * quantity2;
                        var formattedLineTotal2 = window.formatMoney(
                          lineTotalCents2,
                          currencyCodeEnabled2
                        );
                        var del = unitPriceSpan2.querySelector("del");
                        var ins = unitPriceSpan2.querySelector("ins");
                        if (del) del.remove();
                        if (ins) ins.remove();
                        unitPriceSpan2.innerHTML =
                          '<span class="amount">' + formattedPrice2 + "</span>";
                        var subtotalCell2 = row.querySelector(
                          ".product-subtotal, .cart-item__totals"
                        );
                        if (subtotalCell2) {
                          var subtotalPriceSpan2 =
                            subtotalCell2.querySelector(".price");
                          if (subtotalPriceSpan2) {
                            var subtotalDel =
                              subtotalPriceSpan2.querySelector("del");
                            var subtotalDelAmount = subtotalDel
                              ? subtotalDel.querySelector(".amount")
                              : null;
                            var originalLinePrice = 0;
                            if (subtotalDelAmount) {
                              var originalLineText =
                                subtotalDelAmount.textContent.trim();
                              originalLinePrice =
                                window.parseMoneyTextToCents(originalLineText);
                            } else {
                              var dataSubtotal =
                                subtotalCell2.getAttribute("data-subtotal");
                              if (dataSubtotal) {
                                originalLinePrice = parseInt(dataSubtotal);
                              }
                            }
                            if (originalLinePrice > 0) {
                              var formattedOriginalLineTotal =
                                window.formatMoney(
                                  originalLinePrice,
                                  currencyCodeEnabled2
                                );
                              var subtotalIns =
                                subtotalPriceSpan2.querySelector("ins");
                              if (subtotalDel) subtotalDel.remove();
                              if (subtotalIns) subtotalIns.remove();
                              subtotalPriceSpan2.innerHTML =
                                '<span class="amount">' +
                                formattedOriginalLineTotal +
                                "</span>";
                            } else {
                              var subtotalDel =
                                subtotalPriceSpan2.querySelector("del");
                              var subtotalIns =
                                subtotalPriceSpan2.querySelector("ins");
                              if (subtotalDel) subtotalDel.remove();
                              if (subtotalIns) subtotalIns.remove();
                              subtotalPriceSpan2.innerHTML =
                                '<span class="amount">' +
                                formattedLineTotal2 +
                                "</span>";
                            }
                          }
                        }
                      }
                    }
                  }
                }
                return;
              }
              if (allShopifyPills.length > 0 && !userRemovedDiscount) {
                allShopifyPills.forEach(function (pill) {
                  pill.remove();
                });
                try {
                  var mobilePill = row.querySelector(
                    "#applied-discount-cart-page-mobile"
                  );
                  if (mobilePill) {
                    mobilePill.remove();
                  }
                } catch (e) {
                  console.error("[DEBUG] Error removing mobile pill:", e);
                }
                if (existingPill) {
                  existingPill.remove();
                }
                if (
                  !discountData ||
                  !discountData.title ||
                  discountData.title.trim() === ""
                ) {
                  return;
                }
              }
              if (
                discountData &&
                discountData.title &&
                discountData.title.trim() !== ""
              ) {
                var qtyInput = row.querySelector('input[name="updates[]"]');
                var quantity = qtyInput ? parseInt(qtyInput.value || "1") : 1;
                var discountPercentage = discountData.percentage || 0;
                var displayDiscountTitle = discountData.title;

                if (
                  discountData.percentage === undefined ||
                  discountData.percentage === 0
                ) {
                  var ds =
                    document.querySelector("#main-cart-discounts-data") ||
                    document.querySelector(
                      '[data-product-discounts-wrapper] script[type="application/json"]'
                    );
                  if (ds) {
                    try {
                      var discounts = JSON.parse(ds.textContent.trim());
                      if (discounts && Array.isArray(discounts)) {
                        var exactMatch = discounts.find(function (d) {
                          return d.title === discountData.title;
                        });
                        if (exactMatch) {
                          discountPercentage = exactMatch.percentage || 0;
                          displayDiscountTitle =
                            exactMatch.title || discountData.title;
                        }
                      }
                    } catch (e) {
                      console.error(
                        "[CART] Error resolving discount title:",
                        e
                      );
                    }
                  }
                }

                var unitOriginal = 0;
                if (subtotalPriceSpan) {
                  var subtotalDelAmount =
                    subtotalPriceSpan.querySelector("del .amount");
                  if (subtotalDelAmount) {
                    var subtotalDelTxt = subtotalDelAmount.textContent.trim();
                    var subtotalOriginal =
                      window.parseMoneyTextToCents(subtotalDelTxt);
                    if (subtotalOriginal > 0) {
                      var qtyInputForPrice = row.querySelector(
                        'input[name="updates[]"]'
                      );
                      var qtyForPrice = qtyInputForPrice
                        ? parseInt(qtyInputForPrice.value || "1")
                        : 1;
                      if (qtyForPrice > 0) {
                        unitOriginal = Math.round(
                          subtotalOriginal / qtyForPrice
                        );
                      } else {
                        unitOriginal = subtotalOriginal;
                      }
                    }
                  }
                }
                if (!unitOriginal) {
                  var delAmountEl = unitPriceSpan.querySelector("del .amount");
                  if (delAmountEl) {
                    var delTxt = delAmountEl.textContent.trim();
                    unitOriginal = window.parseMoneyTextToCents(delTxt);
                  }
                }
                if (!unitOriginal) {
                  var unitAmountEl = unitPriceSpan.querySelector(".amount");
                  if (
                    unitAmountEl &&
                    !unitPriceSpan.querySelector("del") &&
                    !unitPriceSpan.querySelector("ins")
                  ) {
                    var txt = unitAmountEl.textContent.trim();
                    unitOriginal = window.parseMoneyTextToCents(txt);
                  }
                }
                if (!unitOriginal && priceCell) {
                  var unitAttr = priceCell.getAttribute("data-price");
                  if (unitAttr) {
                    var dataPriceValue = parseInt(unitAttr);
                    if (
                      dataPriceValue > 0 &&
                      discountPercentage > 0 &&
                      discountPercentage < 100
                    ) {
                      unitOriginal = Math.round(
                        dataPriceValue / (1 - discountPercentage / 100)
                      );
                    } else if (dataPriceValue > 0) {
                      unitOriginal = dataPriceValue;
                    }
                  }
                }
                if (
                  !unitOriginal &&
                  discountPercentage > 0 &&
                  discountPercentage < 100
                ) {
                  var mobilePriceWrap =
                    row.querySelector(".product-mobile-price.price") ||
                    row.querySelector(".product-mobile-price");
                  if (mobilePriceWrap) {
                    var mobileAmountEl =
                      mobilePriceWrap.querySelector(".amount");
                    if (
                      mobileAmountEl &&
                      !mobilePriceWrap.querySelector("del") &&
                      !mobilePriceWrap.querySelector("ins")
                    ) {
                      var mobilePriceText = mobileAmountEl.textContent.trim();
                      var mobilePriceCents =
                        window.parseMoneyTextToCents(mobilePriceText);
                      if (mobilePriceCents > 0) {
                        var qtyInputForMobile = row.querySelector(
                          'input[name="updates[]"]'
                        );
                        var qtyForMobile = qtyInputForMobile
                          ? parseInt(qtyInputForMobile.value || "1")
                          : 1;
                        if (qtyForMobile > 0) {
                          var subtotalFinalFromMobile = mobilePriceCents;
                          var subtotalOriginalFromMobile = Math.round(
                            subtotalFinalFromMobile /
                              (1 - discountPercentage / 100)
                          );
                          unitOriginal = Math.round(
                            subtotalOriginalFromMobile / qtyForMobile
                          );
                        }
                      }
                    }
                  }
                  if (!unitOriginal && subtotalPriceSpan) {
                    var subtotalAmountEl =
                      subtotalPriceSpan.querySelector(".amount");
                    if (
                      subtotalAmountEl &&
                      !subtotalPriceSpan.querySelector("del") &&
                      !subtotalPriceSpan.querySelector("ins")
                    ) {
                      var subtotalText = subtotalAmountEl.textContent.trim();
                      var subtotalCents =
                        window.parseMoneyTextToCents(subtotalText);
                      if (subtotalCents > 0) {
                        var qtyInputForSubtotal = row.querySelector(
                          'input[name="updates[]"]'
                        );
                        var qtyForSubtotal = qtyInputForSubtotal
                          ? parseInt(qtyInputForSubtotal.value || "1")
                          : 1;
                        if (qtyForSubtotal > 0) {
                          var subtotalOriginalFromSubtotal = Math.round(
                            subtotalCents / (1 - discountPercentage / 100)
                          );
                          unitOriginal = Math.round(
                            subtotalOriginalFromSubtotal / qtyForSubtotal
                          );
                        }
                      }
                    }
                  }
                }
                if (!unitOriginal) return;
                if (discountPercentage > 0) {
                  var unitDiscount = Math.round(
                    unitOriginal * (discountPercentage / 100)
                  );
                  var unitFinal = unitOriginal - unitDiscount;
                  var subtotalOriginal = unitOriginal * quantity;
                  var subtotalDiscount = unitDiscount * quantity;
                  var subtotalFinal = subtotalOriginal - subtotalDiscount;
                  var cce =
                    window.currencyCodeEnabled !== undefined
                      ? window.currencyCodeEnabled
                      : true;
                  var formattedUnitOriginal = window.formatMoney(
                    unitOriginal,
                    cce
                  );
                  var formattedUnitFinal = window.formatMoney(unitFinal, cce);
                  var formattedDiscount = window.formatMoney(
                    subtotalDiscount,
                    cce
                  );
                  var formattedSubtotalFinal = subtotalPriceSpan
                    ? window.formatMoney(subtotalFinal, cce)
                    : null;
                  if (subtotalPriceSpan && formattedSubtotalFinal) {
                    var formattedSubtotalOriginal = window.formatMoney(
                      subtotalOriginal,
                      cce
                    );
                    subtotalPriceSpan.innerHTML =
                      '<del><span class="amount">' +
                      formattedSubtotalOriginal +
                      "</span></del> " +
                      '<ins><span class="amount">' +
                      formattedSubtotalFinal +
                      "</span></ins>";
                    try {
                      subtotalPriceSpan.style.display = "inline-flex";
                      subtotalPriceSpan.style.alignItems = "center";
                    } catch (e) {}
                  }
                  try {
                    var mobilePriceWrap =
                      row.querySelector(".product-mobile-price.price") ||
                      row.querySelector(".product-mobile-price");
                    if (mobilePriceWrap) {
                      var formattedSubtotalOriginal2 = window.formatMoney(
                        subtotalOriginal,
                        cce
                      );
                      var formattedSubtotalFinal2 = window.formatMoney(
                        subtotalFinal,
                        cce
                      );
                      mobilePriceWrap.innerHTML =
                        '<del><span class="amount">' +
                        formattedSubtotalOriginal2 +
                        "</span></del> " +
                        '<ins><span class="amount">' +
                        formattedSubtotalFinal2 +
                        "</span></ins>";
                    }
                  } catch (e) {}
                  if (!existingPill) {
                    var pillHtml =
                      '<li class="discounts__discount selected-applied-discount" id="applied-discount-cart-page">' +
                      '<span><svg width="12" height="12" aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg></span>' +
                      "<span>" +
                      displayDiscountTitle +
                      "</span>" +
                      '<button type="button" class="discount-pill-remove" onclick="window.removeDiscount && window.removeDiscount(\'' +
                      variantId +
                      '\'); return false;" aria-label="Remove discount" title="Remove discount">×</button>' +
                      "</li>";
                    var discountsList = row.querySelector(".discounts");
                    if (discountsList) {
                      discountsList.insertAdjacentHTML("beforeend", pillHtml);
                    } else {
                      var metaText = row.querySelector(".cart__meta-text");
                      var insertAfter =
                        metaText || row.querySelector(".cart__meta h3");
                      if (insertAfter) {
                        var newList =
                          '<ul class="discounts" role="list">' +
                          pillHtml +
                          "</ul>";
                        insertAfter.insertAdjacentHTML("afterend", newList);
                      } else {
                        if (unitPriceSpan) {
                          unitPriceSpan.insertAdjacentHTML(
                            "afterend",
                            pillHtml
                          );
                        }
                      }
                    }
                    try {
                      var mobilePriceEl = row.querySelector(
                        ".product-mobile-price"
                      );
                      if (mobilePriceEl) {
                        var mobilePill = mobilePriceEl.parentNode.querySelector(
                          "#applied-discount-cart-page-mobile"
                        );
                        if (!mobilePill) {
                          var mobilePillHtml =
                            '<div class="selected-applied-discount" id="applied-discount-cart-page-mobile">' +
                            '<span><svg width="12" height="12" aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor"></path></svg></span>' +
                            "<span>" +
                            displayDiscountTitle +
                            "</span>" +
                            '<button type="button" class="discount-pill-remove" onclick="window.removeDiscount && window.removeDiscount(\'' +
                            variantId +
                            '\'); return false;" aria-label="Remove discount" title="Remove discount">×</button>' +
                            "</div>";
                          mobilePriceEl.insertAdjacentHTML(
                            "afterend",
                            mobilePillHtml
                          );
                        }
                        var discountsListMobile =
                          row.querySelector("ul.discounts");
                        if (discountsListMobile) {
                          discountsListMobile.style.display = "none";
                        }
                      }
                    } catch (e) {}
                  } else {
                    var textSpan =
                      existingPill.querySelector("span:last-child");
                    if (textSpan) {
                      textSpan.textContent = displayDiscountTitle;
                    }
                    var removeBtn = existingPill.querySelector(
                      ".discount-pill-remove"
                    );
                    if (!removeBtn) {
                      var removeBtnHtml =
                        '<button type="button" class="discount-pill-remove" onclick="window.removeDiscount && window.removeDiscount(\'' +
                        variantId +
                        '\'); return false;" aria-label="Remove discount" title="Remove discount">×</button>';
                      existingPill.insertAdjacentHTML(
                        "beforeend",
                        removeBtnHtml
                      );
                    }
                    try {
                      var mPill = row.querySelector(
                        "#applied-discount-cart-page-mobile"
                      );
                      if (mPill) {
                        var mTextSpan = mPill.querySelector("span:last-child");
                        if (mTextSpan) {
                          mTextSpan.textContent = displayDiscountTitle;
                        }
                        var mRemoveBtn = mPill.querySelector(
                          ".discount-pill-remove"
                        );
                        if (!mRemoveBtn) {
                          var mRemoveBtnHtml =
                            '<button type="button" class="discount-pill-remove" onclick="window.removeDiscount && window.removeDiscount(\'' +
                            variantId +
                            '\'); return false;" aria-label="Remove discount" title="Remove discount">×</button>';
                          mPill.insertAdjacentHTML("beforeend", mRemoveBtnHtml);
                        }
                      }
                    } catch (e) {}
                  }
                  pageTotals.original += subtotalOriginal;
                  pageTotals.discounted += subtotalFinal;
                }
              } else {
                if (existingPill) existingPill.remove();
                try {
                  var existingMobile = row.querySelector(
                    "#applied-discount-cart-page-mobile"
                  );
                  if (existingMobile) existingMobile.remove();
                } catch (e) {}
                var baseSubtotalAttr = row
                  .querySelector(".product-subtotal")
                  ?.getAttribute("data-subtotal");
                var baseSubtotal = baseSubtotalAttr
                  ? parseInt(baseSubtotalAttr)
                  : 0;
                if (baseSubtotal) {
                  pageTotals.original += baseSubtotal;
                  pageTotals.discounted += baseSubtotal;
                  try {
                    var mobilePriceWrap2 = row.querySelector(
                      ".product-mobile-price.price"
                    );
                    if (mobilePriceWrap2) {
                      mobilePriceWrap2.textContent = window.formatMoney(
                        baseSubtotal,
                        cce
                      );
                    }
                  } catch (e) {}
                }
              }
            } catch (e) {}
          });
          try {
            recomputeCartPageSubtotalFromDOM();
          } catch (e) {}
        } catch (e) {
          console.error(e);
          isApplyingCartPageDiscounts = false;
          applyCartPageDiscountsTimeout = null;
        }
      }, 150);
    };
  }

  var cartUpdateTimeout = null;
  function handleCartPageUpdate() {
    if (!/\/cart(\?|$|\/?$)/.test(window.location.pathname)) {
      return;
    }

    if (cartUpdateTimeout) {
      clearTimeout(cartUpdateTimeout);
    }

    cartUpdateTimeout = setTimeout(function () {
      cartUpdateTimeout = null;
      window.applyCartPageDiscounts();
      setTimeout(recomputeCartPageSubtotalFromDOM, 200);
      try {
        setupCheckoutDiscountRedirects();
      } catch (e) {
        console.error("[CHK] update error", e);
      }
    }, 300);
  }

  document.addEventListener("cart:refresh", handleCartPageUpdate);
  document.addEventListener("line-item:change:end", handleCartPageUpdate);
  // Listen for cart refresh complete event (dispatched after HTML is updated)
  document.addEventListener("cart:refresh:complete", function() {
    console.log("[CART] cart:refresh:complete - applying discounts after HTML update");
    setTimeout(function() {
      window.applyCartPageDiscounts();
      recomputeCartPageSubtotalFromDOM();
    }, 100);
  });

  if (/\/cart(\?|$|\/?$)/.test(window.location.pathname)) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        setTimeout(window.applyCartPageDiscounts, 350);
        setTimeout(recomputeCartPageSubtotalFromDOM, 500);
        setTimeout(setupCheckoutDiscountRedirects, 700);
      });
    } else {
      setTimeout(window.applyCartPageDiscounts, 350);
      setTimeout(recomputeCartPageSubtotalFromDOM, 500);
      setTimeout(setupCheckoutDiscountRedirects, 700);
    }
  }

  function handleMontageProductRemoval() {
    if (isRemovingProduct) {
      return;
    }
    isRemovingProduct = true;
    var domItemsByVariantId = {};

    var drawerItems = document.querySelectorAll(
      ".mini_cart_item[data-variant-id][data-product-handle]"
    );
    drawerItems.forEach(function (item) {
      var variantId = item.getAttribute("data-variant-id");
      var handle = item.getAttribute("data-product-handle") || "";
      if (variantId && !domItemsByVariantId[variantId]) {
        domItemsByVariantId[variantId] = handle;
      }
    });

    var mainCartItems = document.querySelectorAll(
      "tr[id^='CartItem-'][data-variant-id][data-product-handle]"
    );
    mainCartItems.forEach(function (item) {
      var variantId = item.getAttribute("data-variant-id");
      var handle = item.getAttribute("data-product-handle") || "";
      if (variantId && !domItemsByVariantId[variantId]) {
        domItemsByVariantId[variantId] = handle;
      }
    });

    fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (cartData) {
        if (!cartData || !cartData.items || cartData.items.length === 0) {
          isRemovingProduct = false;
          return;
        }

        var montageItemsToRemove = [];
        var mainProductVariantIds = [];

        cartData.items.forEach(function (item, index) {
          var productHandle =
            domItemsByVariantId[String(item.variant_id)] || "";
          var isMontage =
            productHandle === "montage" || productHandle === "montage-zubehor";

          if (isMontage) {
            montageItemsToRemove.push({
              key: item.key,
              variant_id: item.variant_id,
              handle: productHandle,
              line: index + 1,
            });
          } else if (item.variant_id) {
            mainProductVariantIds.push(String(item.variant_id));
          }
        });

        var button1DiscountTitle = null;
        var button1DiscountPercentage = 0;

        try {
          var buttonMapping = sessionStorage.getItem("buttonDiscountMapping");
          if (buttonMapping) {
            var mapping = JSON.parse(buttonMapping);
            button1DiscountTitle = mapping.button1;
          }
        } catch (e) {
          console.error("[MONTAGE] Error getting button mapping:", e);
        }

        if (!button1DiscountTitle) {
          var button1 = document.querySelector(
            "#discount-button-1, .discount-button[data-discount-title]"
          );
          if (button1) {
            button1DiscountTitle = button1.getAttribute("data-discount-title");
          }
        }

        if (button1DiscountTitle) {
          try {
            var discountsScript = document.querySelector(
              'script[id^="discounts-data-"]'
            );
            if (discountsScript) {
              var discountsData = JSON.parse(discountsScript.textContent);
              if (discountsData && Array.isArray(discountsData)) {
                var foundDiscount = discountsData.find(function (discount) {
                  return (
                    discount.title &&
                    discount.title.trim() === button1DiscountTitle
                  );
                });
                if (foundDiscount && foundDiscount.percentage !== undefined) {
                  button1DiscountPercentage =
                    parseFloat(foundDiscount.percentage) || 0;
                }
              }
            }
          } catch (e) {}

          if (
            button1DiscountPercentage === 0 &&
            mainProductVariantIds.length > 0
          ) {
            try {
              var variantDiscounts = JSON.parse(
                localStorage.getItem("variantDiscounts") || "{}"
              );

              for (var i = 0; i < mainProductVariantIds.length; i++) {
                var variantId = mainProductVariantIds[i];
                var existingDiscount = variantDiscounts[variantId];
                if (
                  existingDiscount &&
                  existingDiscount.title === button1DiscountTitle &&
                  existingDiscount.percentage > 0
                ) {
                  button1DiscountPercentage = existingDiscount.percentage;
                  break;
                }
              }
            } catch (e) {}
          }
        }

        if (button1DiscountTitle) {
          try {
            var variantDiscounts = JSON.parse(
              localStorage.getItem("variantDiscounts") || "{}"
            );
            mainProductVariantIds.forEach(function (variantId) {
              variantDiscounts[variantId] = {
                title: button1DiscountTitle,
                percentage: button1DiscountPercentage,
              };
            });
            localStorage.setItem(
              "variantDiscounts",
              JSON.stringify(variantDiscounts)
            );
          } catch (e) {
            console.error("[MONTAGE] Error updating discounts:", e);
          }

          try {
            localStorage.setItem("cartLockedDiscountPreference", "1");
            localStorage.setItem("assemblyPreference", "1");
          } catch (e) {
            console.error("[MONTAGE] Error locking discount preference:", e);
          }
        }

        if (montageItemsToRemove.length > 0) {
          var removeSequentially = function (items, index) {
            if (index >= items.length) {
              try {
                localStorage.removeItem("variantRelationships");
                console.log(
                  "[MONTAGE] Cleared variantRelationships - all montage products removed"
                );
              } catch (e) {
                console.error(
                  "[MONTAGE] Error clearing variantRelationships:",
                  e
                );
              }

              fetch("/cart.js")
                .then(function (response) {
                  return response.json();
                })
                .then(function (cartData) {
                  if (
                    !cartData ||
                    !cartData.items ||
                    cartData.items.length === 0
                  ) {
                    try {
                      localStorage.removeItem("cartLockedDiscountPreference");
                    } catch (e) {
                      console.error(
                        "[MONTAGE] Error clearing locked discount preference:",
                        e
                      );
                    }
                  }
                })
                .catch(function (error) {
                  console.error(
                    "[MONTAGE] Error checking cart state after removal:",
                    error
                  );
                });

              fetch("/cart.js")
                .then(function (response) {
                  return response.json();
                })
                .then(function (cartData) {
                  if (window.location.pathname.includes("/cart")) {
                    fetch("/?sections=main-cart,cart-drawer,cart-bubble")
                      .then(function (response) {
                        return response.json();
                      })
                      .then(function (sectionsData) {
                        if (sectionsData && sectionsData.sections) {
                          var mainCartSection =
                            sectionsData.sections["main-cart"];
                          var cartDrawerSection =
                            sectionsData.sections["cart-drawer"];
                          if (mainCartSection) {
                            var mainCartEl =
                              document.getElementById("main-cart-items");
                            if (mainCartEl) {
                              mainCartEl.innerHTML = mainCartSection;
                            }
                          }
                          if (cartDrawerSection) {
                            var drawerEl =
                              document.getElementById("Cart-Drawer");
                            if (drawerEl) {
                              var selector = ".cart-drawer__inner";
                              var inner =
                                drawerEl.querySelector(selector) || drawerEl;
                              inner.innerHTML = cartDrawerSection;
                            }
                          }
                        }

                        document.dispatchEvent(new CustomEvent("cart:refresh"));
                        document.dispatchEvent(new Event("theme:cart:refresh"));
                        document.dispatchEvent(new Event("thb:cart:update"));
                        document.dispatchEvent(
                          new Event("cart-drawer:refresh")
                        );

                        setTimeout(function () {
                          if (
                            typeof window.applyCartDrawerDiscounts ===
                            "function"
                          ) {
                            window.applyCartDrawerDiscounts();
                          }
                          if (
                            typeof window.recomputeDrawerSubtotalFromDOM ===
                            "function"
                          ) {
                            window.recomputeDrawerSubtotalFromDOM();
                          }
                        }, 300);

                        setTimeout(function () {
                          isRemovingProduct = false;
                        }, 400);
                      })
                      .catch(function (error) {
                        console.error(
                          "[MONTAGE] Error fetching sections:",
                          error
                        );
                        isRemovingProduct = false;
                      });
                  } else {
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                    document.dispatchEvent(new Event("theme:cart:refresh"));
                    document.dispatchEvent(new Event("thb:cart:update"));
                    document.dispatchEvent(new Event("cart-drawer:refresh"));

                    setTimeout(function () {
                      if (
                        typeof window.applyCartDrawerDiscounts === "function"
                      ) {
                        window.applyCartDrawerDiscounts();
                      }
                      if (
                        typeof window.recomputeDrawerSubtotalFromDOM ===
                        "function"
                      ) {
                        window.recomputeDrawerSubtotalFromDOM();
                      }
                    }, 300);

                    setTimeout(function () {
                      isRemovingProduct = false;
                    }, 400);
                  }
                })
                .catch(function (error) {
                  console.error(
                    "[MONTAGE] Error fetching cart after removal:",
                    error
                  );
                  isRemovingProduct = false;
                });
              return;
            }

            var itemToRemove = items[index];
            var delay = index === 0 ? 200 : 300;

            var drawerItem = document.querySelector(
              '[id^="CartDrawerItem-"][data-variant-id="' +
                itemToRemove.variant_id +
                '"]'
            );
            if (drawerItem) {
              drawerItem.classList.add("thb-loading");
            }

            var cartItem = document.querySelector(
              'tr[id^="CartItem-"][data-variant-id="' +
                itemToRemove.variant_id +
                '"]'
            );
            if (cartItem) {
              cartItem.classList.add("thb-loading");
            }

            var drawerItemRef = drawerItem;
            var cartItemRef = cartItem;

            setTimeout(function () {
              if (
                itemToRemove.handle !== "montage" &&
                itemToRemove.handle !== "montage-zubehor"
              ) {
                console.error(
                  "[MONTAGE] SKIPPING - Item handle is not montage:",
                  itemToRemove.handle,
                  "for variant",
                  itemToRemove.variant_id
                );
                removeSequentially(items, index + 1);
                return;
              }

              if (!itemToRemove.key) {
                console.error(
                  "[MONTAGE] No cart item key found for variant",
                  itemToRemove.variant_id,
                  "- skipping"
                );
                removeSequentially(items, index + 1);
                return;
              }

              fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  id: itemToRemove.key,
                  quantity: 0,
                }),
              })
                .then(function (response) {
                  if (!response.ok) {
                    return response.text().then(function (errorText) {
                      var errorDetails = "";
                      try {
                        var errorJson = JSON.parse(errorText);
                        errorDetails = JSON.stringify(errorJson);
                      } catch (e) {
                        errorDetails = errorText;
                      }

                      if (response.status === 400 || response.status === 422) {
                      } else {
                        console.error(
                          "[MONTAGE] Error removing cart item key",
                          itemToRemove.key,
                          ":",
                          response.status,
                          response.statusText
                        );
                        if (errorDetails) {
                          console.error(
                            "[MONTAGE] Error details:",
                            errorDetails
                          );
                        }
                      }

                      if (drawerItemRef && drawerItemRef.parentNode) {
                        drawerItemRef.classList.remove("thb-loading");
                      }
                      if (cartItemRef && cartItemRef.parentNode) {
                        cartItemRef.classList.remove("thb-loading");
                      }

                      removeSequentially(items, index + 1);
                      return null;
                    });
                  }
                  return response.json();
                })
                .then(function (cartResponse) {
                  if (drawerItemRef && drawerItemRef.parentNode) {
                    drawerItemRef.classList.remove("thb-loading");
                  }
                  if (cartItemRef && cartItemRef.parentNode) {
                    cartItemRef.classList.remove("thb-loading");
                  }

                  if (cartResponse !== null) {
                    removeSequentially(items, index + 1);
                  }
                })
                .catch(function (error) {
                  if (drawerItemRef && drawerItemRef.parentNode) {
                    drawerItemRef.classList.remove("thb-loading");
                  }
                  if (cartItemRef && cartItemRef.parentNode) {
                    cartItemRef.classList.remove("thb-loading");
                  }

                  console.error(
                    "[MONTAGE] Error removing cart item key",
                    itemToRemove.key,
                    ":",
                    error
                  );

                  removeSequentially(items, index + 1);
                });
            }, delay);
          };

          removeSequentially(montageItemsToRemove, 0);
        } else {
          if (window.location.pathname.includes("/cart")) {
            fetch("/?sections=main-cart,cart-drawer,cart-bubble")
              .then(function (response) {
                return response.json();
              })
              .then(function (sectionsData) {
                if (sectionsData && sectionsData.sections) {
                  var mainCartSection = sectionsData.sections["main-cart"];
                  var cartDrawerSection = sectionsData.sections["cart-drawer"];
                  if (mainCartSection) {
                    var mainCartEl = document.getElementById("main-cart-items");
                    if (mainCartEl) {
                      mainCartEl.innerHTML = mainCartSection;
                    }
                  }
                  if (cartDrawerSection) {
                    var drawerEl = document.getElementById("Cart-Drawer");
                    if (drawerEl) {
                      var selector = ".cart-drawer__inner";
                      var inner = drawerEl.querySelector(selector) || drawerEl;
                      inner.innerHTML = cartDrawerSection;
                    }
                  }
                }

                document.dispatchEvent(new CustomEvent("cart:refresh"));
                document.dispatchEvent(new Event("theme:cart:refresh"));
                document.dispatchEvent(new Event("thb:cart:update"));
                document.dispatchEvent(new Event("cart-drawer:refresh"));

                setTimeout(function () {
                  isRemovingProduct = false;
                }, 400);
              })
              .catch(function (error) {
                console.error("[MONTAGE] Error fetching sections:", error);
                isRemovingProduct = false;
              });
          } else {
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              isRemovingProduct = false;
            }, 300);
          }
        }
      })
      .catch(function (error) {
        console.error("[MONTAGE] Error fetching cart:", error);
        isRemovingProduct = false;
      });
  }

  function removeLinkedVariantsForMainProduct(
    mainItemVariantId,
    linkedVariantIdsParam,
    mainProductInfo
  ) {
    if (isSyncingMontage) {
      return;
    }

    try {
      var linkedVariantIds = linkedVariantIdsParam;

      if (!linkedVariantIds) {
        var variantRelationships = JSON.parse(
          localStorage.getItem("variantRelationships") || "{}"
        );
        linkedVariantIds = variantRelationships[String(mainItemVariantId)];
      }

      console.log(
        "[REMOVE-LINKED] Starting removal for main product:",
        mainItemVariantId
      );
      console.log("[REMOVE-LINKED] linkedVariantIds:", linkedVariantIds);
      console.log("[REMOVE-LINKED] mainProductInfo:", mainProductInfo);

      if (
        !linkedVariantIds ||
        !Array.isArray(linkedVariantIds) ||
        linkedVariantIds.length === 0
      ) {
        console.log("[REMOVE-LINKED] No linked variants found, cleaning up");
        try {
          var variantRelationships = JSON.parse(
            localStorage.getItem("variantRelationships") || "{}"
          );
          delete variantRelationships[String(mainItemVariantId)];
          localStorage.setItem(
            "variantRelationships",
            JSON.stringify(variantRelationships)
          );
        } catch (e) {
          console.error(
            "[REMOVE-LINKED] Error cleaning up variantRelationships:",
            e
          );
        }
        return;
      }

      isSyncingMontage = true;

      var propertyLabel = {
        en: "For",
        de: "Für",
        fr: "Pour",
        it: "Per",
      };
      var currentLocale = document.documentElement.lang || "en";
      var langCode = currentLocale.split("-")[0].toLowerCase();
      if (!propertyLabel[langCode]) {
        langCode = "en";
      }
      var propertyKey = propertyLabel[langCode];

      var expectedPropertyValue = null;
      if (mainProductInfo) {
        var combinedTitle =
          mainProductInfo.product_title || mainProductInfo.title || "";
        if (
          mainProductInfo.variant_title &&
          mainProductInfo.variant_title !== "Default Title"
        ) {
          combinedTitle = combinedTitle + " " + mainProductInfo.variant_title;
        }
        expectedPropertyValue = combinedTitle;
      }

      fetch("/cart.js")
        .then(function (response) {
          return response.json();
        })
        .then(function (cartData) {
          if (!cartData || !cartData.items) {
            isSyncingMontage = false;
            return;
          }

          var itemsToRemove = [];

          cartData.items.forEach(function (item, index) {
            var itemVariantId = String(item.variant_id);
            var isLinkedVariant =
              linkedVariantIds.indexOf(itemVariantId) !== -1;

            if (isLinkedVariant) {
              var shouldRemove = false;

              if (expectedPropertyValue && propertyKey) {
                var itemProperties = item.properties || {};
                var itemPropertyValue = itemProperties[propertyKey];

                if (itemPropertyValue) {
                  shouldRemove =
                    String(itemPropertyValue) === String(expectedPropertyValue);
                  console.log("[REMOVE-LINKED] Property check:", {
                    itemPropertyValue: itemPropertyValue,
                    expectedPropertyValue: expectedPropertyValue,
                    matches: shouldRemove,
                  });
                } else {
                  shouldRemove = false;
                  console.log(
                    "[REMOVE-LINKED] Montage product has no 'For' property, skipping"
                  );
                }
              } else {
                // If we don't have main product info, fall back to old behavior
                // (remove all matching variant IDs)
                shouldRemove = true;
                console.log(
                  "[REMOVE-LINKED] No main product info, using variant ID only match"
                );
              }

              if (shouldRemove) {
                console.log(
                  "[REMOVE-LINKED] Adding to removal list:",
                  itemVariantId,
                  "with properties:",
                  item.properties
                );
                itemsToRemove.push({
                  line: index + 1,
                  variantId: itemVariantId,
                  key: item.key,
                });
              } else {
                console.log(
                  "[REMOVE-LINKED] Skipping item (properties don't match):",
                  itemVariantId
                );
              }
            }
          });

          console.log(
            "[REMOVE-LINKED] Items to remove:",
            itemsToRemove.length,
            itemsToRemove
          );

          if (itemsToRemove.length === 0) {
            try {
              var variantRelationships = JSON.parse(
                localStorage.getItem("variantRelationships") || "{}"
              );
              if (
                variantRelationships &&
                typeof variantRelationships === "object"
              ) {
                delete variantRelationships[String(mainItemVariantId)];
                localStorage.setItem(
                  "variantRelationships",
                  JSON.stringify(variantRelationships)
                );
              }
            } catch (e) {
              console.error(
                "[REMOVE-LINKED] Error cleaning up variantRelationships:",
                e
              );
            }
            isSyncingMontage = false;
            return;
          }

          try {
            var variantRelationships = JSON.parse(
              localStorage.getItem("variantRelationships") || "{}"
            );
            if (
              variantRelationships &&
              typeof variantRelationships === "object"
            ) {
              delete variantRelationships[String(mainItemVariantId)];
              localStorage.setItem(
                "variantRelationships",
                JSON.stringify(variantRelationships)
              );
            }
          } catch (e) {
            console.error(
              "[REMOVE-LINKED] Error cleaning up variantRelationships:",
              e
            );
          }

          itemsToRemove.forEach(function (item) {
            var drawerItem = document.querySelector(
              '.mini_cart_item[data-variant-id="' + item.variantId + '"]'
            );
            if (drawerItem) {
              drawerItem.classList.add("thb-loading");
            }

            var cartRow = document.querySelector(
              'tr[id^="CartItem-"][data-variant-id="' + item.variantId + '"]'
            );
            if (cartRow) {
              cartRow.classList.add("thb-loading");
            }
          });

          var removeSequentially = function (items, index) {
            if (index >= items.length) {
              isSyncingMontage = false;
              setTimeout(function () {
                document.dispatchEvent(new CustomEvent("cart:refresh"));
              }, 300);
              return;
            }
            var itemToRemove = items[index];

            setTimeout(
              function () {
                var drawerItemRef = document.querySelector(
                  '.mini_cart_item[data-variant-id="' +
                    itemToRemove.variantId +
                    '"]'
                );
                var cartRowRef = document.querySelector(
                  'tr[id^="CartItem-"][data-variant-id="' +
                    itemToRemove.variantId +
                    '"]'
                );

                fetch("/cart/change.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({
                    id: itemToRemove.key || itemToRemove.line,
                    quantity: 0,
                  }),
                })
                  .then(function (response) {
                    if (!response.ok && response.status !== 422) {
                      if (drawerItemRef && drawerItemRef.parentNode) {
                        drawerItemRef.classList.remove("thb-loading");
                      }
                      if (cartRowRef && cartRowRef.parentNode) {
                        cartRowRef.classList.remove("thb-loading");
                      }
                    }
                    return response.json();
                  })
                  .then(function () {
                    if (drawerItemRef && drawerItemRef.parentNode) {
                      drawerItemRef.classList.remove("thb-loading");
                    }
                    if (cartRowRef && cartRowRef.parentNode) {
                      cartRowRef.classList.remove("thb-loading");
                    }
                    setTimeout(function () {
                      removeSequentially(items, index + 1);
                    }, 300);
                  })
                  .catch(function (error) {
                    if (drawerItemRef && drawerItemRef.parentNode) {
                      drawerItemRef.classList.remove("thb-loading");
                    }
                    if (cartRowRef && cartRowRef.parentNode) {
                      cartRowRef.classList.remove("thb-loading");
                    }
                    setTimeout(function () {
                      removeSequentially(items, index + 1);
                    }, 300);
                  })
                  .finally(function () {
                    if (index >= items.length - 1) {
                      isSyncingMontage = false;
                    }
                  });
              },
              index === 0 ? 200 : 300
            );
          };
          removeSequentially(itemsToRemove, 0);
        })
        .catch(function (error) {
          console.error("[SYNC] Error:", error);
          isSyncingMontage = false;
        });
    } catch (error) {
      console.error("[SYNC] Error:", error);
      isSyncingMontage = false;
    }
  }

  function findAndSyncMontageProducts(
    mainItemIndex,
    mainItemVariantId,
    newQuantity
  ) {
    if (isSyncingMontage) {
      return;
    }

    isSyncingMontage = true;

    try {
      var variantRelationships = {};
      try {
        variantRelationships = JSON.parse(
          localStorage.getItem("variantRelationships") || "{}"
        );
      } catch (e) {}

      var linkedVariantIds = variantRelationships[String(mainItemVariantId)];
      if (
        !linkedVariantIds ||
        !Array.isArray(linkedVariantIds) ||
        linkedVariantIds.length === 0
      ) {
        isSyncingMontage = false;
        return;
      }

      fetch("/cart.js")
        .then(function (response) {
          return response.json();
        })
        .then(function (cartData) {
          if (!cartData || !cartData.items) {
            isSyncingMontage = false;
            return;
          }

          var montageItemsToUpdate = [];
          var montageItemsToRemove = [];

          cartData.items.forEach(function (item, index) {
            var itemLine = index + 1;
            var itemVariantId = String(item.variant_id);

            if (linkedVariantIds.indexOf(itemVariantId) !== -1) {
              if (newQuantity === 0 || newQuantity === "0") {
                montageItemsToRemove.push({
                  line: itemLine,
                  variantId: itemVariantId,
                });
              } else {
                montageItemsToUpdate.push({
                  line: itemLine,
                  variantId: itemVariantId,
                  quantity: parseInt(newQuantity) || 1,
                });
              }
            }
          });

          if (
            (newQuantity === 0 || newQuantity === "0") &&
            montageItemsToRemove.length > 0
          ) {
            try {
              var variantRelationships = JSON.parse(
                localStorage.getItem("variantRelationships") || "{}"
              );
              delete variantRelationships[String(mainItemVariantId)];
              localStorage.setItem(
                "variantRelationships",
                JSON.stringify(variantRelationships)
              );
            } catch (e) {
              console.error("[SYNC] Error removing variant relationship:", e);
            }
          }

          if (montageItemsToRemove.length > 0) {
            montageItemsToRemove.forEach(function (item) {
              var drawerItem = document.querySelector(
                '.mini_cart_item[data-variant-id="' + item.variantId + '"]'
              );
              if (drawerItem) {
                drawerItem.classList.add("thb-loading");
              }

              var cartRow = document.querySelector(
                'tr[id^="CartItem-"][data-variant-id="' + item.variantId + '"]'
              );
              if (cartRow) {
                cartRow.classList.add("thb-loading");
              }
            });

            var removeSequentially = function (items, index) {
              if (index >= items.length) {
                isSyncingMontage = false;
                setTimeout(function () {
                  document.dispatchEvent(new CustomEvent("cart:refresh"));
                }, 300);
                return;
              }
              var itemToRemove = items[index];

              var delay = index === 0 ? 200 : 300;
              setTimeout(function () {
                var drawerItemRef = document.querySelector(
                  '.mini_cart_item[data-variant-id="' +
                    itemToRemove.variantId +
                    '"]'
                );
                var cartRowRef = document.querySelector(
                  'tr[id^="CartItem-"][data-variant-id="' +
                    itemToRemove.variantId +
                    '"]'
                );

                fetch("/cart/change.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({
                    line: itemToRemove.line,
                    quantity: 0,
                  }),
                })
                  .then(function (response) {
                    if (!response.ok) {
                      if (response.status === 422) {
                      } else {
                        console.error(
                          "[SYNC] Error removing line",
                          itemToRemove.line,
                          ":",
                          response.status,
                          response.statusText
                        );
                      }

                      if (drawerItemRef && drawerItemRef.parentNode) {
                        drawerItemRef.classList.remove("thb-loading");
                      }
                      if (cartRowRef && cartRowRef.parentNode) {
                        cartRowRef.classList.remove("thb-loading");
                      }
                      return null;
                    }
                    return response.json();
                  })
                  .then(function () {
                    if (drawerItemRef && drawerItemRef.parentNode) {
                      drawerItemRef.classList.remove("thb-loading");
                    }
                    if (cartRowRef && cartRowRef.parentNode) {
                      cartRowRef.classList.remove("thb-loading");
                    }
                    setTimeout(function () {
                      removeSequentially(items, index + 1);
                    }, 300);
                  })
                  .catch(function (error) {
                    console.error(
                      "[SYNC] Error removing line",
                      itemToRemove.line,
                      ":",
                      error
                    );

                    if (drawerItemRef && drawerItemRef.parentNode) {
                      drawerItemRef.classList.remove("thb-loading");
                    }
                    if (cartRowRef && cartRowRef.parentNode) {
                      cartRowRef.classList.remove("thb-loading");
                    }
                    setTimeout(function () {
                      removeSequentially(items, index + 1);
                    }, 300);
                  })
                  .finally(function () {
                    if (index >= items.length - 1) {
                      isSyncingMontage = false;
                    }
                  });
              }, delay);
            };
            removeSequentially(montageItemsToRemove, 0);
          } else if (montageItemsToUpdate.length > 0) {
            var updateSequentially = function (updates, index) {
              if (index >= updates.length) {
                isSyncingMontage = false;
                document.dispatchEvent(new CustomEvent("cart:refresh"));
                return;
              }
              var updateItem = updates[index];
              fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  line: updateItem.line,
                  quantity: updateItem.quantity,
                }),
              })
                .then(function (response) {
                  if (!response.ok) {
                    if (response.status === 422) {
                    } else {
                      console.error(
                        "[SYNC] Error updating line",
                        updateItem.line,
                        ":",
                        response.status,
                        response.statusText
                      );
                    }
                    return null;
                  }
                  return response.json();
                })
                .then(function () {
                  setTimeout(function () {
                    updateSequentially(updates, index + 1);
                  }, 300);
                })
                .catch(function (error) {
                  console.error(
                    "[SYNC] Error updating line",
                    updateItem.line,
                    ":",
                    error
                  );
                  setTimeout(function () {
                    updateSequentially(updates, index + 1);
                  }, 300);
                })
                .finally(function () {
                  if (index >= updates.length - 1) {
                    isSyncingMontage = false;
                  }
                });
            };
            updateSequentially(montageItemsToUpdate, 0);
          } else {
            isSyncingMontage = false;
          }
        })
        .catch(function (error) {
          console.error("[SYNC] Error syncing montage products:", error);
          isSyncingMontage = false;
        });
    } catch (e) {
      console.error("[SYNC] Error in findAndSyncMontageProducts:", e);
      isSyncingMontage = false;
    }
  }

  var quantityChangeTimeout = null;
  var lastQuantityChange = { line: null, quantity: null, variantId: null };
  var isSyncingMontage = false;
  var isRemovingProduct = false;
  var removeProductDebounceTimeout = null;

  function handleQuantityChangeSync(line, variantId, quantity) {
    clearTimeout(quantityChangeTimeout);
    quantityChangeTimeout = setTimeout(function () {
      if (line && variantId && quantity !== null) {
        fetch("/cart.js")
          .then(function (response) {
            return response.json();
          })
          .then(function (cartData) {
            if (!cartData || !cartData.items) {
              return;
            }
            var item = cartData.items[line - 1];
            if (item && item.product_handle !== "montage") {
              findAndSyncMontageProducts(line, variantId, quantity);
            } else {
            }
          })
          .catch(function (error) {
            console.error(
              "[QTY] Error syncing montage after quantity change:",
              error
            );
          });
      }
    }, 600);
  }

  document.addEventListener(
    "change",
    function (e) {
      if (
        e.target &&
        e.target.classList.contains("qty") &&
        e.target.hasAttribute("data-index")
      ) {
        var line = parseInt(e.target.getAttribute("data-index")) || null;
        var quantity = parseInt(e.target.value) || 0;
        if (!line || quantity < 0) {
          return;
        }

        var row =
          e.target.closest('tr[id^="CartItem-"]') ||
          e.target.closest('[id^="CartDrawerItem-"]');
        if (!row) {
          return;
        }

        var variantId = null;
        var variantIdEl = row.querySelector("[data-variant-id]");
        if (variantIdEl) {
          variantId = variantIdEl.getAttribute("data-variant-id");
        } else {
          var productIdAttr = row.getAttribute("data-product-id");
          if (productIdAttr) {
            var m = productIdAttr.match(/^(\d+)/);
            if (m) {
              variantId = m[1];
            }
          }
        }

        if (!variantId) {
          return;
        }

        var productLink = row.querySelector(
          ".cart-product-link, .mini_cart_item_content h3 a, .mini_cart_item_content h3 span"
        );
        var isMontage = false;

        if (productLink) {
          var productTitle = productLink.textContent.trim().toLowerCase();
          isMontage = productTitle.includes("montage");
        }

        if (!isMontage && variantId) {
          lastQuantityChange = {
            line: line,
            quantity: quantity,
            variantId: variantId,
          };
          handleQuantityChangeSync(line, variantId, quantity);
        }
      }
    },
    true
  );

  var previousCartItemCount = null;

  document.addEventListener("line-item:change:end", function (event) {
    try {
      if (isSyncingMontage) {
        return;
      }

      var shouldCleanup = false;
      if (event.detail) {
        if (event.detail.quantity === 0 || event.detail.quantity === "0") {
          shouldCleanup = true;
        }
        if (event.detail.cart && event.detail.cart.items) {
          var currentItemCount = event.detail.cart.items.length;
          if (
            previousCartItemCount !== null &&
            currentItemCount < previousCartItemCount
          ) {
            shouldCleanup = true;
          }
          previousCartItemCount = currentItemCount;
        }
      }

      if (shouldCleanup) {
        setTimeout(window.cleanuplocalStorageForRemovedItems, 1000);
      }

      if (
        event.detail &&
        event.detail.cart &&
        event.detail.cart.items &&
        event.detail.cart.items.length === 0
      ) {
        try {
          localStorage.removeItem("cartLockedDiscountPreference");
        } catch (e) {
          console.error(
            "[CLEANUP] Error clearing locked discount preference:",
            e
          );
        }
      }

      if (event.detail && event.detail.cart && event.detail.cart.items) {
        var changedLine = null;
        var changedItem = null;

        for (var i = 0; i < event.detail.cart.items.length; i++) {
          var item = event.detail.cart.items[i];
          if (item && item.product_handle !== "montage") {
            var currentLine = i + 1;
            var qtyInput = document.querySelector(
              'input.qty[data-index="' + currentLine + '"]'
            );
            if (qtyInput && !qtyInput.classList.contains("thb-loading")) {
              var currentQty = parseInt(qtyInput.value) || 0;
              if (
                currentQty === item.quantity &&
                currentQty !== lastQuantityChange.quantity
              ) {
                changedLine = currentLine;
                changedItem = item;
                break;
              }
            }
          }
        }

        if (changedLine && changedItem) {
          setTimeout(function () {
            findAndSyncMontageProducts(
              changedLine,
              changedItem.variant_id,
              changedItem.quantity
            );
          }, 300);
        }
      }
    } catch (e) {
      console.error("[QTY] Error in line-item:change:end handler:", e);
    }
  });

  document.addEventListener(
    "click",
    function (e) {
      var target = e.target;
      if (!target) return;
      var drawerRemove =
        target.closest && target.closest(".mini_cart_item .remove[data-id]");
      if (drawerRemove) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        var itemIndex = drawerRemove.getAttribute("data-index");
        var cartItem = drawerRemove.closest('[id^="CartDrawerItem-"]');
        if (cartItem) {
          var variantId = null;

          if (cartItem.hasAttribute("data-variant-id")) {
            variantId = cartItem.getAttribute("data-variant-id");
          } else if (drawerRemove.hasAttribute("data-id")) {
            variantId = drawerRemove.getAttribute("data-id");
          }

          if (variantId) {
            try {
              var st = localStorage.getItem("variantDiscounts");
              if (st) {
                var mp = JSON.parse(st);
                if (mp && mp[variantId]) {
                  delete mp[variantId];
                  localStorage.setItem("variantDiscounts", JSON.stringify(mp));
                }
              }
            } catch (e) {}

            var isMontage = false;
            var productHandle = cartItem.getAttribute("data-product-handle");

            if (productHandle) {
              isMontage =
                productHandle === "montage" ||
                productHandle === "montage-zubehor";
            } else {
              var productLink = cartItem.querySelector(
                ".mini_cart_item_content h3 a, .mini_cart_item_content h3 span"
              );
              if (productLink) {
                var productTitle = productLink.textContent.trim().toLowerCase();
                isMontage = productTitle.includes("montage");
              }
            }

            if (isMontage) {
              if (!isRemovingProduct) {
                handleMontageProductRemoval();
              }
              setTimeout(window.cleanuplocalStorageForRemovedItems, 1000);
              setTimeout(recomputeDrawerSubtotalFromDOM, 120);
              return;
            }

            if (!isMontage && variantId && itemIndex) {
              isRemovingProduct = true;

              var linkedVariantIdsToRemove = null;
              var mainProductInfo = null;

              // Get main product info and linked variants before removal
              fetch("/cart.js")
                .then(function (response) {
                  return response.json();
                })
                .then(function (cartDataBeforeRemoval) {
                  if (cartDataBeforeRemoval && cartDataBeforeRemoval.items) {
                    // Find the main product in cart before removal
                    var mainItem = cartDataBeforeRemoval.items.find(function (
                      item
                    ) {
                      return String(item.variant_id) === String(variantId);
                    });
                    if (mainItem) {
                      mainProductInfo = {
                        product_title: mainItem.product_title,
                        title: mainItem.title,
                        variant_title: mainItem.variant_title,
                      };
                      console.log(
                        "[REMOVE] Captured main product info:",
                        mainProductInfo
                      );
                    }
                  }

                  try {
                    var variantRelationships = JSON.parse(
                      localStorage.getItem("variantRelationships") || "{}"
                    );
                    linkedVariantIdsToRemove =
                      variantRelationships[String(variantId)];
                    console.log(
                      "[REMOVE] Captured linked variants before removal:",
                      linkedVariantIdsToRemove
                    );
                  } catch (e) {
                    console.error(
                      "[REMOVE] Error reading variantRelationships:",
                      e
                    );
                  }

                  // Now remove the main product
                  return fetch("/cart/change.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Accept: "application/json",
                    },
                    body: JSON.stringify({
                      line: parseInt(itemIndex, 10),
                      quantity: 0,
                      sections: ["cart-drawer"],
                      sections_url: window.location.pathname,
                    }),
                  });
                })
                .then(function (response) {
                  return response.json();
                })
                .then(function (cartData) {
                  if (!isRemovingProduct) {
                    return;
                  }

                  if (
                    !cartData ||
                    !cartData.items ||
                    cartData.items.length === 0
                  ) {
                    try {
                      localStorage.removeItem("cartLockedDiscountPreference");
                    } catch (e) {
                      console.error(
                        "[REMOVE] Error clearing locked preference:",
                        e
                      );
                    }
                  }

                  if (
                    cartData &&
                    cartData.items &&
                    cartData.items.length > 0 &&
                    linkedVariantIdsToRemove
                  ) {
                    removeLinkedVariantsForMainProduct(
                      variantId,
                      linkedVariantIdsToRemove,
                      mainProductInfo
                    );
                  }

                  setTimeout(function () {
                    isRemovingProduct = false;
                    document.dispatchEvent(new CustomEvent("cart:refresh"));
                  }, 300);
                })
                .catch(function (error) {
                  console.error("[REMOVE] Error removing item:", error);
                  isRemovingProduct = false;
                });
            } else if (!isMontage && variantId) {
              if (!isRemovingProduct) {
                // Get main product info before calling removal function
                fetch("/cart.js")
                  .then(function (response) {
                    return response.json();
                  })
                  .then(function (cartData) {
                    var mainProductInfo = null;
                    if (cartData && cartData.items) {
                      var mainItem = cartData.items.find(function (item) {
                        return String(item.variant_id) === String(variantId);
                      });
                      if (mainItem) {
                        mainProductInfo = {
                          product_title: mainItem.product_title,
                          title: mainItem.title,
                          variant_title: mainItem.variant_title,
                        };
                      }
                    }
                    removeLinkedVariantsForMainProduct(
                      variantId,
                      null,
                      mainProductInfo
                    );
                  })
                  .catch(function (error) {
                    console.error(
                      "[REMOVE] Error fetching cart for product info:",
                      error
                    );
                    // Fallback: call without product info
                    removeLinkedVariantsForMainProduct(variantId, null, null);
                  });
              }
            }

            setTimeout(window.cleanuplocalStorageForRemovedItems, 1000);
          }
        }
        setTimeout(recomputeDrawerSubtotalFromDOM, 120);
        return;
      }
      var cartRemove = target.closest && target.closest("a.remove[data-index]");
      if (cartRemove) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (isRemovingProduct) {
          return;
        }

        clearTimeout(removeProductDebounceTimeout);
        removeProductDebounceTimeout = setTimeout(function () {
          if (isRemovingProduct) {
            return;
          }

          var row = cartRemove.closest('tr[id^="CartItem-"]');
          if (row) {
            var key = row.getAttribute("data-product-id") || "";
            var m = key.match(/^(\d+)/);
            var v = m ? m[1] : null;
            var itemIndex = cartRemove.getAttribute("data-index");
            var productHandle = row.getAttribute("data-product-handle");
            var isMontage = false;

            if (productHandle) {
              isMontage =
                productHandle === "montage" ||
                productHandle === "montage-zubehor";
            }

            if (isMontage) {
              handleMontageProductRemoval();
              setTimeout(window.cleanuplocalStorageForRemovedItems, 1000);
              setTimeout(function () {
                if (/\/cart(\?|$|\/?$)/.test(window.location.pathname)) {
                  recomputeCartPageSubtotalFromDOM();
                }
              }, 120);
              return;
            }

            if (v && itemIndex) {
              isRemovingProduct = true;

              var linkedVariantIdsToRemove = null;
              var mainProductInfo = null;

              // Get main product info and linked variants before removal
              fetch("/cart.js")
                .then(function (response) {
                  return response.json();
                })
                .then(function (cartDataBeforeRemoval) {
                  if (cartDataBeforeRemoval && cartDataBeforeRemoval.items) {
                    // Find the main product in cart before removal
                    var mainItem = cartDataBeforeRemoval.items.find(function (
                      item
                    ) {
                      return String(item.variant_id) === String(v);
                    });
                    if (mainItem) {
                      mainProductInfo = {
                        product_title: mainItem.product_title,
                        title: mainItem.title,
                        variant_title: mainItem.variant_title,
                      };
                      console.log(
                        "[REMOVE] Captured main product info:",
                        mainProductInfo
                      );
                    }
                  }

                  try {
                    var variantRelationships = JSON.parse(
                      localStorage.getItem("variantRelationships") || "{}"
                    );
                    linkedVariantIdsToRemove = variantRelationships[String(v)];
                    console.log(
                      "[REMOVE] Captured linked variants before removal:",
                      linkedVariantIdsToRemove
                    );
                  } catch (e) {
                    console.error(
                      "[REMOVE] Error reading variantRelationships:",
                      e
                    );
                  }

                  // Now remove the main product
                  return fetch("/cart/change.js", {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Accept: "application/json",
                    },
                    body: JSON.stringify({
                      line: parseInt(itemIndex, 10),
                      quantity: 0,
                      sections: ["main-cart", "cart-drawer"],
                      sections_url: window.location.pathname,
                    }),
                  })
                    .then(function (response) {
                      return response.json();
                    })
                    .then(function (cartData) {
                      if (
                        !cartData ||
                        !cartData.items ||
                        cartData.items.length === 0
                      ) {
                        try {
                          localStorage.removeItem(
                            "cartLockedDiscountPreference"
                          );
                        } catch (e) {
                          console.error(
                            "[REMOVE] Error clearing locked preference:",
                            e
                          );
                        }
                      }

                      try {
                        var st2 = localStorage.getItem("variantDiscounts");
                        if (st2) {
                          var mp2 = JSON.parse(st2);
                          if (mp2 && mp2[v]) {
                            delete mp2[v];
                            localStorage.setItem(
                              "variantDiscounts",
                              JSON.stringify(mp2)
                            );
                          }
                        }
                      } catch (e) {}

                      if (cartData && cartData.sections) {
                        var mainCartSection = cartData.sections["main-cart"];
                        var cartDrawerSection =
                          cartData.sections["cart-drawer"];
                        if (mainCartSection) {
                          var mainCartEl =
                            document.getElementById("main-cart-items");
                          if (mainCartEl) {
                            mainCartEl.innerHTML = mainCartSection;
                          }
                        }
                        if (cartDrawerSection) {
                          var drawerEl = document.getElementById("Cart-Drawer");
                          if (drawerEl) {
                            var selector = ".cart-drawer__inner";
                            var inner =
                              drawerEl.querySelector(selector) || drawerEl;
                            inner.innerHTML = cartDrawerSection;
                          }
                        }
                      }

                      if (
                        cartData &&
                        cartData.items &&
                        cartData.items.length > 0 &&
                        linkedVariantIdsToRemove
                      ) {
                        removeLinkedVariantsForMainProduct(
                          v,
                          linkedVariantIdsToRemove,
                          mainProductInfo
                        );
                      }

                      setTimeout(function () {
                        isRemovingProduct = false;
                        document.dispatchEvent(new CustomEvent("cart:refresh"));
                        document.dispatchEvent(new Event("theme:cart:refresh"));
                        document.dispatchEvent(new Event("thb:cart:update"));
                      }, 300);
                    })
                    .catch(function (error) {
                      console.error("[REMOVE] Error removing item:", error);
                      isRemovingProduct = false;
                    });
                })
                .catch(function (error) {
                  console.error(
                    "[REMOVE] Error fetching cart for product info:",
                    error
                  );
                  isRemovingProduct = false;
                });

              setTimeout(window.cleanuplocalStorageForRemovedItems, 1000);
            }
          }
          setTimeout(function () {
            if (/\/cart(\?|$|\/?$)/.test(window.location.pathname)) {
              recomputeCartPageSubtotalFromDOM();
            }
          }, 120);
        }, 100);
      }
    },
    true
  );

  function setupEssentialUpsellListener() {
    var upsellContainer = document.querySelector(
      ".essential-upsell-side-cart-top"
    );
    if (upsellContainer) {
      upsellContainer.addEventListener(
        "click",
        function (e) {
          var addToCartButton = e.target.closest(
            '[data-essential-upsell-element="add-to-cart-button"]'
          );
          if (addToCartButton) {
            setTimeout(function () {
              document.dispatchEvent(new CustomEvent("cart:refresh"));
              setTimeout(function () {
                if (window.applyCartDrawerDiscounts) {
                  window.applyCartDrawerDiscounts();
                }
                recomputeDrawerSubtotalFromDOM();
              }, 300);
            }, 500);
          } else {
          }
        },
        true
      );
    } else {
      setTimeout(setupEssentialUpsellListener, 500);
    }
  }

  document.addEventListener(
    "click",
    function (e) {
      var addToCartButton = e.target.closest(
        '[data-essential-upsell-element="add-to-cart-button"]'
      );
      if (addToCartButton) {
        var container = addToCartButton.closest(
          ".essential-upsell-side-cart-top, .essential-upsell-cross-sell-block.essential-cart-upsell, essential-upsell-cross-sell-app-block"
        );
        if (container) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          var isCartPage = container.classList.contains(
            "essential-cart-upsell"
          );
          var isProductPage =
            container.tagName === "ESSENTIAL-UPSELL-CROSS-SELL-APP-BLOCK";
          console.log("[UPSELL] Container tagName :", container.tagName);
          console.log("[UPSELL] isCartPage:", isCartPage);
          console.log("[UPSELL] isProductPage:", isProductPage);
          var productCard = addToCartButton.closest(
            '[data-essential-upsell-element="product"]'
          );
          var productInfo = {};

          var originalButtonText =
            addToCartButton.textContent || addToCartButton.innerHTML;
          addToCartButton.setAttribute("aria-disabled", "true");
          addToCartButton.classList.add("thb-loading");
          addToCartButton.disabled = true;

          var removeLoadingState = function () {
            addToCartButton.classList.remove("thb-loading");
            addToCartButton.removeAttribute("aria-disabled");
            addToCartButton.disabled = false;
          };

          if (productCard) {
            // Try to get variantId from select element
            var variantSelect = productCard.querySelector(
              'select[data-essential-upsell-element="variant-select"], select[aria-label*="Select variant"]'
            );
            if (variantSelect) {
              productInfo.variantId = variantSelect.value;
            }

            // FIX: Fallback - try to get variantId from other sources for single-variant products
            if (!productInfo.variantId) {
              // Try data attribute on the add-to-cart button
              var buttonVariantId = addToCartButton.getAttribute("data-variant-id") ||
                                    addToCartButton.getAttribute("data-id");
              if (buttonVariantId) {
                productInfo.variantId = buttonVariantId;
                console.log("[UPSELL] Got variantId from button data attribute:", buttonVariantId);
              }
            }
            if (!productInfo.variantId) {
              // Try hidden input
              var hiddenInput = productCard.querySelector('input[name="id"], input[type="hidden"][value]');
              if (hiddenInput && hiddenInput.value) {
                productInfo.variantId = hiddenInput.value;
                console.log("[UPSELL] Got variantId from hidden input:", hiddenInput.value);
              }
            }
            if (!productInfo.variantId) {
              // Try data attribute on product card
              var cardVariantId = productCard.getAttribute("data-variant-id") ||
                                  productCard.getAttribute("data-product-variant-id");
              if (cardVariantId) {
                productInfo.variantId = cardVariantId;
                console.log("[UPSELL] Got variantId from product card:", cardVariantId);
              }
            }
            if (!productInfo.variantId) {
              // Try price elements (Essential Upsell stores variant ID here for single-variant products)
              var priceElement = productCard.querySelector('[data-essential-upsell-element="discounted-price"][data-variant-id], [data-essential-upsell-element="regular-price"][data-variant-id]');
              if (priceElement) {
                var priceVariantId = priceElement.getAttribute("data-variant-id");
                if (priceVariantId) {
                  productInfo.variantId = priceVariantId;
                  console.log("[UPSELL] Got variantId from price element:", priceVariantId);
                }
              }
            }

            var titleLink = productCard.querySelector(
              '[data-essential-upsell-element="title"]'
            );
            if (titleLink) {
              var href = titleLink.getAttribute("href");
              if (href) {
                var handleMatch = href.match(/\/products\/([^\/\?]+)/);
                if (handleMatch) {
                  productInfo.productHandle = handleMatch[1];
                }
              }
              productInfo.productTitle = titleLink.textContent.trim();
            }

            // FIX: Fallback - try to get productHandle from other sources
            if (!productInfo.productHandle) {
              // Try data attribute on product card
              var cardHandle = productCard.getAttribute("data-product-handle") ||
                               productCard.getAttribute("data-handle");
              if (cardHandle) {
                productInfo.productHandle = cardHandle;
                console.log("[UPSELL] Got productHandle from product card:", cardHandle);
              }
            }
            if (!productInfo.productHandle) {
              // Try any link with /products/ in href
              var anyProductLink = productCard.querySelector('a[href*="/products/"]');
              if (anyProductLink) {
                var anyHref = anyProductLink.getAttribute("href");
                var anyMatch = anyHref.match(/\/products\/([^\/\?]+)/);
                if (anyMatch) {
                  productInfo.productHandle = anyMatch[1];
                  console.log("[UPSELL] Got productHandle from product link:", anyMatch[1]);
                }
              }
            }

            console.log("[UPSELL] Extracted productInfo:", productInfo);

            if (productInfo.variantId && productInfo.productHandle) {
              fetch("/cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "X-Requested-With": "XMLHttpRequest",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  id: productInfo.variantId,
                  quantity: 1,
                }),
              })
                .then(function (response) {
                  if (response.ok) {
                    return response.json();
                  }
                  throw new Error("Failed to add item to cart");
                })
                .catch(function (error) {
                  removeLoadingState();
                  console.error("[UPSELL] Error adding to cart:", error);
                  throw error;
                })
                .then(function (cartData) {
                  console.log("[UPSELL] Cart add response received:", cartData);
                  console.log(
                    "[UPSELL] isProductPage before check:",
                    isProductPage
                  );
                  console.log("[UPSELL] cartData.items:", cartData?.items);
                  console.log(
                    "[UPSELL] cartData.items.length:",
                    cartData?.items?.length
                  );

                  var productItem = null;
                  if (cartData && cartData.items && cartData.items.length > 0) {
                    console.log("[UPSELL] Cart has items array, processing...");
                    productItem = cartData.items[cartData.items.length - 1];
                  } else if (cartData && cartData.variant_id) {
                    console.log(
                      "[UPSELL] Response is single item, processing..."
                    );
                    productItem = cartData;
                  }

                  if (productItem) {
                    var upsellVariantId = String(productItem.variant_id);
                    console.log("[UPSELL] Product item added:", productItem);
                    console.log("[UPSELL] Upsell variant ID:", upsellVariantId);

                    var buttonMapping = window.getButtonDiscountMapping();
                    var assemblyPreference = window.getAssemblyPreference();
                    var buttonNumber = assemblyPreference || 1;

                    console.log("[UPSELL] buttonMapping:", buttonMapping);
                    console.log(
                      "[UPSELL] assemblyPreference:",
                      assemblyPreference
                    );
                    console.log("[UPSELL] buttonNumber:", buttonNumber);
                    console.log("[UPSELL] isProductPage:", isProductPage);
                    console.log("[UPSELL] productInfo:", productInfo);
                    console.log(
                      "[UPSELL] productInfo.productHandle:",
                      productInfo.productHandle
                    );

                    // FIX: Handle cartLockedDiscountPreference BEFORE fetch (moved from after fetch)
                    if (isProductPage) {
                      console.log("[UPSELL] Entering isProductPage block (moved before fetch)");
                      try {
                        var lockedPreference = localStorage.getItem(
                          "cartLockedDiscountPreference"
                        );

                        if (!lockedPreference) {
                          localStorage.setItem(
                            "cartLockedDiscountPreference",
                            String(buttonNumber)
                          );
                          console.log(
                            "[UPSELL] Set cartLockedDiscountPreference to:",
                            buttonNumber
                          );
                        } else {
                          var lockedButtonNumber = parseInt(
                            lockedPreference,
                            10
                          );
                          buttonNumber = lockedButtonNumber;
                          console.log(
                            "[UPSELL] Using existing cartLockedDiscountPreference:",
                            lockedButtonNumber
                          );
                        }
                      } catch (e) {
                        console.error(
                          "[UPSELL] Error handling cartLockedDiscountPreference:",
                          e
                        );
                      }
                    }

                    // FIX: Set targetDiscountTitle BEFORE fetch (moved from after fetch)
                    var targetDiscountTitle = null;
                    if (
                      buttonMapping &&
                      (buttonMapping.button1 || buttonMapping.button2)
                    ) {
                      if (buttonNumber === 1) {
                        targetDiscountTitle = buttonMapping.button1;
                      } else if (buttonNumber === 2) {
                        targetDiscountTitle = buttonMapping.button2;
                      }
                    }
                    console.log("[UPSELL] targetDiscountTitle set to:", targetDiscountTitle);

                    if (!productInfo.productHandle) {
                      console.error(
                        "[UPSELL] ERROR: productInfo.productHandle is missing!"
                      );
                      removeLoadingState();
                      return;
                    }
                    console.log(
                      "[UPSELL] Fetching product data for:",
                      productInfo.productHandle
                    );

                    var linkedVariants = null;
                    var linkedVariantsScript = document.querySelector(
                      '[id^="linked-variants-data-"]'
                    );
                    if (linkedVariantsScript) {
                      try {
                        var linkedVariantsData = JSON.parse(
                          linkedVariantsScript.textContent.trim()
                        );
                        linkedVariants = linkedVariantsData[upsellVariantId];
                        console.log(
                          "[UPSELL] Linked variants from script tag:",
                          linkedVariants
                        );
                      } catch (e) {
                        console.error(
                          "[UPSELL] Error parsing linked variants data:",
                          e
                        );
                      }
                    }

                    // FIX: Store fetch as promise for proper timing of discount application
                    var discountSavePromise = fetch("/products/" + productInfo.productHandle + ".js")
                      .then(function (response) {
                        return response.json();
                      })
                      .then(function (productData) {
                        console.log(
                          "[UPSELL] Product data received:",
                          productData
                        );
                        var discountsMetafield = null;

                        if (productData && productData.variants) {
                          console.log(
                            "[UPSELL] Looking for variant:",
                            upsellVariantId
                          );
                          var variant = productData.variants.find(function (v) {
                            return String(v.id) === upsellVariantId;
                          });
                          console.log("[UPSELL] Found variant:", variant);
                          if (variant && variant.metafields) {
                            console.log(
                              "[UPSELL] Variant metafields:",
                              variant.metafields
                            );
                            discountsMetafield =
                              variant.metafields.custom?.discounts?.value;
                          }
                        }

                        if (
                          !discountsMetafield &&
                          productData &&
                          productData.metafields
                        ) {
                          discountsMetafield =
                            productData.metafields.custom?.discounts?.value;
                        }

                        console.log(
                          "[UPSELL] Checking linked variants:",
                          linkedVariants
                        );
                        if (
                          linkedVariants &&
                          Array.isArray(linkedVariants) &&
                          linkedVariants.length > 0
                        ) {
                          console.log(
                            "[UPSELL] Processing linked variants array:",
                            linkedVariants
                          );
                          try {
                            var linkedVariantIds = linkedVariants
                              .map(function (lv) {
                                return lv && lv.id ? String(lv.id) : null;
                              })
                              .filter(function (id) {
                                return (
                                  id !== null && id !== String(upsellVariantId)
                                );
                              });

                            console.log(
                              "[UPSELL] Mapped linked variant IDs:",
                              linkedVariantIds
                            );
                            if (linkedVariantIds.length > 0) {
                              var variantRelationships = JSON.parse(
                                localStorage.getItem("variantRelationships") ||
                                  "{}"
                              );
                              console.log(
                                "[UPSELL] Current variantRelationships:",
                                variantRelationships
                              );
                              variantRelationships[String(upsellVariantId)] =
                                linkedVariantIds;
                              localStorage.setItem(
                                "variantRelationships",
                                JSON.stringify(variantRelationships)
                              );
                              console.log(
                                "[UPSELL] ✅ Saved variant relationships for",
                                upsellVariantId,
                                ":",
                                linkedVariantIds
                              );
                              console.log(
                                "[UPSELL] Updated variantRelationships:",
                                variantRelationships
                              );
                            } else {
                              console.log(
                                "[UPSELL] No linked variant IDs after filtering"
                              );
                            }
                          } catch (e) {
                            console.error(
                              "[UPSELL] Error saving variant relationships:",
                              e
                            );
                          }
                        } else {
                          console.log(
                            "[UPSELL] No linked variants found or not an array"
                          );
                        }

                        // FIX: Fallback - if no targetDiscountTitle from buttonMapping, use first discount from product metafield
                        if (!targetDiscountTitle && discountsMetafield && Array.isArray(discountsMetafield) && discountsMetafield.length > 0) {
                          var firstDiscount = discountsMetafield[0];
                          if (firstDiscount && firstDiscount.title) {
                            targetDiscountTitle = firstDiscount.title.trim();
                            console.log("[UPSELL] Using fallback discount title from product metafield:", targetDiscountTitle);
                          }
                        }

                        if (targetDiscountTitle) {
                          var discountPercentage = 0;
                          var foundDiscount = null;

                          // Try to find discount percentage from product metafields
                          if (
                            discountsMetafield &&
                            Array.isArray(discountsMetafield) &&
                            discountsMetafield.length > 0
                          ) {
                            foundDiscount = discountsMetafield.find(
                              function (d) {
                                return (
                                  d.title &&
                                  d.title.trim() === targetDiscountTitle
                                );
                              }
                            );

                            if (foundDiscount) {
                              var discountValue = foundDiscount.value;

                              if (discountValue) {
                                if (discountValue.value !== undefined) {
                                  var value = parseFloat(discountValue.value);
                                  if (discountValue.type === "percentage") {
                                    discountPercentage =
                                      value <= 1 ? value * 100 : value;
                                  } else {
                                    discountPercentage = value * 100;
                                  }
                                } else if (typeof discountValue === "number") {
                                  discountPercentage =
                                    discountValue <= 1
                                      ? discountValue * 100
                                      : discountValue;
                                } else if (typeof discountValue === "string") {
                                  var parsed = parseFloat(discountValue);
                                  discountPercentage =
                                    parsed <= 1 ? parsed * 100 : parsed;
                                }
                              }
                            }
                          }

                          // FIX: If no metafield data, try to get percentage from existing variantDiscounts
                          if (!foundDiscount) {
                            try {
                              var existingDiscounts = JSON.parse(localStorage.getItem("variantDiscounts") || "{}");
                              // Look for any existing discount with this title to get the percentage
                              for (var existingVid in existingDiscounts) {
                                if (existingDiscounts[existingVid] && existingDiscounts[existingVid].title === targetDiscountTitle) {
                                  discountPercentage = existingDiscounts[existingVid].percentage || 0;
                                  console.log("[UPSELL] Got discount percentage from existing variant:", discountPercentage);
                                  break;
                                }
                              }
                            } catch (e) {
                              console.error("[UPSELL] Error reading existing discounts:", e);
                            }
                          }

                          // FIX: Remove variant from noDiscountVariants list (it was added by handleCartItemAdded)
                          try {
                            var noDiscountVariants = JSON.parse(localStorage.getItem("noDiscountVariants") || "[]");
                            var noDiscountIndex = noDiscountVariants.indexOf(upsellVariantId);
                            if (noDiscountIndex !== -1) {
                              noDiscountVariants.splice(noDiscountIndex, 1);
                              localStorage.setItem("noDiscountVariants", JSON.stringify(noDiscountVariants));
                              console.log("[UPSELL] Removed variant from noDiscountVariants:", upsellVariantId);
                            }
                          } catch (e) {
                            console.error("[UPSELL] Error removing from noDiscountVariants:", e);
                          }

                          // FIX: Always save the discount when we have a title (even if percentage is 0)
                          console.log("[UPSELL] Saving discount for upsell variant:", upsellVariantId, targetDiscountTitle, discountPercentage);
                          window.saveVariantDiscount(
                            upsellVariantId,
                            targetDiscountTitle,
                            discountPercentage
                          );
                        }
                      })
                      .then(function () {
                        // FIX: Apply discounts immediately after product fetch completes successfully
                        console.log("[UPSELL] Product fetch completed, applying discounts");
                        setTimeout(function () {
                          if (typeof window.applyCartDrawerDiscounts === "function") {
                            window.applyCartDrawerDiscounts();
                          }
                          if (/\/cart(\?|$|\/?$)/.test(window.location.pathname)) {
                            if (typeof window.applyCartPageDiscounts === "function") {
                              window.applyCartPageDiscounts();
                            }
                          }
                        }, 100);
                      })
                      .catch(function (error) {
                        console.error(
                          "[UPSELL] Error fetching product data:",
                          error
                        );
                        // FIX: Still apply discounts even if fetch fails (use what we have)
                        setTimeout(function () {
                          if (typeof window.applyCartDrawerDiscounts === "function") {
                            window.applyCartDrawerDiscounts();
                          }
                        }, 100);
                      });

                    // Note: isProductPage and targetDiscountTitle handling was moved BEFORE the fetch (see above)

                    document.dispatchEvent(
                      new CustomEvent("cart:item-added", {
                        detail: { product: productItem },
                      })
                    );

                    removeLoadingState();
                  } else {
                    console.log("[UPSELL] No product item found in response");
                    removeLoadingState();
                  }

                  document.dispatchEvent(new CustomEvent("cart:refresh"));

                  // FIX: This is now a fallback - primary discount application happens in discountSavePromise.finally()
                  setTimeout(function () {
                    if (typeof window.applyCartDrawerDiscounts === "function") {
                      window.applyCartDrawerDiscounts();
                    }
                  }, 750);

                  var delayForMontage = isProductPage ? 800 : 600;
                  setTimeout(function () {
                    var addedVariantId = String(productInfo.variantId);

                    setTimeout(function () {
                      var cartItem = null;
                      if (isCartPage) {
                        cartItem = document.querySelector(
                          'tr[id^="CartItem-"][data-main-variant-id="' +
                            addedVariantId +
                            '"], tr[id^="CartItem-"][data-variant-id="' +
                            addedVariantId +
                            '"]'
                        );
                      } else if (isProductPage) {
                        setTimeout(function () {
                          var cartDrawerToggle =
                            document.getElementById("cart-drawer-toggle");
                          if (cartDrawerToggle) {
                            cartDrawerToggle.click();
                            document.dispatchEvent(
                              new CustomEvent("cart-drawer:open")
                            );
                          }
                        }, 100);

                        cartItem = document.querySelector(
                          '.mini_cart_item[data-main-variant-id="' +
                            addedVariantId +
                            '"], .mini_cart_item[data-variant-id="' +
                            addedVariantId +
                            '"], tr[id^="CartItem-"][data-main-variant-id="' +
                            addedVariantId +
                            '"], tr[id^="CartItem-"][data-variant-id="' +
                            addedVariantId +
                            '"]'
                        );
                      } else {
                        cartItem = document.querySelector(
                          '.mini_cart_item[data-main-variant-id="' +
                            addedVariantId +
                            '"], .mini_cart_item[data-variant-id="' +
                            addedVariantId +
                            '"]'
                        );
                      }

                      if (cartItem) {
                        var linkedVariantIdsStr = cartItem.getAttribute(
                          "data-linked-variant-ids"
                        );
                        var linkedVariantIds = null;

                        if (
                          linkedVariantIdsStr &&
                          linkedVariantIdsStr.trim() !== "" &&
                          linkedVariantIdsStr !== "null"
                        ) {
                          linkedVariantIds = linkedVariantIdsStr
                            .split(",")
                            .map(function (id) {
                              return String(id.trim());
                            })
                            .filter(function (id) {
                              return id !== "";
                            });
                        }

                        if (
                          (!linkedVariantIds ||
                            linkedVariantIds.length === 0) &&
                          isProductPage
                        ) {
                          try {
                            var variantRelationships = JSON.parse(
                              localStorage.getItem("variantRelationships") ||
                                "{}"
                            );
                            linkedVariantIds =
                              variantRelationships[String(addedVariantId)];
                            console.log(
                              "[UPSELL] Got linked variants from variantRelationships:",
                              linkedVariantIds
                            );
                          } catch (e) {
                            console.error(
                              "[UPSELL] Error reading variantRelationships:",
                              e
                            );
                          }
                        }

                        if (linkedVariantIds && linkedVariantIds.length > 0) {
                          var lockedPreference = null;
                          try {
                            lockedPreference = localStorage.getItem(
                              "cartLockedDiscountPreference"
                            );
                          } catch (e) {
                            console.error(
                              "[UPSELL] Error checking locked preference:",
                              e
                            );
                          }

                          var shouldAddMontageProducts = false;
                          if (lockedPreference === "2") {
                            shouldAddMontageProducts = true;
                          } else if (lockedPreference === "1") {
                            return;
                          } else {
                            shouldAddMontageProducts =
                              window.isAssemblyBySkyPergola();
                          }

                          if (!shouldAddMontageProducts) {
                            return;
                          }

                          var isAssemblyBySkyPergola =
                            window.isAssemblyBySkyPergola();

                          if (!isAssemblyBySkyPergola) {
                            return;
                          }

                          fetch("/cart.js")
                            .then(function (response) {
                              return response.json();
                            })
                            .then(function (currentCartData) {
                              if (!currentCartData || !currentCartData.items) {
                                return;
                              }

                              var mainItem = currentCartData.items.find(
                                function (item) {
                                  return (
                                    String(item.variant_id) === addedVariantId
                                  );
                                }
                              );

                              if (!mainItem) {
                                return;
                              }

                              var propertyLabel = {
                                en: "For",
                                de: "Für",
                                fr: "Pour",
                                it: "Per",
                              };
                              var currentLocale =
                                document.documentElement.lang || "en";
                              var langCode = currentLocale
                                .split("-")[0]
                                .toLowerCase();
                              if (!propertyLabel[langCode]) {
                                langCode = "en";
                              }
                              var propertyKey = propertyLabel[langCode];

                              var combinedTitle =
                                mainItem.product_title || mainItem.title || "";
                              if (
                                mainItem.variant_title &&
                                mainItem.variant_title !== "Default Title"
                              ) {
                                combinedTitle =
                                  combinedTitle + " " + mainItem.variant_title;
                              }

                              var targetProperties = {};
                              if (combinedTitle) {
                                targetProperties[propertyKey] = combinedTitle;
                              }

                              var itemsToAdd = [];
                              var itemsToUpdate = [];
                              var quantityToAdd = mainItem.quantity || 1;

                              linkedVariantIds.forEach(function (
                                variantIdToAdd
                              ) {
                                var existingItem = currentCartData.items.find(
                                  function (cartItem) {
                                    if (
                                      String(cartItem.variant_id) !==
                                      String(variantIdToAdd)
                                    ) {
                                      return false;
                                    }

                                    var cartItemProperties =
                                      cartItem.properties || {};
                                    var targetPropertyValue =
                                      targetProperties[propertyKey];
                                    var cartPropertyValue =
                                      cartItemProperties[propertyKey];

                                    if (
                                      targetPropertyValue &&
                                      cartPropertyValue
                                    ) {
                                      return (
                                        String(targetPropertyValue) ===
                                        String(cartPropertyValue)
                                      );
                                    }

                                    if (
                                      !targetPropertyValue &&
                                      !cartPropertyValue
                                    ) {
                                      return true;
                                    }

                                    return false;
                                  }
                                );

                                if (existingItem) {
                                  var newQuantity =
                                    (existingItem.quantity || 0) +
                                    quantityToAdd;

                                  var itemKey = existingItem.key;
                                  if (itemKey) {
                                    itemsToUpdate.push({
                                      id: itemKey,
                                      quantity: newQuantity,
                                    });
                                  } else {
                                    console.warn(
                                      "[UPSELL] Cart item key not found, adding as new item instead"
                                    );
                                    var properties = {};
                                    if (combinedTitle) {
                                      properties[propertyKey] = combinedTitle;
                                    }
                                    itemsToAdd.push({
                                      id: variantIdToAdd,
                                      quantity: quantityToAdd,
                                      properties: properties,
                                    });
                                  }
                                } else {
                                  var properties = {};
                                  if (combinedTitle) {
                                    properties[propertyKey] = combinedTitle;
                                  }
                                  itemsToAdd.push({
                                    id: variantIdToAdd,
                                    quantity: quantityToAdd,
                                    properties: properties,
                                  });
                                }
                              });

                              var variantRelationships = JSON.parse(
                                localStorage.getItem("variantRelationships") ||
                                  "{}"
                              );
                              variantRelationships[addedVariantId] =
                                linkedVariantIds;
                              localStorage.setItem(
                                "variantRelationships",
                                JSON.stringify(variantRelationships)
                              );

                              var updatePromises = [];
                              var addPromises = [];

                              if (itemsToUpdate.length > 0) {
                                var updatesObject = {};
                                itemsToUpdate.forEach(function (itemToUpdate) {
                                  updatesObject[itemToUpdate.id] =
                                    itemToUpdate.quantity;
                                });
                                updatePromises.push(
                                  fetch("/cart/update.js", {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      "X-Requested-With": "XMLHttpRequest",
                                      Accept: "application/json",
                                    },
                                    body: JSON.stringify({
                                      updates: updatesObject,
                                    }),
                                  })
                                );
                              }

                              if (itemsToAdd.length > 0) {
                                addPromises.push(
                                  fetch("/cart/add.js", {
                                    method: "POST",
                                    headers: {
                                      "Content-Type": "application/json",
                                      "X-Requested-With": "XMLHttpRequest",
                                      Accept: "application/json",
                                    },
                                    body: JSON.stringify({
                                      items: itemsToAdd,
                                    }),
                                  })
                                );
                              }

                              if (
                                updatePromises.length > 0 ||
                                addPromises.length > 0
                              ) {
                                Promise.all([...updatePromises, ...addPromises])
                                  .then(function (responses) {
                                    var allOk = responses.every(function (
                                      response
                                    ) {
                                      return response.ok;
                                    });
                                    if (!allOk) {
                                      throw new Error(
                                        "Failed to update/add linked variants"
                                      );
                                    }
                                    return Promise.all(
                                      responses.map(function (r) {
                                        return r.json();
                                      })
                                    );
                                  })
                                  .then(function () {
                                    document.dispatchEvent(
                                      new CustomEvent("cart:refresh")
                                    );
                                    setTimeout(function () {
                                      if (window.applyCartDrawerDiscounts) {
                                        window.applyCartDrawerDiscounts();
                                      }
                                      if (isCartPage) {
                                        if (window.applyCartPageDiscounts) {
                                          window.applyCartPageDiscounts();
                                        }
                                        recomputeCartPageSubtotalFromDOM();
                                      }
                                      recomputeDrawerSubtotalFromDOM();
                                    }, 300);
                                  })
                                  .catch(function (error) {
                                    console.error(
                                      "[UPSELL] Error updating/adding linked variants:",
                                      error
                                    );
                                  });
                              }
                            })
                            .catch(function (error) {
                              console.error(
                                "[UPSELL] Error fetching cart:",
                                error
                              );
                            });
                        }
                      }
                    }, delayForMontage);

                    if (window.applyCartDrawerDiscounts) {
                      window.applyCartDrawerDiscounts();
                    }
                    if (/\/cart(\?|$|\/?$)/.test(window.location.pathname)) {
                      window.applyCartPageDiscounts();
                      recomputeCartPageSubtotalFromDOM();
                    }
                    recomputeDrawerSubtotalFromDOM();
                  }, 300);
                });
            } else {
              // FIX: Remove loading state when variantId or productHandle is missing
              console.log("[UPSELL] Missing variantId or productHandle, removing loading state");
              removeLoadingState();
            }
          } else {
            // FIX: Remove loading state when productCard is not found
            console.log("[UPSELL] Product card not found, removing loading state");
            removeLoadingState();
          }
        }
      }
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(window.applyCartDrawerDiscounts, 500);
      setTimeout(function () {
        if (/\/cart(\?|$|\/?$)/.test(window.location.pathname)) {
          recomputeCartPageSubtotalFromDOM();
        }
      }, 600);
      setupEssentialUpsellListener();
    });
  } else {
    setTimeout(window.applyCartDrawerDiscounts, 500);
    setTimeout(function () {
      if (/\/cart(\?|$|\/?$)/.test(window.location.pathname)) {
        recomputeCartPageSubtotalFromDOM();
      }
    }, 600);
    setupEssentialUpsellListener();
  }

  document.addEventListener("cart:refresh", function () {
    setTimeout(setupEssentialUpsellListener, 200);

    setTimeout(function () {
      try {
        setupCheckoutDiscountRedirects();
      } catch (e) {
        console.error("[CHK] Error re-setting up checkout redirects:", e);
      }
    }, 300);

    setTimeout(function () {
      try {
        fetch("/cart.js")
          .then(function (response) {
            return response.json();
          })
          .then(function (cartData) {
            if (!cartData || !cartData.items || cartData.items.length === 0) {
              try {
                localStorage.removeItem("cartLockedDiscountPreference");
                console.log(
                  "[CLEANUP] Cleared cartLockedDiscountPreference - cart is empty"
                );
              } catch (e) {
                console.error("[CLEANUP] Error clearing locked preference:", e);
              }
            }
          })
          .catch(function (error) {
            console.error("[CLEANUP] Error checking cart:", error);
          });
      } catch (e) {
        console.error("[CLEANUP] Error in cart empty check:", e);
      }
    }, 500);
  });

  document.addEventListener("cart-drawer:open", function () {
    setTimeout(function () {
      try {
        setupCheckoutDiscountRedirects();
      } catch (e) {
        console.error(
          "[CHK] Error setting up checkout redirects on drawer open:",
          e
        );
      }
    }, 200);
  });

  document.addEventListener("cart-drawer:refresh", function () {
    setTimeout(function () {
      try {
        setupCheckoutDiscountRedirects();
      } catch (e) {
        console.error(
          "[CHK] Error setting up checkout redirects on drawer refresh:",
          e
        );
      }
    }, 300);
  });
})();

if (typeof window.handleDiscountButtonClick === "function") {
  console.log("[BUTTON] handleDiscountButtonClick is available on window");
} else {
  console.error(
    "[BUTTON] handleDiscountButtonClick is NOT available on window!"
  );
}

function getActiveDiscountCodeFromDOM() {
  try {
    var variantDiscounts = {};
    try {
      variantDiscounts = JSON.parse(
        localStorage.getItem("variantDiscounts") || "{}"
      );
    } catch (e) {
      console.error("[CHK] Error parsing variantDiscounts:", e);
      return "";
    }

    if (Object.keys(variantDiscounts).length === 0) {
      return "";
    }

    var cartItems = [];
    try {
      var cartRows = document.querySelectorAll('tr[id^="CartItem-"]');
      if (cartRows.length > 0) {
        cartRows.forEach(function (row) {
          var key = row.getAttribute("data-product-id") || "";
          var match = key.match(/^(\d+)/);
          if (match) {
            var variantId = match[1];
            var discountData = variantDiscounts[variantId];
            if (discountData && discountData.title) {
              var title = discountData.title.trim();
              if (title && /^[A-Za-z0-9-_]+$/.test(title)) {
                cartItems.push({ variantId: variantId, discount: title });
              }
            }
          }
        });
      }
    } catch (e) {
      console.error("[CHK] Error getting cart items:", e);
    }

    if (cartItems.length === 0) {
      try {
        var drawerItems = document.querySelectorAll(".mini_cart_item");
        if (drawerItems.length > 0) {
          drawerItems.forEach(function (item) {
            var variantId = item.getAttribute("data-variant-id");
            if (!variantId) {
              var button = item.querySelector(".remove[data-id]");
              if (button) {
                variantId = button.getAttribute("data-id");
              }
            }
            if (variantId) {
              var discountData = variantDiscounts[variantId];
              if (discountData && discountData.title) {
                var title = discountData.title.trim();
                if (title && /^[A-Za-z0-9-_]+$/.test(title)) {
                  cartItems.push({ variantId: variantId, discount: title });
                }
              }
            }
          });
        }
      } catch (e) {
        console.error("[CHK] Error getting drawer items:", e);
      }
    }

    if (cartItems.length > 0) {
      var discountCounts = {};
      cartItems.forEach(function (item) {
        var discount = item.discount;
        if (!discountCounts[discount]) {
          discountCounts[discount] = 0;
        }
        discountCounts[discount]++;
      });

      var mostCommonDiscount = null;
      var maxCount = 0;
      for (var discount in discountCounts) {
        if (discountCounts[discount] > maxCount) {
          maxCount = discountCounts[discount];
          mostCommonDiscount = discount;
        }
      }

      if (mostCommonDiscount) {
        return mostCommonDiscount;
      }

      return cartItems[0].discount;
    }

    var sel = [
      "#applied-discount-cart-page span:last-child",
      "#applied-discount-cart-page-mobile span:last-child",
      "#applied-discount-cart-drawer span:last-child",
      ".custom-discount-pill span:last-child",
      ".discounts__discount",
    ];
    for (var i = 0; i < sel.length; i++) {
      var el = document.querySelector(sel[i]);
      if (el && el.textContent) {
        var text = el.textContent.trim();
        var codeMatch = text.match(/^([A-Za-z0-9-_]+)/);
        if (codeMatch) {
          var code = codeMatch[1];
          if (code && /^[A-Za-z0-9-_]+$/.test(code)) {
            return code;
          }
        }
      }
    }
  } catch (e) {
    console.error("[CHK] code parse error", e);
  }
  return "";
}

function validateTermsCheckbox() {
  try {
    var isCartPage = /\/cart(\?|$|\/?$)/.test(window.location.pathname);
    if (isCartPage) {
      var cartTerms =
        document.getElementById("CartTerms") ||
        document.querySelector('#cart-form input[type="checkbox"][required]') ||
        document.querySelector(
          '.cart-collaterals-terms input[type="checkbox"][required]'
        );
      if (cartTerms) {
        if (cartTerms.required && !cartTerms.checked) {
          return false;
        }
      }
      return true;
    }
    var drawerTerms = document.getElementById("CartDrawerTerms");
    if (drawerTerms && drawerTerms.required && !drawerTerms.checked) {
      return false;
    }
    return true;
  } catch (e) {
    console.error("[CHK] Terms validation error", e);
    return true;
  }
}

function getCheckoutURL(code) {
  try {
    console.log("[CHK] getCheckoutURL called with code:", code);
    var url = "/checkout";
    var discountCode = code || "";

    try {
      var lockedPreference = localStorage.getItem(
        "cartLockedDiscountPreference"
      );
      console.log("[CHK] Locked preference:", lockedPreference);

      if (lockedPreference) {
        var lockedButtonNumber = parseInt(lockedPreference, 10);
        var buttonMapping = window.getButtonDiscountMapping();
        console.log(
          "[CHK] Button mapping:",
          buttonMapping,
          "Button number:",
          lockedButtonNumber
        );

        if (buttonMapping) {
          var discountTitle = null;
          if (lockedButtonNumber === 1 && buttonMapping.button1) {
            discountTitle = buttonMapping.button1;
          } else if (lockedButtonNumber === 2 && buttonMapping.button2) {
            discountTitle = buttonMapping.button2;
          }

          if (discountTitle && discountTitle.trim() !== "") {
            discountCode = discountTitle.trim();
            console.log("[CHK] Using locked discount preference", {
              lockedButtonNumber: lockedButtonNumber,
              discountCode: discountCode,
            });
          } else {
            console.error(
              "[CHK] No discount title found for button",
              lockedButtonNumber
            );
          }
        } else {
          console.error("[CHK] No button mapping found");
        }
      }
    } catch (e) {
      console.error("[CHK] Error checking locked preference:", e);
    }

    if (!discountCode || discountCode.trim() === "") {
      console.log("[CHK] No discount code found, returning base URL");
      return url;
    }

    url = "/checkout?discount=" + encodeURIComponent(discountCode.trim());

    console.log(
      "[CHK] Generated checkout URL:",
      url,
      "discountCode:",
      discountCode
    );
    return url;
  } catch (e) {
    console.error("[CHK] URL generation error", e);
    return "/checkout";
  }
}

function performCheckoutRedirect(code) {
  try {
    var termsValid = validateTermsCheckbox();
    if (!termsValid) {
      return false;
    }
    var url = getCheckoutURL(code);
    window.location.href = url;
    return true;
  } catch (e) {
    console.error("[CHK] Redirect error", e);
    return false;
  }
}

function setupCheckoutDiscountRedirects() {
  try {
    console.log("[CHK] Setting up checkout redirect handlers");

    if (!document.documentElement.dataset.chkDelegationBound) {
      document.documentElement.dataset.chkDelegationBound = "true";
      document.addEventListener(
        "click",
        function (e) {
          try {
            var target = e.target;
            var checkoutBtn = target.closest(
              'button[name="checkout"], a[href*="/checkout"]'
            );

            if (checkoutBtn) {
              var isDrawerBtn = checkoutBtn.closest("#Cart-Drawer");
              var isCartBtn = checkoutBtn.closest("#cart-form, form#cart-form");

              if (
                !isCartBtn &&
                checkoutBtn.getAttribute("form") === "cart-form"
              ) {
                isCartBtn = true;
              }

              if (isDrawerBtn || isCartBtn) {
                console.log("[CHK] Checkout button clicked via delegation", {
                  isDrawer: !!isDrawerBtn,
                  isCart: !!isCartBtn,
                  button: checkoutBtn,
                  hasFormAttr: checkoutBtn.getAttribute("form"),
                });

                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();

                var termsValid = validateTermsCheckbox();
                if (!termsValid) {
                  var cartTerms =
                    document.getElementById("CartTerms") ||
                    document.getElementById("CartDrawerTerms") ||
                    document.querySelector(
                      '#cart-form input[type="checkbox"][required]'
                    ) ||
                    document.querySelector(
                      '#Cart-Drawer input[type="checkbox"][required]'
                    ) ||
                    document.querySelector(
                      '.cart-collaterals-terms input[type="checkbox"][required]'
                    );
                  if (cartTerms && cartTerms.required && !cartTerms.checked) {
                    cartTerms.focus();
                    cartTerms.reportValidity();
                    return false;
                  }
                  return false;
                }

                var code = getActiveDiscountCodeFromDOM();
                console.log("[CHK] Checkout - code from DOM:", code);
                if (code && code.trim() !== "") {
                  performCheckoutRedirect(code);
                } else {
                  performCheckoutRedirect("");
                }
                return false;
              }
            }
          } catch (err) {
            console.error("[CHK] delegation click handler error", err);
          }
        },
        true
      );
    }

    if (!document.documentElement.dataset.chkFormDelegationBound) {
      document.documentElement.dataset.chkFormDelegationBound = "true";
      document.addEventListener(
        "submit",
        function (e) {
          try {
            var form = e.target;
            if (form && form.tagName === "FORM") {
              var isDrawerForm = form.closest("#Cart-Drawer");
              var isCartForm =
                form.id === "cart-form" || form.closest("#cart-form");

              var hasCheckoutBtn = form.querySelector(
                'button[name="checkout"]'
              );
              var hasExternalCheckoutBtn = document.querySelector(
                'button[name="checkout"][form="' + form.id + '"]'
              );

              if (
                (isDrawerForm || isCartForm) &&
                (hasCheckoutBtn || hasExternalCheckoutBtn)
              ) {
                console.log("[CHK] Form submitted via delegation", {
                  isDrawer: !!isDrawerForm,
                  isCart: !!isCartForm,
                  form: form,
                  hasCheckoutBtn: !!hasCheckoutBtn,
                  hasExternalCheckoutBtn: !!hasExternalCheckoutBtn,
                });

                var code = getActiveDiscountCodeFromDOM();
                console.log("[CHK] Form submit - code from DOM:", code);
                if (performCheckoutRedirect(code || "")) {
                  e.preventDefault();
                  e.stopPropagation();
                  e.stopImmediatePropagation();
                  return false;
                }
              }
            }
          } catch (err) {
            console.error("[CHK] delegation form submit handler error", err);
          }
        },
        true
      );
    }

    var cartCheckoutBtn = document.querySelector(
      'form#cart-form button[name="checkout"], button.checkout-button[name="checkout"], button[form="cart-form"][name="checkout"]'
    );
    if (cartCheckoutBtn && !cartCheckoutBtn.dataset.chkBound) {
      console.log(
        "[CHK] Found cart checkout button, setting up direct handler"
      );
      cartCheckoutBtn.dataset.chkBound = "true";
      cartCheckoutBtn.type = "button";
    }

    var drawerCheckoutBtn = document.querySelector(
      '#Cart-Drawer form[action="/cart"] button[name="checkout"], #Cart-Drawer button[name="checkout"], #Cart-Drawer button.checkout, #Cart-Drawer a[href*="/checkout"]'
    );
    if (drawerCheckoutBtn && !drawerCheckoutBtn.dataset.chkBound) {
      console.log(
        "[CHK] Found drawer checkout button, setting up direct handler"
      );
      drawerCheckoutBtn.dataset.chkBound = "true";
      if (drawerCheckoutBtn.tagName === "BUTTON") {
        drawerCheckoutBtn.type = "button";
      }
    }
    var shopPayBtn = document.querySelector("shop-pay-wallet-button");
    if (shopPayBtn && !shopPayBtn.dataset.chkBound) {
      shopPayBtn.dataset.chkBound = "true";
      shopPayBtn.addEventListener(
        "click",
        function (e) {
          try {
            var code = getActiveDiscountCodeFromDOM();
            if (code && performCheckoutRedirect(code)) {
              e.preventDefault();
            }
          } catch (err) {
            console.error("[CHK] shop pay redirect error", err);
          }
        },
        true
      );
    }
  } catch (e) {
    console.error("[CHK] setup error", e);
  }
}

function recomputeCartPageSubtotalFromDOM() {
  try {
    var activeDiscountTitle = localStorage.getItem("activeDiscountTitle");

    if (!/\/cart(\?|$|\/?$)/.test(window.location.pathname)) {
      return;
    }
    var row = document.querySelector("tr.cart-subtotal");
    if (!row) {
      return;
    }
    var amountWrap = row.querySelector(".price");
    if (!amountWrap) {
      return;
    }

    var userRemovedDiscount = false;
    try {
      if (typeof window.hasNoDiscountPreference === "function") {
        userRemovedDiscount = window.hasNoDiscountPreference();
      } else {
        console.error(
          "[DEBUG] window.hasNoDiscountPreference is not a function"
        );
        userRemovedDiscount =
          localStorage.getItem("activeDiscountTitle") === "__no_discount__";
      }
    } catch (e) {
      console.error("[DEBUG] Error calling hasNoDiscountPreference():", e);
      try {
        userRemovedDiscount =
          localStorage.getItem("activeDiscountTitle") === "__no_discount__";
      } catch (e2) {
        userRemovedDiscount = false;
      }
    }
    var del = amountWrap.querySelector("del");
    var ins = amountWrap.querySelector("ins");

    var dataOriginalTotal = row.getAttribute("data-original-total");
    var dataFinalTotal = row.getAttribute("data-final-total");

    if (userRemovedDiscount && (del || ins)) {
      var originalSubtotalCents = 0;
      var delAmount = del ? del.querySelector(".amount") : null;
      if (delAmount) {
        var originalSubtotalText = delAmount.textContent.trim();
        originalSubtotalCents =
          window.parseMoneyTextToCents(originalSubtotalText);
      } else if (dataOriginalTotal) {
        originalSubtotalCents = parseInt(dataOriginalTotal);
      } else {
        var cartRows = document.querySelectorAll('tr[id^="CartItem-"]');
        cartRows.forEach(function (cartRow) {
          try {
            var priceCell = cartRow.querySelector(".product-price");
            if (priceCell) {
              var priceSpan = priceCell.querySelector(".price");
              if (priceSpan) {
                var delPrice = priceSpan.querySelector("del .amount");
                var originalPriceText = delPrice
                  ? delPrice.textContent.trim()
                  : priceSpan.querySelector(".amount")
                  ? priceSpan.querySelector(".amount").textContent.trim()
                  : "";
                if (originalPriceText) {
                  var priceCents =
                    window.parseMoneyTextToCents(originalPriceText);
                  if (priceCents > 0) {
                    var qtyInput = cartRow.querySelector(
                      'input[name="updates[]"]'
                    );
                    var quantity = qtyInput
                      ? parseInt(qtyInput.value || "1")
                      : 1;
                    originalSubtotalCents += priceCents * quantity;
                  }
                }
              }
            }
          } catch (e) {}
        });
      }
      if (originalSubtotalCents > 0) {
        var fBase = window.formatMoneyDrawer(originalSubtotalCents);
        while (amountWrap.firstChild) {
          amountWrap.removeChild(amountWrap.firstChild);
        }
        var amountSpan = document.createElement("span");
        amountSpan.className = "amount";
        amountSpan.textContent = fBase;
        amountWrap.appendChild(amountSpan);
        row.setAttribute("data-original-total", String(originalSubtotalCents));
        row.setAttribute("data-final-total", String(originalSubtotalCents));
        setTimeout(function () {
          if (window.hasNoDiscountPreference()) {
            var recheckRow = document.querySelector("tr.cart-subtotal");
            if (recheckRow) {
              var recheckWrap = recheckRow.querySelector(".price");
              if (recheckWrap) {
                var recheckDel = recheckWrap.querySelector("del");
                var recheckIns = recheckWrap.querySelector("ins");
                if (recheckDel || recheckIns) {
                  var recheckDelAmount = recheckDel
                    ? recheckDel.querySelector(".amount")
                    : null;
                  var recheckOriginalCents = 0;
                  if (recheckDelAmount) {
                    var recheckText = recheckDelAmount.textContent.trim();
                    recheckOriginalCents =
                      window.parseMoneyTextToCents(recheckText);
                  } else {
                    var recheckData = recheckRow.getAttribute(
                      "data-original-total"
                    );
                    if (recheckData) {
                      recheckOriginalCents = parseInt(recheckData);
                    }
                  }
                  if (recheckOriginalCents > 0) {
                    var recheckFBase =
                      window.formatMoneyDrawer(recheckOriginalCents);
                    while (recheckWrap.firstChild) {
                      recheckWrap.removeChild(recheckWrap.firstChild);
                    }
                    var recheckAmountSpan = document.createElement("span");
                    recheckAmountSpan.className = "amount";
                    recheckAmountSpan.textContent = recheckFBase;
                    recheckWrap.appendChild(recheckAmountSpan);
                  }
                }
              }
            }
          }
        }, 200);
        return;
      } else {
        return;
      }
    }
    var userRemovedDiscountCheck = window.hasNoDiscountPreference();
    if (userRemovedDiscountCheck) {
      return;
    }
    var cartRows = document.querySelectorAll('tr[id^="CartItem-"]');
    var base = 0;
    var totalDiscount = 0;
    cartRows.forEach(function (cartRow) {
      try {
        var subtotalCell = cartRow.querySelector(".product-subtotal");
        if (!subtotalCell) return;
        var subtotalPriceSpan = subtotalCell.querySelector(".price");
        var dataSubtotal = subtotalCell.getAttribute("data-subtotal");
        var originalLinePrice = 0;
        var finalLinePrice = 0;
        if (dataSubtotal) {
          finalLinePrice = window.parseMoneyTextToCents(dataSubtotal);
        }
        if (subtotalPriceSpan) {
          var del = subtotalPriceSpan.querySelector(
            "del .amount, del span.amount"
          );
          var ins = subtotalPriceSpan.querySelector(
            "ins .amount, ins span.amount"
          );
          if (del) {
            var originalPriceText = del.textContent.trim();
            originalLinePrice = window.parseMoneyTextToCents(originalPriceText);
            if (originalLinePrice > 0) {
              base += originalLinePrice;
            }
          } else {
            var amountEl = subtotalPriceSpan.querySelector(".amount");
            if (amountEl) {
              var priceText = amountEl.textContent.trim();
              originalLinePrice = window.parseMoneyTextToCents(priceText);
              if (originalLinePrice > 0) {
                base += originalLinePrice;
              }
            }
          }
          if (ins) {
            var finalPriceText = ins.textContent.trim();
            finalLinePrice = window.parseMoneyTextToCents(finalPriceText);
          }
          if (
            originalLinePrice > 0 &&
            finalLinePrice > 0 &&
            originalLinePrice > finalLinePrice
          ) {
            var rowDiscount = originalLinePrice - finalLinePrice;
            if (rowDiscount > 0) {
              totalDiscount += rowDiscount;
            }
          }
        } else if (dataSubtotal) {
          var key = cartRow.getAttribute("data-product-id") || "";
          var match = key.match(/^(\d+)/);
          if (match) {
            var variantId = match[1];
            var discountData =
              typeof window.getVariantDiscountData === "function"
                ? window.getVariantDiscountData(variantId)
                : null;
            if (discountData && discountData.percentage) {
              var qtyInput = cartRow.querySelector('input[name="updates[]"]');
              var quantity = qtyInput ? parseInt(qtyInput.value || "1") : 1;
              var unitPriceCell = cartRow.querySelector(".product-price");
              var unitPriceSpan = unitPriceCell
                ? unitPriceCell.querySelector(".price .amount")
                : null;
              if (unitPriceSpan) {
                var unitPriceText = unitPriceSpan.textContent.trim();
                var unitPriceCents =
                  window.parseMoneyTextToCents(unitPriceText);
                if (unitPriceCents > 0) {
                  var lineOriginal = unitPriceCents * quantity;
                  base += lineOriginal;
                  var lineDiscount = Math.round(
                    lineOriginal * (discountData.percentage / 100)
                  );
                  totalDiscount += lineDiscount;
                }
              }
            } else {
              base += finalLinePrice;
            }
          } else {
            base += finalLinePrice;
          }
        }
      } catch (e) {
        console.error("[CART] Error processing cart row:", e);
      }
    });
    if (base === 0) {
      var origAttr = parseInt(row.getAttribute("data-original-total") || "0");
      if (origAttr && origAttr > 0) {
        base = origAttr;
      } else {
        var amountWrap = row.querySelector(".price .amount, .price");
        if (amountWrap) {
          var del = amountWrap.querySelector("del span, del");
          var ins = amountWrap.querySelector("ins span, ins");
          var txt = ins
            ? ins.textContent.trim()
            : del
            ? del.textContent.trim()
            : amountWrap.textContent.trim();
          base = window.parseMoneyTextToCents(txt);
        }
      }
    }
    if (!base) return;
    if (totalDiscount === 0) {
      var shopifyPillElements = document.querySelectorAll(
        ".discounts__discount:not(#applied-discount-cart-page)"
      );
      var useShopifyPills = shopifyPillElements.length > 0;
      var jsPills = document.querySelectorAll("#applied-discount-cart-page");
      if (useShopifyPills && jsPills.length > 0) {
        jsPills.forEach(function (jsPill) {
          jsPill.style.display = "none";
        });
      }
      var nodes = useShopifyPills
        ? Array.from(shopifyPillElements)
        : document.querySelectorAll(
            "#applied-discount-cart-page span:last-child"
          );
      nodes.forEach(function (node) {
        try {
          var t = node.textContent || "";

          var currencyCode = (window.shop_currency || "CHF").replace(
            /[.*+?^${}()|[\]\\]/g,
            "\\$&"
          );
          var m = t.match(
            new RegExp(
              "[\\-\\u2013]\\s*" + currencyCode + "\\s*([\\d'.,]+)",
              "i"
            )
          );
          if (m) {
            var cents = Math.round(
              parseFloat(m[1].replace(/[']/g, "").replace(/,/g, "")) * 100
            );
            if (cents > 0) {
              totalDiscount += cents;
            }
          }
        } catch (e) {}
      });
    }
    var finalCents = Math.max(0, base - totalDiscount);
    try {
      row.setAttribute("data-original-total", String(base));
      row.setAttribute("data-final-total", String(finalCents));
    } catch (e) {}
    var fBase = window.formatMoneyDrawer(base);
    var fFinal = window.formatMoneyDrawer(finalCents);
    var amountWrap = row.querySelector(".price");
    if (!amountWrap) {
      var td = row.querySelector("td:last-child");
      if (td) {
        amountWrap = document.createElement("span");
        amountWrap.className = "price";
        td.appendChild(amountWrap);
      }
    }
    if (amountWrap) {
      var newHtml =
        totalDiscount > 0
          ? '<del><span class="amount">' +
            fBase +
            '</span></del> <ins><span class="amount">' +
            fFinal +
            "</span></ins>"
          : '<span class="amount">' + fBase + "</span>";
      amountWrap.innerHTML = newHtml;
    }
  } catch (e) {}
}

function recomputeDrawerSubtotalFromDOM() {
  try {
    var row = document.getElementById("cart-drawer-subtotal");
    if (!row) {
      var rows = Array.prototype.slice.call(
        document.querySelectorAll(
          ".mini-cart__row.total, .mini-cart__row.mini-cart__total"
        )
      );
      rows = rows.filter(function (r) {
        return r && r.offsetParent !== null;
      });
      row = rows.length ? rows[rows.length - 1] : null;
    }
    if (!row) return;
    var amountWrap = row.querySelector(".amount");
    var drawerTotals = { original: 0, discounted: 0 };
    var cartItems = document.querySelectorAll(".mini_cart_item");
    cartItems.forEach(function (item) {
      try {
        var priceSpan = item.querySelector(".price");
        if (!priceSpan) return;
        var delAmt = priceSpan.querySelector("del .amount");
        var insAmt = priceSpan.querySelector("ins .amount");
        if (delAmt && insAmt) {
          var oTxt = delAmt.textContent.trim();
          var dTxt = insAmt.textContent.trim();
          var oCents = window.parseMoneyTextToCents(oTxt);
          var dCents = window.parseMoneyTextToCents(dTxt);
          if (oCents > 0 && dCents > 0) {
            var qTxt = (
              item.querySelector(".mini-quantity")?.textContent || "1"
            ).replace(/[^0-9]/g, "");
            var q = parseInt(qTxt || "1");
            drawerTotals.original += oCents * (isNaN(q) ? 1 : q);
            drawerTotals.discounted += dCents * (isNaN(q) ? 1 : q);
          }
        } else {
          var singleAmt = priceSpan.querySelector(".amount");
          if (singleAmt) {
            var sTxt = singleAmt.textContent.trim();
            var sCents = window.parseMoneyTextToCents(sTxt);
            if (sCents > 0) {
              var qTxt = (
                item.querySelector(".mini-quantity")?.textContent || "1"
              ).replace(/[^0-9]/g, "");
              var q = parseInt(qTxt || "1");
              var lineTotal = sCents * (isNaN(q) ? 1 : q);
              drawerTotals.original += lineTotal;
              drawerTotals.discounted += lineTotal;
            }
          }
        }
      } catch (e) {
        console.error("[DRAWER] Error calculating item total:", e);
      }
    });
    var baseSubtotal = drawerTotals.original;
    var finalSubtotal = drawerTotals.discounted;
    var totalDiscount = baseSubtotal - finalSubtotal;
    var cce =
      window.currencyCodeEnabled !== undefined
        ? window.currencyCodeEnabled
        : true;
    try {
      var fBase = window.formatMoneyDrawer(baseSubtotal);
      var fFinal = window.formatMoneyDrawer(finalSubtotal);
      try {
        if (!amountWrap) {
          amountWrap = row.querySelector(".amount");
        }
        if (!amountWrap) {
          amountWrap = document.createElement("span");
          amountWrap.className = "amount";
          row.appendChild(amountWrap);
        }
        var currentContent =
          amountWrap.innerHTML || amountWrap.textContent || "";
        var newContent =
          totalDiscount > 0
            ? "<del><span>" + fBase + "</span></del> <ins>" + fFinal + "</ins>"
            : fBase;
        if (currentContent !== newContent) {
          row.setAttribute("data-final-total", String(finalSubtotal));
          row.setAttribute("data-original-total", String(baseSubtotal));
          if (totalDiscount > 0) {
            amountWrap.innerHTML = newContent;
          } else {
            amountWrap.textContent = newContent;
          }
        }
      } catch (e) {}
    } catch (err) {}
  } catch (e) {}
}
